import React, { useState, useEffect, useRef, PureComponent } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import {
  useUpdateUserMutation,
  useDeleteUserMutation,
  useGetUsersQuery,
} from "./usersApiSlice";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentToken } from "../../features/auth/authSlice";
import {
  setTransformacijaData,
  selectTabTrigger,
  setTabTrigger,
} from "../transformacije/PokreniTransformaciju";
import {
  useGetAllCiljeviQuery,
  useGetAllSpecCiljeviQuery,
  useGetAllMotivacijeQuery,
} from "../ciljevi/ciljeviApiSlice";
import {
  useGetAllFizickeAktivnostiQuery,
  useGetAllDijagnozeQuery,
} from "../fizickaAktivnost/fizickaAktivnostApiSlice";
import { Radio, RadioGroup } from "@headlessui/react";
import { CheckCircleIcon, PaperClipIcon } from "@heroicons/react/20/solid";
import {
  TrashIcon,
  ArrowDownTrayIcon,
  EyeIcon,
  UserIcon,
  DocumentChartBarIcon,
} from "@heroicons/react/24/outline";
import { useGetAllNamirniceQuery } from "../Namirnice/namirniceApiSlice";
import { useGetAllIshraneQuery } from "../ishrana/ishranaApiSlice";
import Tooltip from "../../components/Tooltip";
import { PieChart, Pie, Cell } from "recharts";
// import GaugeChart from "react-gauge-chart";
import BMIChartJS from "./BMIChartJS";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.js",
  import.meta.url
).toString();

// Za weight loss
const mailingLists1 = [
  {
    id: 1,
    title: "Blago smanjenje",
    description: "Cilj: Postepeni gubitak težine, obično 0.25-0.5 kg nedeljno",
    ideal:
      "Idealno za: Osobe koje žele sporiji, održiviji gubitak težine ili koje imaju manju količinu kilograma za gubljenje",
    users: "Besplatno",
    procenat: 10,
  },
  {
    id: 2,
    title: "Umereno smanjenje",
    description: "Cilj: Umeren gubitak težine, obično 0.5-1 kg nedeljno",
    ideal:
      "Idealno za: Osobe koje teže bržem vidljivom gubitku težine u kratkom vremenskom okviru, dok istovremeno održavaju zdrav i održiv pristup.",
    users: "Plaćena verzija",
    procenat: 20,
  },
  {
    id: 3,
    title: "Agresivno smanjenje",
    description: "Cilj: Brži gubitak težine, obično 1-1.5 kg nedeljno",
    ideal:
      "Idealno za: Osobe sa većim viškom kilograma koje žele brže rezultate, ali je važno napomenuti da ovakvo smanjenje može biti teže za održavanje na duži rok",
    users: "Plaćena verzija",
    procenat: 30,
  },
  {
    id: 4,
    title: "Idealno za: Osobe sa jasno definisanim ciljem",
    description: "Cilj: Gubitak težine po vašoj meri",
    ideal: "Idealno za: Osobe sa jasno definisanim ciljem",
    users: "Plaćena verzija",
    procenat: 100,
  },
];

// Za weight gain
const mailingLists2 = [
  {
    id: 1,
    title: "Blago povećanje",
    description: "Cilj: Postepeno dobijanje težine, obično 0.25-0.5 kg mesečno",
    ideal:
      "Idealno za: Osobe koje žele održiv i sporiji dobitak mišićne mase ili za one koji tek počinju sa dobijanjem težine.",
    users: "Besplatno",
    procenat: 5,
  },
  {
    id: 2,
    title: "Umereno povećanje:",
    description: "Cilj: Umeren dobitak težine, obično 0.5-1 kg mesečno",
    ideal:
      "Idealno za: Osobe koje žele stabilan dobitak težine i mišićne mase, uz održavanje niske količine masti.",
    users: "Plaćena verzija",
    procenat: 15,
  },
  {
    id: 3,
    title: "Agresivno povećanje:",
    description: "Cilj: Brži dobitak težine, obično 1-1.5 kg mesečno",
    ideal:
      "Idealno za: Osobe sa većim ciljevima za dobitak težine, kao što su bodibilderi ili oni koji žele brzo povećanje telesne mase.",
    users: "Plaćena verzija",
    procenat: 25,
  },
  {
    id: 4,
    title: "Tvoje povećanje",
    description: "Cilj: Dobitak težine po vašoj meri",
    ideal: "Idealno za: Osobe sa jasno definisanim ciljem",
    users: "Plaćena verzija",
    procenat: 100,
  },
];

// import Bmi from "../kalkulacije/Bmi";

const EditUserForm = ({ user }) => {
  //console.log("user", user);
  // console.log("ID", id);
  const navigate = useNavigate();

  const { id } = useAuth();
  const token = useSelector(selectCurrentToken);
  const [name, setName] = useState(user?.name);
  const [lastname, setLastName] = useState(user?.lastName);
  const [mail, setMail] = useState(user?.mail);
  const [tezina, setTezina] = useState(user?.tezina);
  const [visina, setVisina] = useState(user?.visina);
  const [password, setPassword] = useState("");
  const [primcilj, setPrimcilj] = useState(user?.primcilj);
  const [specilj, setSpecilj] = useState(""); //motiv
  const [motiv, setMotiv] = useState(user?.motiv || "");
  const [datumRodjenja, setDatumRodjenja] = useState(user?.datumRodjenja);
  const [pol, setPol] = useState(user?.pol);
  const [roles, setRoles] = useState(user?.roles);
  const [telefon, setTelefon] = useState(user?.telefon);
  let [bmi, setBmi] = useState(parseInt(user?.bmi));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenIzmena, setIsModalOpenIzmena] = useState(false);
  const [hasIzmena, setHasIzmena] = useState();
  const [loading, setLoading] = useState(false); //Loading za dugme
  // const [selectedMonth, setSelectedMonth] = useState(1);
  // const [brKilaDaSmrsa, setBrKilaDaSmrsa] = useState('');
  // const [kilazaIspisana, setKilazaIspisana] = useState(0);
  let [activityLevel, setActivityLevel] = useState(user?.nivoAkt); //Postavi da bude sedentan kada se prvi put uloguje
  const [vrstAkt, setVrstAkt] = useState(""); //Ne koristi se

  const [selectedActivities, setSelectedActivities] = useState(
    user?.vrstaFiz || []
  ); //Ovo je ustvari lista aktivnosti
  const [dropdownOpenFizAkt, setDropdownOpenFizAkt] = useState(false);

  const [specCiljevi, setSpecCiljevi] = useState(); // Za sve specificne ciljeve  komentarCilja
  const [specCilj_naziv, setSpecCilj_naziv] = useState();

  const [selectedDefTip, setSelectedDefTip] = useState(user?.selectedDefTip);
  const [filteredSpecCiljevi, setFilteredSpecCiljevi] = useState([]);
  const [selectedSpecCiljevi, setSelectedSpecCiljevi] = useState(user?.specilj); //Ovaj mozda
  const [selectedSpecCiljeviNazivi, setSelectedSpecCiljeviNazivi] = useState(
    []
  );
  const [groupedData, setGroupedData] = useState();

  const [bloodType, setBloodType] = useState(user?.krvGru);
  // const [dijagnoza, setDijagnoza] = useState(user?.dijagnoza);
  const [alergije, setAlergije] = useState(user?.alergije);
  const [imunitet, setImunitet] = useState(user?.imunitet);
  const [ucestObr, setUcestObr] = useState(user?.ucestBr);
  const [navike, setNavike] = useState(user?.navikeUish);
  const [iskSaDijetama, setIskSaDijetama] = useState(user?.iskSaDijetama);
  const [ukupnaKalVred, setUkupnaKalVred] = useState(user?.ukupnaKalVred);
  const [wellcome, setWellcome] = useState(user?.wellcome);
  const [isVerified, setIsVerified] = useState(user?.isVerified);

  //Nema
  const [komentarCilja, setKomentarCilja] = useState(user?.komCilja);

  const [alkohol, setAlkohol] = useState(user?.alk);
  const [vrstaAlkohola, setVrstaAlkohola] = useState(user?.vrstaAlkohola);
  const [kolicina, setKolicina] = useState(user?.kolicina); //Na alkohol se misli

  const [bmrValue, setBmrValuer] = useState(user?.bmrValue);

  const [smoking, setSmoking] = useState(user?.pus); //Na cigarete se misli
  const [kolicinaCigara, setKolicinaCigara] = useState(user?.kolicinaCigara);
  const [voljeneNamirnice, setVoljeneNamirnice] = useState(
    user?.voljeneNamirnice
  );
  const [neVoljeneNamirnice, setNeVoljeneNamirnice] = useState(
    user?.neVoljeneNamirnice
  );
  const [algNaHran, setAlgNaHran] = useState("");
  const [algiNaHran, setAlgiNaHran] = useState(false);
  const [selectedAllergens, setSelectedAllergens] = useState({});
  const [isAllergic, setIsAllergic] = useState(
    user?.allergyChoice === "yes" ? true : false
  );
  const [modalOpenSelected, setModalOpenSelected] = useState(false); // Modal za prikaz odabranih namirnica
  const [isModalOpenIntol, setIsModalOpenIntol] = useState(false);
  const [prehranIntol, setPrehranIntol] = useState(false);
  const [modalOpenAlr, setModalOpenAlr] = useState(false);
  const [allergyChoice, setAllergyChoice] = useState(user?.allergyChoice); //Da li je alergican na neku naminicu

  const [checkedItemsNamirnice, setCheckedItemsNamirnice] = useState({});

  // const [postImage, setPostImage] = useState({ myFile: "" });
  const [imageUrl, setImageUrl] = useState(""); //New

  const handleToggleFizAkt = () => setDropdownOpenFizAkt(!dropdownOpenFizAkt);

  const dropdownRef = useRef(null);

  const dispatch = useDispatch();

  let [tdee, setTdee] = useState(user?.tdee);

  const [aktivan, setAktivan] = useState(null); //Za jedan aktivan

  //Za menjanje divova na klik
  const [selectedDiv, setSelectedDiv] = useState("Dashboard");
  const handleButtonClick = (divName) => {
    setSelectedDiv((prev) => (prev === divName ? "" : divName));
  };

  // const [tez, stez] = useState(); //Sample

  //Za highlighting
  let [highlighted, setHighlighted] = useState(user?.wellcomePanel); //bilo je false
  // Toggle za highlight
  const toggleHighlight = () => setHighlighted((prev) => !prev);

  const getPakete = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/get-pakete/${id}`
      );
      const result = await response.json();
      setAktivan(result.data);
    } catch (error) {
      console.error("Greška prilikom učitavanja paketa:", error);
    }
  };

  //Ako nece da ucita activityLevel
  useEffect(() => {
    setTdee(user?.tdee);
    getPakete();
    setSelectedIshrana(user?.selectedIshrana);
  }, []);

  useEffect(() => {
    if (allergyChoice === "no") {
      setSelectedAllergens({});
      saveDataToDatabase();
    }
  }, [allergyChoice]);

  // useEffect(() => {
  //   setTdee("Act lvll: ", activityLevel);
  // }, [activityLevel]);

  const [disabledNamirnice, setDisabledNamirnice] = useState([]);

  // First set of radio buttons state
  const [selectedMailingLists1, setSelectedMailingLists1] = useState(
    mailingLists1[0]
  );

  const [areButtonsEnabled1, setAreButtonsEnabled1] = useState(true); //
  // const [areButtonsEnabledZaOsnovni, setAreButtonsEnabledZaOsnovni] =
  //   useState(true); //
  // const [areButtonsEnabledZaNapredni, setAreButtonsEnabledZaNapredni] =
  //   useState(true); //

  const [enabledButtonsCount1, setEnabledButtonsCount1] = useState(1);
  const [enabledButtonsCount2, setEnabledButtonsCount2] = useState(1);

  const [baseValue1, setBaseValue1] = useState(); // Example base value for first group
  const [calculatedValue1, setCalculatedValue1] = useState(0); //Vrednost kalorija za mrsavljenje kad izabere POSTAVI KAD SALJES U PROMPT VREDNOST DA BUDE toFixed.(2) ???

  // useEffect(() => {
  //   if (selectedMailingLists1) {
  //     const procenat = selectedMailingLists1.procenat || 0; // Uzmi procenat ili 0 ako nije definisan
  //     const newValue = baseValue1 - (procenat / 100) * baseValue1; // Izračunaj novu vrednost
  //     setCalculatedValue1(newValue); // Postavi novu izračunatu vrednost
  //   }
  // }, [selectedMailingLists1, baseValue1]);

  // Second set of radio buttons state
  const [selectedMailingLists2, setSelectedMailingLists2] = useState(
    mailingLists2[0]
  );
  const [areButtonsEnabled2, setAreButtonsEnabled2] = useState(true); //Triger kada plati dobija ostala 2 radio buttona
  const [baseValue2, setBaseValue2] = useState(); // Example base value for second group
  const [calculatedValue2, setCalculatedValue2] = useState(0); //Vrednost kalorija za gojenje kad izabere POSTAVI KAD SALJES U PROMPT VREDNOST DA BUDE toFixed.(2) ???

  // useEffect(() => {
  //   if (selectedMailingLists2) {
  //     const procenat = selectedMailingLists2.procenat || 0;
  //     const newValue = baseValue2 + (procenat / 100) * baseValue2;
  //     setCalculatedValue2(newValue);
  //   }
  // }, [selectedMailingLists2, baseValue2]);

  //Pdf
  const [title, setTitle] = useState("");
  const [file, setFile] = useState("");
  const [allImage, setAllImage] = useState(null);
  const [allImageTwo, setAllImageTwo] = useState([]);
  const [defaultPDF, setDefaultPDF] = useState([]);
  const [pdfFile, setPdfFile] = useState(null);
  const [isModalOpenPdf, setIsModalOpenPdf] = useState(false); //Modal u seckiji svih
  const [isModalOpenPdfTwo, setIsModalOpenPdfTwo] = useState(false); //Modal u sekciji dashboard za 2 poslednja
  const [numPages, setNumPages] = useState(null); // Track number of pages

  useEffect(() => {
    getPdf();
    getdefaultPdf();
  }, []);

  //Google
  // useEffect(() => {
  //   const fetchUser = async () => {
  //     try {
  //       const response = await fetch("http://localhost:5000/auth/user", {
  //         credentials: "include",
  //       });
  //       if (response.ok) {
  //         const userData = await response.json();
  //         // setUser(userData); //!!!
  //         console.log("userData => ", userData);
  //       } else {
  //         console.error("Korisnik nije prijavljen");
  //       }
  //     } catch (err) {
  //       console.error("Greška:", err);
  //     }
  //   };

  //   fetchUser();
  // }, []);

  //Uzimamo sve pdf-ove za starnicu moje ishrane
  const getPdf = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/get-files/${id}`
      );
      const result = await response.json();
      setAllImage(result.data);
    } catch (error) {
      console.error("Greška prilikom učitavanja PDF datoteka:", error);
    }
  };

  //Uzimamo samo poslendja dva pdf-ova za starnicu dashboard
  const getPdftwo = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/get-files/two/${id}`
      );
      const result = await response.json();
      setAllImageTwo(result.data);
    } catch (error) {
      console.error("Greška prilikom učitavanja dve PDF datoteke:", error);
    }
  };

  //work here
  const getdefaultPdf = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/get-defaultPDF`
      );
      const result = await response.json();
      setDefaultPDF([result.data]);
    } catch (error) {
      console.error("Greška prilikom učitavanja default PDF datoteke:", error);
    }
  };

  // useEffect(() => {
  //   setTdee(user?.tdee)
  // }, [tezina,visina,pol,]);

  const saveDataToDatabase = async () => {
    const danasnjiDatum = new Date();
    const rodjendan = new Date(datumRodjenja);

    let age = danasnjiDatum.getFullYear() - rodjendan.getFullYear();

    if (
      danasnjiDatum.getMonth() < rodjendan.getMonth() ||
      (danasnjiDatum.getMonth() === rodjendan.getMonth() &&
        danasnjiDatum.getDate() < rodjendan.getDate())
    ) {
      age--;
    }

    // console.log("Izabran datum => ", datumRodjenja);

    // let specCilj_naziv = "";
    const naminice_naziviDa = availableNamirnice
      .filter((obj) => odabraneNamirnice?.includes(obj._id))
      .map((obj) => obj.naziv); //Izabrane naminice
    const naminice_nazivi = availableNamirnice
      .filter((obj) => odabraneNamirnice?.includes(obj._id))
      .map((obj) => obj.naziv); //Ne izabrane naminice
    // const naminice_voljene_nazivi = availableNamirnice.filter(obj => odabraneNamirnice?.includes(obj._id)).map(obj => obj.naziv);

    const nazivi = selectedSpecCiljevi
      ?.map((ciljId) => {
        const cilj = specCiljevi?.find((c) => c._id === ciljId);
        return cilj ? cilj.naziv : null;
      })
      .filter((naziv) => naziv !== null);

    setSelectedSpecCiljeviNazivi(nazivi);

    // let bmr =

    try {
      const dataToSave = {
        id: user.id,
        mail,
        name,
        lastname,
        datumRodjenja,
        telefon,
        pol,
        visina,
        tezina,
        struka,
        kukova,
        vrat,
        bloodType,
        tdee,
        primcilj,
        ukupnaKalVred,
        // motiv: getMotivData?.entities[motiv]?.naziv,
        motiv,
        imunitet,
        komentarCilja,
        alergije,
        // specilj: selectedSpecCiljeviNazivi,
        godine: age,
        // dijagnoza: dijagnoza === '' ? 'Ne' : dijagnoza,
        ucestBr: ucestObr,
        navikeUish: navike,
        // namirnice: naminice_nazivi, // ZA ONE KOJE NE ULAZE U SKUP ISHRANE
        // namirniceDa: naminice_naziviDa, // ZA ONE KOJE ULAZE U SKUP ISHRANE
        selectedIshranaNaziv,
        voljeneNamirnice,
        neVoljeneNamirnice,
        bmi,
        nivoAkt: activityLevel,
        vrstaFiz: selectedActivities,
        struk: struka === "" ? "Nema" : struka,
        kuk: kukova === "" ? "Nema" : kukova,
        vrat: vrat === "" ? "Nema" : vrat,
        krv: bloodType === "" ? "Nema" : bloodType,
        alerg: alergije === "" ? "Nema" : alergije,
        pus: smoking,
        alk: alkohol,
        bmrValue,
        iskSaDijetama,
        intolerancija: selectedAllergies,
        kolicina,
        vrstaAlkohola,
        kolicinaCigara,
        // selectedDefTip //Specificni tip IME,
        allergyChoice,
        allergiesEnabled,
        highlighted, //Flag za stanje da li da izlece onaj zasivljen ekran
      };

      // Prepare the base URL and fetch options
      const baseUrl = `${process.env.REACT_APP_API_URL}`;

      const headers = new Headers();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");

      const response = await fetch(`${baseUrl}/users`, {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(dataToSave),
        credentials: "include", // Include cookies with the request
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      // console.log('Data successfully saved:', result);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  //Kada se trigeruje select za promenu ishrane onda se salje zahtev za cuvanje ishrane i naminice
  const saveDataToDatabaseNaminice = async (odab, odabIshNaziv, selIsh) => {
    const age =
      new Date().getFullYear() -
      new Date(datumRodjenja).getFullYear() -
      (new Date() < new Date(new Date().getFullYear(), 4, 2) ? 1 : 0); //Iz datuma u godine

    // let specCilj_naziv = "";
    const naminice_naziviDa = availableNamirnice
      .filter((obj) => odab?.includes(obj._id))
      .map((obj) => obj._id); //Izabrane naminice
    const naminice_nazivi = availableNamirnice
      .filter((obj) => !odab?.includes(obj._id))
      .map((obj) => obj._id); //Ne izabrane naminice
    // const naminice_voljene_nazivi = availableNamirnice.filter(obj => odabraneNamirnice?.includes(obj._id)).map(obj => obj.naziv);

    // console.log('naminice_naziviDa => ', naminice_naziviDa)  //
    // console.log('naminice_nazivi => ', naminice_nazivi)

    const nazivi = selectedSpecCiljevi
      .map((ciljId) => {
        const cilj = specCiljevi?.find((c) => c._id === ciljId);
        return cilj ? cilj.naziv : null;
      })
      .filter((naziv) => naziv !== null);

    setSelectedSpecCiljeviNazivi(nazivi);

    try {
      const dataToSave = {
        id: user.id,
        namirnice: naminice_nazivi, // ZA ONE KOJE NE ULAZE U SKUP ISHRANE (lista id-ijeva)
        namirniceDa: naminice_naziviDa, // ZA ONE KOJE ULAZE U SKUP ISHRANE (lista id-ijeva)
        selectedIshranaNaziv: odabIshNaziv,
        selectedIshrana: selIsh,
      };

      const baseUrl = `${process.env.REACT_APP_API_URL}`;

      const headers = new Headers();
      // if (token) {
      //   headers.set("Authorization", `Bearer ${token}`);
      // }
      headers.set("Content-Type", "application/json");

      const response = await fetch(`${baseUrl}/updateNaminice`, {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(dataToSave),
        // credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      // console.log('Data successfully saved:', result);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  //Kada se trigeruje select za promenu ishrane onda se salje zahtev za cuvanje ishrane i naminice
  const saveDataToDatabaseNaminiceNov = async (odab, odabIshNaziv, selIsh) => {
    const age =
      new Date().getFullYear() -
      new Date(datumRodjenja).getFullYear() -
      (new Date() < new Date(new Date().getFullYear(), 4, 2) ? 1 : 0);

    // let specCilj_naziv = "";
    const naminice_naziviDa = availableNamirnice
      .filter((obj) => odab?.includes(obj))
      .map((obj) => obj._id); //Izabrane naminice
    const naminice_nazivi = availableNamirnice
      .filter((obj) => !odab?.includes(obj))
      .map((obj) => obj._id); //Ne izabrane naminice
    // const naminice_voljene_nazivi = availableNamirnice.filter(obj => odabraneNamirnice?.includes(obj._id)).map(obj => obj.naziv);

    // console.log('naminice_naziviDa => ', naminice_naziviDa)  //
    // console.log('naminice_nazivi => ', naminice_nazivi)

    const nazivi = selectedSpecCiljevi
      .map((ciljId) => {
        const cilj = specCiljevi?.find((c) => c._id === ciljId);
        return cilj ? cilj.naziv : null;
      })
      .filter((naziv) => naziv !== null);

    setSelectedSpecCiljeviNazivi(nazivi);

    try {
      const dataToSave = {
        id: user.id,
        namirnice: naminice_nazivi, // ZA ONE KOJE NE ULAZE U SKUP ISHRANE
        namirniceDa: naminice_naziviDa, // ZA ONE KOJE ULAZE U SKUP ISHRANE
        selectedIshranaNaziv: odabIshNaziv,
        selectedIshrana: selIsh,
      };

      // Prepare the base URL and fetch options
      const baseUrl = `${process.env.REACT_APP_API_URL}`;

      const headers = new Headers();
      // if (token) {
      //   headers.set("Authorization", `Bearer ${token}`);
      // }
      headers.set("Content-Type", "application/json");

      const response = await fetch(`${baseUrl}/updateNaminice`, {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(dataToSave),
        // credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      // console.log('Data successfully saved:', result);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  const saveDataToDatabaseDefaultDataNov = async () => {
    try {
      const dataToSave = {
        id: user.id,
        primcilj: "Mršavljenje",
        activityLevel: "1.2",
      };

      // Prepare the base URL and fetch options
      const baseUrl = `${process.env.REACT_APP_API_URL}`;

      const headers = new Headers();
      // if (token) {
      //   headers.set("Authorization", `Bearer ${token}`);
      // }
      headers.set("Content-Type", "application/json");

      const response = await fetch(`${baseUrl}/updateDefaultData`, {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(dataToSave),
        // credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      // console.log('Data successfully saved:', result);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  //Za upload slike
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  const [isLoadingImg, setIsLoadingImg] = useState(true);

  // const fetchImage = async () => {
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}/profilePic/${id}`,
  //       {
  //         method: "GET",
  //         headers: headers,
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(`Error fetching image: ${response.statusText}`);
  //     }

  //     const data = await response.json();
  //     // console.log("Fetched Data:", data);

  //     const fileData = data?.file;
  //     if (fileData) {
  //       // console.log("File Data:", fileData);
  //       setPostImage({ myFile: fileData });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching the image:", error);
  //   } finally {
  //     setIsLoadingImg(false);
  //   }
  // };

  // Upload a new profile picture
  // const uploadImage = async (newImage) => {
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}/profilePic/${id}`,
  //       {
  //         method: "POST",
  //         headers: headers,
  //         body: JSON.stringify(newImage),
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(`Error uploading image: ${response.statusText}`);
  //     }

  //     // console.log("File uploaded successfully");
  //     setPostImage(newImage);
  //   } catch (error) {
  //     console.error("Error uploading the file:", error);
  //   }
  // };

  // Handle file upload - STARI NACIN
  // const handleFileUpload = async (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const base64 = await convertToBase64(file);
  //     const newImage = { myFile: base64 };
  //     setPostImage(newImage); // Update the state for immediate feedback
  //     uploadImage(newImage); // Automatically upload the file
  //   }
  // };

  //NOVI NACIN UPLOADA
  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/${id}/upload`,
        {
          method: "POST",
          body: formData,
        }
      );
      // const response = await fetch(
      //   `http://localhost:5000/api/users/${id}/upload`,
      //   {
      //     method: "POST",
      //     body: formData,
      //   }
      // );
      const data = await response.json();
      setImageUrl(`${process.env.REACT_APP_API_URL}${data.imageUrl}`);
      // setImageUrl(`http://localhost:5000${data.imageUrl}`);
      //ZMANENI URL
      // alert("Profilna slika uspešno postavljena!");
      // window.location.reload();
    } catch (error) {
      console.error("Greška pri uploadu slike", error);
    }
  };

  // Fetch the image on component mount
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/users/${id}`
        );
        // const response = await fetch(`http://localhost:5000/api/users/${id}`);
        const data = await response.json();
        // console.log("data: ", data.imageUrl);
        setImageUrl(`${process.env.REACT_APP_API_URL}${data}`);
        // setImageUrl(`http://localhost:5000${data.imageUrl}`);
      } catch (error) {
        console.error("Greška pri dohvatu profilne slike", error);
      }
    };

    fetchUserData();
  }, [id, imageUrl]);

  // work here 1
  // useEffect(() => {
  //   console.log("imageUrl =>", imageUrl);
  // }, [imageUrl]);

  //Naknadno izracunavanje TDEE-a work here
  // useEffect(() => {
  //   const age =
  //     new Date().getFullYear() -
  //     new Date(datumRodjenja).getFullYear() -
  //     (new Date() < new Date(new Date().getFullYear(), 4, 2) ? 1 : 0);

  //   let bmr = 0;
  //   if (pol === "muski") {
  //     bmr = 88.36 + 13.4 * tezina + 4.8 * visina - 5.7 * age;
  //     setBmrValuer(bmr);
  //   } else {
  //     bmr = 447.6 + 9.2 * tezina + 3.1 * visina - 4.3 * age;
  //     setBmrValuer(bmr);
  //   }

  //   // Izračunavanje TDEE-a
  //   const tdeeResult = bmr * activityLevel;
  //   setTdee(tdeeResult);
  //   console.log("Izracunava nesto => ", tdeeResult);
  // }, [activityLevel, datumRodjenja, tezina, visina, primcilj]);

  //
  useEffect(() => {
    const age =
      new Date().getFullYear() -
      new Date(datumRodjenja).getFullYear() -
      (new Date() < new Date(new Date().getFullYear(), 4, 2) ? 1 : 0);

    let bmr = 0;
    if (pol === "muski") {
      bmr = 88.36 + 13.4 * tezina + 4.8 * visina - 5.7 * age;
      setBmrValuer(bmr);
    } else {
      bmr = 447.6 + 9.2 * tezina + 3.1 * visina - 4.3 * age;
      setBmrValuer(bmr);
    }

    // TDEE formula
    const tdeeValue = bmr * parseFloat(activityLevel);

    if (primcilj === "Mršavljenje") {
      if (selectedMailingLists1) {
        //Ovde menjaj da li je blago mrsavljenje itd...
        const procenat = selectedMailingLists1.procenat || 0; // Use default if not defined
        const newValue = tdeeValue - (procenat / 100) * tdeeValue;
        setUkupnaKalVred(newValue);
        setTdee(tdeeValue);
      }
    } else if (primcilj === "Povećanje kilaže") {
      if (selectedMailingLists2) {
        //Ovde menjaj da li je blago gojenje itd...
        const procenat = selectedMailingLists2.procenat || 0;
        const newValue = tdeeValue + (procenat / 100) * tdeeValue;
        setUkupnaKalVred(newValue);
        setTdee(tdeeValue);
      }
    } else {
      setUkupnaKalVred(tdeeValue);
      setTdee(tdeeValue);
    }
    // console.log("Izracunava nesto 1 => ", tdeeValue);
  }, [
    tezina,
    visina,
    datumRodjenja,
    pol,
    activityLevel,
    primcilj,
    selectedMailingLists1,
    selectedMailingLists2,
  ]);

  // const submitImage = async (e) => {
  //   e.preventDefault();
  //   const formData = new FormData();
  //   formData.append("title", title);
  //   formData.append("file", file);

  //   try {
  //     const response = await fetch("https://nutritrans.rs:5000/upload-files", {
  //       method: "POST",
  //       body: formData,
  //     });

  //     const result = await response.json();
  //     if (result.status === "ok") {
  //       alert("Uspešno otpremljeno!");
  //       getPdf(); // Refresh the list of files
  //     }
  //   } catch (error) {
  //     console.error("Greška prilikom otpremanja:", error);
  //   }
  // };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages); // Store the total number of pages
  };

  //Za sekciju svi pdf-ovi  https://nutritrans.rs/files/Nutricionisticki_Izvestaj_06-01-2025_Mr%C5%A1avljenje.pdf
  //                        https://nutritrans.rs/files/Nutricionisticki_Izvestaj_20-11-2024_Povećanje_kilaže.pdf
  const showPdf = (pdf) => {
    // setPdfFile(`${process.env.REACT_APP_API_URL}/files/${pdf}`); //Za localhost
    // setPdfFile(`https://nutritrans.rs/files/${pdf}`);
    const pdfUrl = `${process.env.REACT_APP_API_URL}/files/${pdf}`;
    window.open(pdfUrl, "_blank");
    // console.log(
    //   "SHOW PDF => ",
    //   `${process.env.REACT_APP_API_URL}/files/${pdf}`
    // );
    // setIsModalOpenPdf(true); // Open modal
  };

  //Za sekciju svi pdf-ovi
  const closeModalPdf = () => {
    setIsModalOpenPdf(false); // Close modal
  };

  //Za dashboard 2 pdf-a
  const showPdfTwo = (pdf) => {
    // setPdfFile(`${process.env.REACT_APP_API_URL}/files/${pdf}`); //Za localhost
    // setPdfFile(`https://nutritrans.rs/files/${pdf}`);
    // setIsModalOpenPdfTwo(true); // Open modal
    const pdfUrl = `${process.env.REACT_APP_API_URL}/files/${pdf}`;
    window.open(pdfUrl, "_blank");
  };

  //Za dashboard 2 pdf-a
  const closeModalPdfTwo = () => {
    setIsModalOpenPdfTwo(false); // Close modal
  };

  const downloadPdf = async (pdf) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/files/${pdf}`
    );
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", pdf);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const deletePdf = async (id, pdf) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/delete-file/${id}`,
        {
          method: "DELETE",
        }
      );
      const result = await response.json();
      if (result.status === "ok") {
        alert(`${pdf} je obrisan!`);
        getPdf(); // Refresh the list after deletion
      } else {
        alert("Neuspešno brisanje.");
      }
    } catch (error) {
      console.error("Greška prilikom brisanja PDF-a:", error);
    }
  };

  //TDEE - IZRACUNAVANJE I DODAVANJE - PRI UCITAVANJU!
  // useEffect(() => {
  //   const age = new Date().getFullYear() - new Date(datumRodjenja).getFullYear() - (new Date() < new Date(new Date().getFullYear(), 4, 2) ? 1 : 0);

  //   if (pol === 'muski') {
  //     setBmrValuer(88.36 + (13.4 * tezina) + (4.8 * visina) - (5.7 * age));
  //   } else {
  //     setBmrValuer(447.6 + (9.2 * tezina) + (3.1 * visina) - (4.3 * age));
  //   }

  //   // TDEE formula
  //   const tdeeValue = bmrValue * parseFloat(activityLevel);
  //   setTdee(tdeeValue.toFixed(2));
  //   // console.log('tdeeValueN:', tdeeValue)
  //   setBaseValue1(tdeeValue);
  //   setBaseValue2(tdeeValue);
  //
  //   setActivityLevel(user?.actlvl);
  //   // console.log('Lvl act: ', user?.actlvl)
  // }, []);

  //Za ishrane select i tabelu
  const [ishrane, setIshrane] = useState([]); //
  const [availableNamirnice, setAvailableNamirnice] = useState([]); //Su bas sve naminice
  const [grupisaneNamirnice, setGrupisaneNamirnice] = useState({}); //Za strukturu
  const [odabraneNamirnice, setOdabraneNamirnice] = useState([]); // Sada čuva imena namirnica
  const [selectedIshrana, setSelectedIshrana] = useState(user?.selectedIshrana); // Defaultno prazan string
  const [selectedIshranaNaziv, setSelectedIshranaNaziv] = useState("");

  const {
    isSuccess: isSuccessGetNamir,
    isError: isErrorGetNamir,
    error: getNamirError,
    data: getNamirData,
  } = useGetAllNamirniceQuery();
  const {
    isSuccess: isSuccessGetIsh,
    isError: isErrorGetIsh,
    error: getIshError,
    data: getIshData,
  } = useGetAllIshraneQuery();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpenFizAkt(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleCheckboxChangeFizAktDrop = (aktivnost) => {
    if (selectedActivities.includes(aktivnost.naziv)) {
      setSelectedActivities(
        selectedActivities.filter((item) => item !== aktivnost.naziv)
      );
    } else {
      setSelectedActivities([...selectedActivities, aktivnost.naziv]);
    }
  };

  //Bmi grafik
  //const RADIAN = Math.PI / 180;

  // Definisanje novih kategorija BMI sa ažuriranim vrednostima
  // const categories = [
  //   { name: "Ispod težine (Podhranjenost)", value: 1, color: "#1E90FF" }, // BMI < 16
  //   { name: "Normalna težina", value: 1, color: "#32CD32" }, // BMI 16 – 17
  //   { name: "Prekomerna težina", value: 1, color: "#F8E152" }, // BMI 17 – 18.5
  //   { name: "Gojaznost, Klasa I", value: 1, color: "#FFA500" }, // BMI 18.5 – 25
  //   { name: "Gojaznost, Klasa II", value: 1, color: "#FF4500" }, // BMI 25 – 30
  //   { name: "Gojaznost, Klasa III", value: 1, color: "#A659F5" }, // BMI ≥ 30
  // ];

  // Funkcija za izračunavanje BMI (visina u centimetrima)
  // const calculateBMI = (weight, heightCm) => {
  //   const heightM = heightCm / 100; // Pretvaranje visine u metre
  //   return weight / (heightM * heightM); // BMI formula
  // };

  // const cx = 140; //Visina containera gouga
  // const cy = 120;
  // const iR = 80; //Unutrasnji radius (inner)
  // const oR = 110;
  // const heightCm = visina; // Visina u centimetrima (npr. 175 cm)
  // const weight = tezina; // Težina u kilogramima

  // const bmiValue = calculateBMI(weight, heightCm); // Računanje BMI na osnovu težine i visine

  // const needle = (bmiValue, categories, cx, cy, iR, oR, color) => {
  //   let total = 0;
  //   categories.forEach((v) => {
  //     total += v.value;
  //   });

  //   // Izračunavanje ugla igle na osnovu BMI vrednosti
  //   let angle = 0;
  //   // if (bmiValue < 16) angle = 180 * (1 - bmiValue / 16);
  //   // else if (bmiValue < 17) angle = 180 * (1 - (bmiValue - 16) / (17 - 16));
  //   // else if (bmiValue < 18.5) angle = 180 * (1 - (bmiValue - 17) / (18.5 - 17));
  //   // else if (bmiValue < 25) angle = 180 * (1 - (bmiValue - 18.5) / (25 - 18.5));
  //   // else if (bmiValue < 30) angle = 180 * (1 - (bmiValue - 25) / (30 - 25));
  //   // else angle = 180 * (1 - (bmiValue - 30) / 50);

  //   //Veljkovi proracuni
  //   if (bmiValue < 18.5) angle = 180 * (1 - bmiValue / 18.5);
  //   else if (bmiValue < 25) angle = 180 * (1 - (bmiValue - 18.5) / (25 - 18.5));
  //   else if (bmiValue < 30) angle = 180 * (1 - (bmiValue - 25) / (30 - 25));
  //   else if (bmiValue < 35) angle = 180 * (1 - (bmiValue - 30) / (35 - 30));
  //   else if (bmiValue < 40) angle = 180 * (1 - (bmiValue - 35) / (40 - 35));
  //   else angle = 180 * (1 - (bmiValue - 40) / 50); // Max BMI up to 50 for representation

  //   const length = (iR + 2 * oR) / 3;
  //   const sin = Math.sin(-RADIAN * angle);
  //   const cos = Math.cos(-RADIAN * angle);
  //   const r = 5;
  //   const x0 = cx + 5;
  //   const y0 = cy + 5;
  //   const xba = x0 + r * sin;
  //   const yba = y0 - r * cos;
  //   const xbb = x0 - r * sin;
  //   const ybb = y0 + r * cos;
  //   const xp = x0 + length * cos;
  //   const yp = y0 + length * sin;

  //   return [
  //     <circle cx={x0} cy={y0} r={r} fill={color} stroke="none" />,
  //     <path
  //       d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`}
  //       stroke="#none"
  //       fill={color}
  //     />,
  //   ];
  // };

  // ZA NAMIRNICE
  // const handleCheckboxChangeNamirnice = (name) => {
  //   setCheckedItemsNamirnice((prev) => ({
  //     ...prev,
  //     [name]: !prev[name],
  //   }));
  // };

  // const allergens = [
  //   "Celer", "Soja", "Badem", "Orah", "Lešnik", "Indijski orah", "Kikiriki", "Susam",
  //   "Pšenica", "Ječam", "Ovas", "Raž", "Kravlje", "Kozije", "Sojno", "Bademovo (alternativna mleka)",
  //   "Šaran", "Som", "Pastrmka", "Smudj", "Deverika", "Kečiga", "Štuka", "Losos", "Tuna", "Bakalar",
  //   "Lignje", "Skuša", "Škampi", "Pileća"
  // ];

  const allergens = [
    { id: "671f6daf5997900563ceaae0", name: "Celer" },
    { id: "671f80aa5997900563ceac9d", name: "Soja" },
    { id: "671f81235997900563ceacac", name: "Badem" },
    { id: "671f81335997900563ceacbb", name: "Orah" },
    { id: "671f81445997900563ceacca", name: "Lešnik" },
    { id: "671f81595997900563ceacd9", name: "Indijski orah" },
    { id: "671f81705997900563ceace8", name: "Kikiriki" },
    { id: "671f81ba5997900563cead19", name: "Susam" },
    { id: "671f82735997900563cead4c", name: "Pšenica" },
    { id: "671f829b5997900563cead5b", name: "Ječam" },
    { id: "671f82b35997900563cead6a", name: "Ovas" },
    { id: "671f82c75997900563cead79", name: "Raž" },
    { id: "671f948cd1348708c15baba8", name: "Kravlje" },
    { id: "671f94b6d1348708c15babb7", name: "Kozije" },
    { id: "671f94f5d1348708c15babc6", name: "Sojno" },
    { id: "671f951ed1348708c15babd5", name: "Bademovo (alternativna mleka)" },
    { id: "671f9835d1348708c15bad34", name: "Šaran" },
    { id: "671f9844d1348708c15bad43", name: "Som" },
    { id: "671f985cd1348708c15bad52", name: "Pastrmka" },
    { id: "671f986dd1348708c15bad61", name: "Smuđ" },
    { id: "671f987dd1348708c15bad70", name: "Deverika" },
    { id: "671f988ed1348708c15bad7f", name: "Kečiga" },
    { id: "671f98a3d1348708c15bad8e", name: "Štuka" },
    { id: "671f98b7d1348708c15bad9d", name: "Losos" },
    { id: "671f98cbd1348708c15badac", name: "Tuna" },
    { id: "671f98ebd1348708c15badca", name: "Bakalar" },
    { id: "671f990ad1348708c15bade8", name: "Lignje" },
    { id: "671f98dbd1348708c15badbb", name: "Skuša" },
    { id: "671f98fad1348708c15badd9", name: "Škampi" },
    { id: "671f99bfd1348708c15bae5f", name: "Pileća" },
  ];

  const [struka, setStruka] = useState(user.struk);
  const [kukova, setKukova] = useState(user.kuk);
  const [vrat, setvrat] = useState(user.vrat);
  const [errorObim, setErrorObim] = useState("");

  const userLista = () => navigate(`/dash/users`);
  const profile = () => navigate(`/`);

  const [updateUser, { isLoading, isSuccess, isError, error }] =
    useUpdateUserMutation();
  const [
    deleteUser,
    { isSuccess: isDelSuccess, isError: isDelError, error: delerror },
  ] = useDeleteUserMutation();

  const {
    isSuccess: isSuccessGetCiljevi,
    isError: isErrorGetCiljevi,
    error: getCiljeviError,
    data: getCiljeviData,
  } = useGetAllCiljeviQuery();
  const {
    isSuccess: isSuccessGetSpecCiljevi,
    isError: isErrorGetSpecCiljevi,
    error: getSpecCiljeviError,
    data: getSpecCiljeviData,
  } = useGetAllSpecCiljeviQuery();
  const {
    isSuccess: isSuccessGetMotiv,
    isError: isErrorGetMotiv,
    error: getMotivError,
    data: getMotivData,
  } = useGetAllMotivacijeQuery();
  const {
    isSuccess: isSuccessGetFizAkt,
    isError: isErrorGetFizAkt,
    error: getFizAktError,
    data: getFizAktData,
  } = useGetAllFizickeAktivnostiQuery();
  // const { isSuccess: isSuccessGetDijagnoza, isError: isErrorGetDijagnoza, error: getDijagnozaError, data: getDijagnozaData } = useGetAllDijagnozeQuery();

  useEffect(() => {
    if (isSuccess) {
      alert("Uspesno ste sacuvali podatke");
    }
  }, [isSuccess]);

  // useEffect(() => {
  //   console.log("selectedIshrana: ", selectedIshrana);
  // }, [selectedIshrana]);

  function pronadjiKomentar(id) {
    const objekat = ishrane?.find((item) => item._id === id);
    return objekat ? objekat.komentar : "Nije pronadjena ishrana.";
  }

  // useEffect(() => {
  //   const age = new Date().getFullYear() - new Date(datumRodjenja).getFullYear() - (new Date() < new Date(new Date().getFullYear(), 4, 2) ? 1 : 0);

  //   // let specCilj_naziv = "";
  //   const naminice_naziviDa = availableNamirnice.filter(obj => odabraneNamirnice?.includes(obj._id)).map(obj => obj.naziv);  //Izabrane naminice
  //   const naminice_nazivi = availableNamirnice.filter(obj => !odabraneNamirnice?.includes(obj._id)).map(obj => obj.naziv); //Ne izabrane naminice
  //   const naminice_voljene_nazivi = availableNamirnice.filter(obj => odabraneNamirnice?.includes(obj._id)).map(obj => obj.naziv);
  //   // const naminice_nevoljene_nazivi = availableNamirnice.filter(obj => odabraneNamirnice.includes(obj._id)).map(obj => obj.naziv);

  //   // if(primcilj == "Mršavljenje"){
  //   //   setUkupnaKalVred(calculatedValue1.toFixed(2))
  //   //   // ukupnaKalVred = baseValue1
  //   // }else if(primcilj == "Povećanje kilaže"){
  //   //   setUkupnaKalVred(calculatedValue2.toFixed(2))
  //   //   // ukupnaKalVred = baseValue2
  //   // }else{
  //   //   setUkupnaKalVred(tdee)
  //   // }

  //   //Ako imamo specifican cilj
  //   // if (specilj) {
  //   //     const specCilj_ = specCiljevi.find(spec => spec._id === specilj);
  //   //     if (tezina && visina && pol && primcilj && specCilj_) {
  //   //         specCilj_naziv = specCilj_.naziv;
  //   //         dispatch(setTransformacijaData({
  //   //           tezina,
  //   //           visina,
  //   //           pol,
  //   //           specilj: specCilj_naziv,
  //   //           primcilj,
  //   //           godine: age,
  //   //           dijagnoza,
  //   //           ucestBr: ucestObr,
  //   //           navikeUish: navike,
  //   //           namirnice: naminice_nazivi,
  //   //           voljeneNamirnice,
  //   //           neVoljeneNamirnice,
  //   //           ukupnaKalVred
  //   //       }));
  //   //     }
  //   // }

  //   // Samo primaran cilj
  //   // let specCilj_ = specCiljevi?.find(spec => spec._id === specilj);  //Kada smo imali samo pecificne ciljeve
  //   // let specCilj_naziv = specCilj_ ? specCilj_.naziv : "";
  //   // setSpecCilj_naziv(specCilj_?.naziv)

  //   // let nazivi = specCiljevi?.filter(obj => selectedSpecCiljevi?.includes(obj.id)).map(obj => obj.naziv);
  //   // setSelectedSpecCiljeviNazivi(nazivi);
  //   // console.log('nazivi', nazivi)

  //   //console.log('selectedSpecCiljevi:', selectedSpecCiljevi)

  //   //Za ciljeve nazivi
  //     const nazivi = selectedSpecCiljevi.map(ciljId => {
  //       const cilj = specCiljevi.find(c => c._id === ciljId);
  //         return cilj ? cilj.naziv : null;
  //     }).filter(naziv => naziv !== null);

  //     setSelectedSpecCiljeviNazivi(nazivi);
  //     // console.log('selectedSpecCiljeviNazivi:', selectedSpecCiljeviNazivi);

  //     if (tezina && visina && pol && primcilj) {

  //         dispatch(setTransformacijaData({
  //             tezina,
  //             visina,
  //             pol,
  //             specilj: selectedSpecCiljeviNazivi.length === 0 ? 'Nema ciljeva' : selectedSpecCiljeviNazivi,  //sada je lista
  //             primcilj,
  //             godine: age,
  //             datumRodjenja,
  //             dijagnoza: dijagnoza === '' ? 'Ne' : dijagnoza,
  //             ucestBr: ucestObr,
  //             navikeUish: navike,
  //             namirnice: naminice_nazivi, //ZA ONE KOJE NE ULAZE U SKUP ISHRANE
  //             namirniceDa: naminice_naziviDa, //ZA ONE KOJE ULAZE U SKUP ISHRANE
  //             selectedIshranaNaziv,
  //             voljeneNamirnice: voljeneNamirnice === '' ? 'Nema' : voljeneNamirnice,
  //             neVoljeneNamirnice: neVoljeneNamirnice === '' ? 'Nema' : neVoljeneNamirnice,
  //             ukupnaKalVred,
  //             tdee,
  //             bmi,
  //             motiv: motiv === '' ? 'Nema' : getMotivData?.entities[motiv]?.naziv,
  //             nivoAkt: activityLevel,
  //             vrstaFiz: selectedActivities,
  //             struk: struka === '' ? 'Nema' : struka,
  //             kuk: kukova === '' ? 'Nema' : kukova,
  //             vrat: vrat === '' ? 'Nema' : vrat,
  //             krv: bloodType === '' ? 'Nema' : bloodType,
  //             alerg: alergije === '' ? 'Nema' : alergije,
  //             pus: smoking === 'ne' ? 'Ne' : `${kolicinaCigara} cigareta`,
  //             alk: alkohol === 'ne' ? 'Ne' : `${kolicina} ${vrstaAlkohola}`,
  //             bmrValue,
  //             ime: name,
  //             prezime: lastname,
  //             imunitet,
  //             iskSaDijetama,
  //             intolerancija: selectedAllergies
  //         }));
  //     }
  // }, [tezina, visina, pol, primcilj, odabraneNamirnice, dijagnoza, ucestObr, navike, voljeneNamirnice, neVoljeneNamirnice, ukupnaKalVred, selectedIshranaNaziv, selectedSpecCiljeviNazivi]);

  //Kada se uzita stranica
  // useEffect(() => {

  //   const age = new Date().getFullYear() - new Date(datumRodjenja).getFullYear() - (new Date() < new Date(new Date().getFullYear(), 4, 2) ? 1 : 0);

  //   // let bmrValue;
  //   if (pol === 'muski') {
  //     // bmrValue = 88.36 + (13.4 * tezina) + (4.8 * visina) - (5.7 * age);
  //     setBmrValuer(88.36 + (13.4 * tezina) + (4.8 * visina) - (5.7 * age));
  //   } else {
  //     // bmrValue = 447.6 + (9.2 * tezina) + (3.1 * visina) - (4.3 * age);
  //     setBmrValuer(447.6 + (9.2 * tezina) + (3.1 * visina) - (4.3 * age));
  //   }

  //   // TDEE formula
  //   const tdeeValue = bmrValue * parseFloat(activityLevel);
  //   setTdee(tdeeValue.toFixed(2));
  //   setBaseValue1(tdeeValue); //Ali postavi kad saljes u prompt
  //   setBaseValue2(tdeeValue);

  //   if(primcilj == "Mršavljenje"){
  //     setUkupnaKalVred(calculatedValue1.toFixed(2))
  //     // ukupnaKalVred = baseValue1
  //   }else if(primcilj == "Povećanje kilaže"){
  //     setUkupnaKalVred(calculatedValue2.toFixed(2))
  //     // ukupnaKalVred = baseValue2
  //   }else{
  //     setUkupnaKalVred(tdee)
  //   }

  //   dispatch(setTransformacijaData({
  //         ukupnaKalVred,
  //     }));

  // }, []);

  //Racunanje razike - ipisane kilaze
  // useEffect(() => {
  //   const brKilaDaSmrsaNum = Number(brKilaDaSmrsa) || 0; // Convert to number or default to 0
  //   setKilazaIspisana(tezina - brKilaDaSmrsaNum);
  // }, [tezina, brKilaDaSmrsa]);

  //Setters
  // const onNameChanged = (e) => setName(e.target.value);
  const onNameChanged = async (e) => {
    setName(e.target.value);
  };

  const onLastNameChanged = async (e) => {
    setLastName(e.target.value);
  };

  const onMailChanged = async (e) => {
    setMail(e.target.value);
  };

  const onPolChanged = async (e) => {
    setPol(e.target.value);
  };

  const onDatumRodjenjaChanged = async (e) => {
    setDatumRodjenja(e.target.value);
  };

  const onTezinaChanged = async (e) => {
    setTezina(e.target.value);
  };

  const onVisinaChanged = async (e) => {
    setVisina(e.target.value);
  };

  const onPrimCiljChanged = async (e) => {
    setPrimcilj(e.target.value);
  };

  const onSpecCiljChanged = async (e) => {
    setSpecilj(e.target.value);
  };

  const onMotivChanged = async (e) => {
    setMotiv(e.target.value);
  };

  const onTelefonChanged = async (e) => {
    setTelefon(e.target.value);
  };

  const handleChangeVrstAkt = async (e) => {
    setVrstAkt(e.target.value);
  };

  const handleAlkoholChange = async (e) => {
    if (e.target.value == "ne") {
      setAlkohol(e.target.value);
      setVrstaAlkohola("");
      setKolicina("");
    } else {
      setAlkohol(e.target.value);
    }
  };

  // const handleChangeDijagnoza = async (e) => {
  //     setDijagnoza(e.target.value);
  // };

  const onUcestObrChange = async (e) => {
    setUcestObr(e.target.value);
  };

  const handleNavikeChange = async (e) => {
    setNavike(e.target.value);
  };

  const handleIskSaDijetamaChange = async (e) => {
    setIskSaDijetama(e.target.value);
  };

  const handleVrstaAlkoholaChange = async (e) => {
    setVrstaAlkohola(e.target.value);
  };

  const handleKolicinaChange = async (e) => {
    setKolicina(e.target.value);
  };

  const handleSmokingChange = async (event) => {
    if (event.target.value == "ne") {
      setSmoking(event.target.value);
      setKolicinaCigara("");
    } else {
      setSmoking(event.target.value);
    }
  };

  const handleKolicinaCigaraChange = async (event) => {
    setKolicinaCigara(event.target.value);
  };

  const handleVoljeneNamirniceChange = async (event) => {
    setVoljeneNamirnice(event.target.value);
  };

  const handleNeVoljeneNamirniceChange = async (event) => {
    setNeVoljeneNamirnice(event.target.value);
  };

  const handlAalgNaHranChange = async (e) => {
    setAlgNaHran(e.target.value);
  };

  const onKomentarCiljaChange = async (e) => {
    setKomentarCilja(e.target.value);
  };
  // const handleAlgiNaHranChange = (e) => setAlgiNaHran(e.target.checked)

  //Za alergije
  const [allergiesEnabled, setAllergiesEnabled] = useState(
    user?.allergiesEnabled
  );
  const [selectedAllergies, setSelectedAllergies] = useState(
    user?.intolerancija
  ); //Ovde su selektovane (gluten, laktoza)
  const [popupContentAle, setPopupContentAle] = useState([]);
  const [showPopupAle, setShowPopupAle] = useState(false);

  //Updejtuje kada se napravi promena HERE PROMENA
  useEffect(() => {
    saveDataToDatabase();
  }, [
    name,
    lastname,
    mail,
    tezina,
    visina,
    password,
    primcilj,
    motiv, //specilj, dijagnoza
    datumRodjenja,
    pol,
    roles,
    telefon,
    bmi,
    bloodType,
    alergije,
    imunitet,
    ucestObr,
    navike,
    iskSaDijetama,
    ukupnaKalVred,
    komentarCilja,
    struka,
    kukova,
    vrat,
    alkohol,
    smoking,
    kolicina,
    kolicinaCigara,
    vrstaAlkohola,
    neVoljeneNamirnice,
    voljeneNamirnice,
    allergiesEnabled,
    allergyChoice,
    activityLevel,
    // vrstaFiz
    selectedActivities,
    highlighted,
  ]);

  // useEffect(() => {
  //   saveDataToDatabaseNaminice();
  // }, [
  //   selectedIshrana
  // ]);

  // const handleAlgiNaHranChange = () => {
  //   setAlgiNaHran(!algiNaHran);
  //   if (!algiNaHran) {
  //     setModalOpenAlr(true);
  //   } else {
  //     setModalOpenAlr(false);
  //   }
  // };

  // const handleBackdropClickAlr = (e) => {
  //   // Proveravamo da li je klik bio na pozadini
  //   if (e.target === e.currentTarget) {
  //     closeModalAlr();
  //   }
  // };

  // const handleBackdropClickSelected = (e) => {
  //   if (e.target === e.currentTarget) {
  //     closeSelectedModal();
  //   }
  // };

  const handleRadioChange = (value) => {
    setIsAllergic(value === "yes");
    // if (value === "yes") {
    //   setModalOpenAlr(true);
    // } else {
    //   setModalOpenAlr(false);
    // }
    setAllergyChoice(value); // Postavljanje alergije na "yes" ili "no"
    setModalOpenAlr(value === "yes"); // Otvara modal ako je odabrano "Da"
  };

  // Dodavanje novog alergena sa liste
  // const addAllergen = (allergen) => {
  //   setSelectedAllergens((prev) => ({ ...prev, [allergen]: true }));
  // };

  // Get Ishrane (za tablarni prikaz namirnica)
  //  useEffect(() => {
  //   if (isSuccessGetIsh) {
  //       const ishraneList = Object.values(getIshData.entities || []);
  //       setIshrane(ishraneList);

  //       // Postavljanje podrazumevane ishrane
  //       const defaultIshrana = ishraneList.find((ishrana) => ishrana.naziv === "Tvoja ishrana");
  //       if (defaultIshrana) {
  //           setSelectedIshrana(defaultIshrana._id);
  //       }
  //   }

  //   if (isErrorGetIsh) {
  //       const errorMessage = getIshError?.data?.message;
  //       alert(errorMessage);
  //   }
  //   }, [isSuccessGetIsh, isErrorGetIsh, getIshError, getIshData]);

  // Get Ishrane (za tree prikaz namirnica)
  useEffect(() => {
    if (isSuccessGetIsh) {
      setIshrane(Object.values(getIshData.entities || []));
    }
    if (isErrorGetIsh) {
      const errorMessage = getIshError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetIsh, isErrorGetIsh, getIshError, getIshData]);

  //Posatvlja se prva ishrana kao defolt (A TREBA DA MU SE PAMTI IZ BAZE)
  // useEffect(() => {
  //   if (ishrane.length > 0 && !selectedIshrana) {
  //     setSelectedIshrana(user?.selectedIshrana);
  //     // handleIshranaChangeFirstSelect(ishrane[0]._id);
  //     //Postravi i
  //   }
  // }, [ishrane]);

  //Izcita iz baze id ishrane i posatvi njene naminice ako nema ishranu odna se cuva tvoja ishrana po difoltu // here 3
  // ODAVDE SE BACKI, ZAKOMENTARISI I PROBAJ ODATLE!
  // PROBAJ DA IZCITAS IS PROFILA...
  // useEffect(() => {
  //   if (user?.selectedIshrana != "") {
  //     //Probaj da izcitas iz profila naminiceDA
  //     const odabranaIshrana = ishrane.find(
  //       (ishrana) => ishrana._id === user?.selectedIshrana
  //     ); // Pronadjena ishrana odabrana iz selecta
  //     // console.log('user selected => ', user?.selectedIshrana)
  //     // console.log('odabranaIshrana => ', odabranaIshrana)
  //     if (odabranaIshrana) {
  //       setOdabraneNamirnice(odabranaIshrana.namirnice || []); // Postavljamo naminice od odabrane ishrane
  //       setSelectedIshranaNaziv(odabranaIshrana.naziv); // Postavljamo naziv ishrane
  //       // saveDataToDatabaseNaminice();
  //     }
  //   } else {
  //     console.log("Nema def. ishranu!");
  //     const odabranaIshrana_ = ishrane.find(
  //       (ishrana) => ishrana._id == "671784a5782070c626c837d8"
  //     );
  //     if (odabranaIshrana_) {
  //       setOdabraneNamirnice(odabranaIshrana_.namirnice || []); // Postavljamo naminice od odabrane ishrane
  //       setSelectedIshranaNaziv(odabranaIshrana_.naziv); // Postavljamo naziv ishrane
  //       saveDataToDatabaseNaminiceNov(
  //         odabranaIshrana_.namirnice,
  //         odabranaIshrana_.naziv,
  //         "671784a5782070c626c837d8"
  //       ); //Inicijalno kada se loguje
  //       // console.log('Ceo obejekat => ', odabranaIshrana_) Svi podaci su tu
  //     }
  //   }
  // }, [ishrane, isSuccessGetNamir]); //Da li treba issuceessgennaminice...?

  //OVDE POSTAVLJA IZ PROFILA PROMENJENU ISHRANU..
  useEffect(() => {
    //Probaj da izcitas iz profila naminiceDA
    setOdabraneNamirnice(user?.namirniceDa || []);
    setSelectedIshranaNaziv(user?.selectedIshranaNaziv);

    //Da ne ne mogu checkirati odcheckirani - PROVERI
    // setOdabraneNamirnice((prevDisabled) => [
    //   ...new Set([...prevDisabled, ...user?.namirniceDa]),
    // ]);

    // saveDataToDatabaseNaminice();
  }, []); //Da li treba da se postavi kad se mountuje???

  // useEffect(() => {
  //   if (user?.actlvl == "" || user?.primcilj == "") {
  //     saveDataToDatabaseDefaultDataNov();
  //   }
  // }, []);

  // Get Namirnice (za tablarni prikaz namirnica)
  // useEffect(() => {
  //     if (isSuccessGetNamir) {
  //         const namirnice = Object.values(getNamirData.entities || {});
  //         setAvailableNamirnice(namirnice);
  //         setGrupisaneNamirnice(groupNamirnice(namirnice));

  //         if (selectedIshrana) {
  //             const defaultIshrana = ishrane.find((ishrana) => ishrana._id === selectedIshrana);
  //             if (defaultIshrana) {
  //                 const filteredNamirnice = namirnice.filter((namirnica) =>
  //                     defaultIshrana.namirnice.includes(namirnica._id)
  //                 );
  //                 setOdabraneNamirnice(filteredNamirnice.map((namirnica) => namirnica.naziv)); // Čuvamo imena umesto ID-jeva
  //                 setGrupisaneNamirnice(groupNamirnice(filteredNamirnice));
  //             }
  //         }
  //     }

  //     if (isErrorGetNamir) {
  //         const errorMessage = getNamirError?.data?.message;
  //         alert(errorMessage);
  //     }
  // }, [isSuccessGetNamir, isErrorGetNamir, getNamirError, getNamirData, ishrane, selectedIshrana]);

  // useEffect(() => {
  //   console.log('User => ', user);
  // }, [user]);

  // Get Namirnice (za tree prikaz namirnica)
  useEffect(() => {
    if (isSuccessGetNamir) {
      setAvailableNamirnice(Object.values(getNamirData.entities || {}));
      // console.log('Avalibe naminice: ', Object.values(getNamirData.entities))

      const grupisaneNamirnice_ = Object.values(
        getNamirData.entities || {}
      ).reduce((acc, namirnica) => {
        if (!acc[namirnica.grupa]) {
          acc[namirnica.grupa] = {};
        }
        if (!acc[namirnica.grupa][namirnica.podtip]) {
          acc[namirnica.grupa][namirnica.podtip] = [];
        }
        acc[namirnica.grupa][namirnica.podtip].push(namirnica);
        return acc;
      }, {});
      setGrupisaneNamirnice(grupisaneNamirnice_); //Da li ovde treba da postavimo
      // console.log("Grupisane naminice => ", grupisaneNamirnice_); //Struktura za renderovanje - Objekat
    }

    if (isErrorGetNamir) {
      const errorMessage = getNamirError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetNamir, isErrorGetNamir, getNamirError, getNamirData]);

  const groupNamirnice = (namirnice) => {
    return namirnice.reduce((acc, namirnica) => {
      if (!acc[namirnica.grupa]) {
        acc[namirnica.grupa] = {};
      }
      if (!acc[namirnica.grupa][namirnica.podtip]) {
        acc[namirnica.grupa][namirnica.podtip] = [];
      }
      acc[namirnica.grupa][namirnica.podtip].push(namirnica);
      return acc;
    }, {});
  };

  // ZA TABELARNI PRIKAZ funkcija u selectu
  // const handleIshranaSelect = (event) => {
  //     const selectedIshranaId = event.target.value;
  //     setSelectedIshrana(selectedIshranaId);

  //     if (selectedIshranaId === "") {
  //         setGrupisaneNamirnice(groupNamirnice(availableNamirnice));
  //         setOdabraneNamirnice([]); // Resetujemo odabrane namirnice
  //         return;
  //     }

  //     const selectedIshrana = ishrane.find((ishrana) => ishrana._id === selectedIshranaId);

  //     if (selectedIshrana) {
  //         const filteredNamirnice = availableNamirnice.filter((namirnica) =>
  //             selectedIshrana.namirnice.includes(namirnica._id)
  //         );
  //         setOdabraneNamirnice(filteredNamirnice.map((namirnica) => namirnica.naziv)); // Čuvamo imena umesto ID-jeva
  //         setGrupisaneNamirnice(groupNamirnice(filteredNamirnice));
  //     }
  // };

  const posaljiSpecCiljeveReset = async () => {
    const headers = new Headers();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`); // Dodajemo Authorization token ako postoji
    }
    headers.set("Content-Type", "application/json"); // Postavljamo Content-Type na JSON

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/specCilj/reset/${id}`, //HERE dodaj
        {
          method: "PATCH", // PATCH metod za ažuriranje resursa
          headers: headers,
          credentials: "include", // Uključujemo kolačiće sa zahtevom
        }
      );

      if (response.ok) {
        alert("Odaberite specificne ciljeve");
        setSelectedSpecCiljevi([]);
      } else {
        console.error("Greška u odgovoru:", response.status);
      }
    } catch (error) {
      console.error("Greška pri slanju zahteva:", error);
    }
  };

  // Kada promenimo ishranu, resetuj namirnice na osnovu te ishrane NOVO - Postavi naminice od izabrane ishrane
  const handleIshranaChange = async (e) => {
    const selectedIshranaId = e.target.value;
    setSelectedIshrana(selectedIshranaId); // Postavljamo id ishrane
    setDisabledNamirnice([]);

    if (selectedIshranaId === "") {
      setOdabraneNamirnice([]); // Resetus ishranu ako nista nije izbarano
    } else {
      const odabranaIshrana = ishrane.find(
        (ishrana) => ishrana._id === selectedIshranaId
      ); // Pronadjena ishrana odabrana iz selecta

      if (odabranaIshrana) {
        setOdabraneNamirnice(odabranaIshrana.namirnice || []); // Postavljamo naminice od odabrane ishrane
        setSelectedIshranaNaziv(odabranaIshrana.naziv); // Postavljamo naziv ishrane
        //postavi ovde
        saveDataToDatabaseNaminice(
          odabranaIshrana.namirnice,
          odabranaIshrana.naziv,
          selectedIshranaId
        );

        //here reset
        // await posaljiSpecCiljeveReset();
      }
    }
  };

  // const handleIshranaChangeFirstSelect = (e) => {
  //   const selectedIshranaId = e;
  //   setSelectedIshrana(selectedIshranaId);
  //   setDisabledNamirnice([]); // Resetuj disabled checkboxove

  //   if (selectedIshranaId === '') {
  //     setOdabraneNamirnice([]); // Resetuj odabrane namirnice ako nije odabrana ishrana
  //   } else {
  //     const odabranaIshrana = ishrane.find((ishrana) => ishrana._id === selectedIshranaId); //Za naminice
  //     // console.log('availableNamirnice: ', availableNamirnice);

  //     const odabranaIshranaNaziv = ishrane.find((ishrana) => ishrana._id === selectedIshranaId);  //Za naziv jedne sihrane
  //     // const odabranaIshranaNaziv_ = odabranaIshranaNaziv.naziv;

  //     if (odabranaIshrana && odabranaIshranaNaziv) {
  //       setOdabraneNamirnice(odabranaIshrana.namirnice || []); // Postavi namirnice iz izabrane ishrane
  //       setSelectedIshranaNaziv(odabranaIshranaNaziv.naziv);
  //     }
  //   }
  // };

  // Kada promenimo specifičan cilj, resetuj namirnice i oduzmi checkboxove cilja, a te checkboxove onemogući NOVO HERE
  // useEffect(() => {
  //   if (specilj && selectedIshrana) {
  //     const odabranaIshrana = ishrane.find(
  //       (ishrana) => ishrana._id === selectedIshrana
  //     );

  //     if (odabranaIshrana) {
  //       setOdabraneNamirnice(odabranaIshrana.namirnice || []);

  //       const odabraniCilj = getSpecCiljeviData.entities[specilj];

  //       console.log('getSpecCiljeviData => ', getSpecCiljeviData);
  //       console.log('odabraniCilj => ', odabraniCilj);
  //       console.log('specilj => ', specilj);

  //       if (odabraniCilj && odabraniCilj.namirnice) {
  //         setOdabraneNamirnice((prev) =>
  //           prev.filter(
  //             (namirnicaId) => !odabraniCilj.namirnice.includes(namirnicaId)
  //           )
  //         );

  //         // Postavi disabled checkboxove na osnovu specifičnog cilja
  //         setDisabledNamirnice(odabraniCilj.namirnice);
  //       }
  //     }
  //   }
  // }, [specilj, selectedIshrana, getSpecCiljeviData, ishrane]);

  //Postavlja naminice od specificnog cilja pri mountovanju - RADI ALI PROVERI UVEK SE VRATI!
  // useEffect(() => {
  //   if (selectedSpecCiljevi.length != 0) {
  //     const odabraniCiljevi = selectedSpecCiljevi?.map(
  //       (specilj) => getSpecCiljeviData?.entities[specilj]
  //     );

  //     console.log("getSpecCiljeviDataF => ", getSpecCiljeviData);
  //     console.log("speciljF => ", selectedSpecCiljevi);
  //     console.log("odabraniCiljeviF =>", odabraniCiljevi);

  //     //Da oduzmem od ishrane...
  //     if (odabraniCiljevi && odabraniCiljevi?.length > 0) {
  //       odabraniCiljevi?.forEach((odabraniCilj) => {
  //         // Filtriraj namirnice koje su već odabrane za svaki cilј
  //         setOdabraneNamirnice((prev) =>
  //           prev.filter(
  //             (namirnicaId) => !odabraniCilj?.namirnice.includes(namirnicaId)
  //           )
  //         );

  //         // Postavi disabled checkboxove za sve ciljeve
  //         setDisabledNamirnice((prevDisabled) => [
  //           ...new Set([...prevDisabled, ...odabraniCilj?.namirnice]),
  //         ]);
  //       });
  //     }
  //   }
  // }, []);

  //Postavlja naminice od specificnog cilja pri selectovanju ALI NA KLIJENTSKOJ STRANI! - RADI ALI PROVERI UVEK POGLEDAJ!
  // useEffect(() => {
  //   if (selectedSpecCiljevi && selectedIshrana) {
  //     //Nalazimo naminice od ishrane i postavljamo namirnice te ishrane
  //     const odabranaIshrana = ishrane.find(
  //       (ishrana) => ishrana._id === selectedIshrana
  //     );

  //     if (odabranaIshrana) {
  //       setOdabraneNamirnice(odabranaIshrana.namirnice || []);

  //       //Odabrani spec cilj koji vice sa sobom naminice
  //       // const odabraniCilj = getSpecCiljeviData.entities[specilj];

  //       const odabraniCiljevi = selectedSpecCiljevi.map(
  //         (specilj) => getSpecCiljeviData.entities[specilj]
  //       );

  //       console.log("getSpecCiljeviData => ", getSpecCiljeviData); //Svi specificni ciljevi
  //       console.log("specilj => ", selectedSpecCiljevi); //Lista id odabranih spec ciljevi
  //       console.log("odabraniCiljevi =>", odabraniCiljevi); //Lista objekata specificnih ciljeva sa naminicama, nazivom itd...
  //       console.log("==========");

  //       //Da oduzmem od ishrane...
  //       if (odabraniCiljevi && odabraniCiljevi.length > 0) {
  //         odabraniCiljevi.forEach((odabraniCilj) => {
  //           // Filtriraj namirnice koje su već odabrane za svaki cilј
  //           setOdabraneNamirnice((prev) => prev.filter((namirnicaId) => !odabraniCilj.namirnice.includes(namirnicaId))
  //           );

  //           // Postavi disabled checkboxove za sve ciljeve
  //           setDisabledNamirnice((prevDisabled) => [
  //             ...new Set([...prevDisabled, ...odabraniCilj.namirnice]),
  //           ]);
  //         });
  //       }
  //     }
  //   }
  // }, [selectedSpecCiljevi]);

  //Postavlja checkirane naminice u odabrane naminice - radi
  const handleNamirnicaChange = (event) => {
    const value = event.target.value;
    // console.log("value => ", value);
    setOdabraneNamirnice((prev) => {
      if (prev.includes(value)) {
        return prev.filter((id) => id !== value);
      } else {
        return [...prev, value];
      }
    });
  };

  //Ovde posalji da se cuvaju u bazi tj. u profilu
  useEffect(() => {
    const updateNamirnice = async () => {
      // console.log("odabraneNamirnice => ", odabraneNamirnice);

      const headers = new Headers();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");

      let data = {
        id,
        odabraneNamirnice,
      };

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/updateNaminiceNaChekbox`,
          {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data),
            credentials: "include",
          }
        );

        if (response.ok) {
          const data = await response.json();
          // console.log("odabraneNamirnice u useru => ", data.updatedUser);
        } else {
          console.error("Greška u odgovoru:", response.status);
        }
      } catch (error) {
        console.error("Greška pri slanju zahteva:", error);
      }
    };

    updateNamirnice();
  }, [odabraneNamirnice]);

  const selectedAllergenNames = Object.keys(selectedAllergens).filter(
    (allergen) => selectedAllergens[allergen]
  );

  // Za alergene
  const handleAllergenChange = (e) => {
    const { name, checked } = e.target;
    setSelectedAllergens((prev) => ({
      ...prev,
      [name]: checked,
    }));

    setOdabraneNamirnice((prev) =>
      checked ? prev.filter((id) => id !== name) : [...prev, name]
    );
  };

  const closeModalAlr = () => {
    setModalOpenAlr(false);
  };

  const closeSelectedModal = () => {
    setModalOpenSelected(false);
  };

  // console.log('selectedAllergens', selectedAllergens)

  const onBmiChanged = (e) => setBmi(e.target.value); //Nije sacuvano u bazi jer ne postoji kao property

  //Chat pitanje
  const [pitanje, setPitanje] = useState("");
  // const [odg, setOdgovor] = useState("");

  //Posta checkbox
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  //Gledaj da snimi u bazu
  const handleCheckboxChange = (e) => {
    if (e.target.checked) {
      setPopupMessage("Prijavljeni ste na pormotivne mejlove");
    } else {
      setPopupMessage("Odjavili ste se sa pormotivnih mejilova");
    }
    setShowPopup(true);
  };

  const closeModalPosta = () => {
    setShowPopup(false);
  };

  const handlePrehranIntolChange = () => {
    setPrehranIntol(!prehranIntol);
    if (!prehranIntol) {
      setIsModalOpenIntol(true);
    } else {
      setIsModalOpenIntol(false);
    }
  };

  const closeModalIntol = () => {
    setIsModalOpenIntol(false);
    setPrehranIntol(false);
  };

  // let sendPitanje = async (e) => {
  //   closeModalIzmena();
  //   e.preventDefault();

  //   let prompt = "";
  //   if (primcilj == "") {
  //     prompt = `Kreiraj mi plan ishrane, moj pol je ${pol} i imam ${tezina}kg, moj primaran cilj je da ${primcilj}`;
  //   } else {
  //     prompt = `Kreiraj mi plan ishrane, moj pol je ${pol} i imam ${tezina}kg, moj primaran cilj je da ${primcilj} a moj pecifični cilj je da ${specilj}`;
  //   }

  //   const res = await fetch("https://nutritrans.rs:5000/openai/ishrana", {
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({
  //       title: prompt,
  //     }),
  //     method: "POST",
  //   });
  //   const data = await res.json();

  //   console.log("data", data.description);

  //   setOdgovor(data.description);
  // };

  //NEW
  const tabs = [
    { name: "Osnovni podaci", href: "#tab1" },
    { name: "Ciljevi", href: "#tab4" },
    { name: "Fizički parametri", href: "#tab5" },
    { name: "Ishrana i zivotne navike", href: "#tab2" },
    { name: "Namirnice", href: "#tab3" },
    { name: "Moje ishrane", href: "#tab3" },
  ];

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  //Tab
  const [currentTab, setCurrentTab] = useState(tabs[0].name);

  const tabTrigger = useSelector(selectTabTrigger);

  //Premesta na drugi tab kada se u redux state prebaci da je iskreirao ishranu
  useEffect(() => {
    if (tabTrigger) {
      // setCurrentTab("Moje ishrane"); //Pre je bilo za tabove
      setSelectedDiv("PlanoviIshrane");
      dispatch(setTabTrigger(!tabTrigger));
    }
  }, [tabTrigger]);

  //Da mi fetchuje sve pdf-ove
  useEffect(() => {
    if (selectedDiv === "PlanoviIshrane") {
      getPdf();
    }

    if (selectedDiv === "Dashboard") {
      getPdftwo();
    }
  }, [selectedDiv]);

  //Disejbluje radio buttone
  useEffect(() => {
    if (selectedDiv === "Ciljevi") {
      // Prvi set dugmadi
      if (aktivan?.naziv_paketa === "Starter") {
        setEnabledButtonsCount1(1);
      } else if (aktivan?.naziv_paketa === "Osnovni") {
        setEnabledButtonsCount1(3);
      } else if (aktivan?.naziv_paketa === "Napredni") {
        setEnabledButtonsCount1(4);
      }

      // Drugi set dugmadi
      if (aktivan?.naziv_paketa === "Starter") {
        setEnabledButtonsCount2(1);
      } else if (aktivan?.naziv_paketa === "Osnovni") {
        setEnabledButtonsCount2(3);
      } else if (aktivan?.naziv_paketa === "Napredni") {
        setEnabledButtonsCount2(4);
      }
    }
  }, [selectedDiv, aktivan]);

  // const openModal = (e) => {
  //   e.preventDefault(); //Jer je dugme u formi!
  //   setIsModalOpen(true);
  // };

  //OVO
  // const openModalIzmena = (e) => {
  //   e.preventDefault(); //Jer je dugme u formi!
  //   setIsModalOpenIzmena(true);
  // };

  const closeModal = () => setIsModalOpen(false);

  const closeModalIzmena = (e) => {
    if (hasIzmena) {
      setIsModalOpenIzmena(false);
      // onClose();
    } else {
      setIsModalOpenIzmena(false);
    }
  };

  // const onRolesChanged = (e) => {
  //   const values = Array.from(
  //     e.target.selectedOptions,
  //     (option) => option.value
  //   );
  //   setRoles(values);
  // };

  //ZA RADIO GROUP
  // const [selectedOptionStatus, setSelectedOptionStatus] = useState(user.status);
  // const [selectedOptionValuta, setSelectedOptionValuta] = useState(user.valuta);

  // const handleOptionChangeStatus = (e) => {
  //   setSelectedOptionStatus(e.target.value);
  // };

  // const handleOptionChangeValuta = (e) => {
  //   setSelectedOptionValuta(e.target.value);
  // };

  const handleTabClick = (tabName) => {
    setCurrentTab(tabName);
  };

  const handleSelectChange = (event) => {
    setCurrentTab(event.target.value);
  };

  //Za mesece kalkulacija
  // const handleChange = (event) => {
  //   setSelectedMonth(Number(event.target.value));
  // };

  // const calculateDate = () => {
  //   const today = new Date();
  //   today.setMonth(today.getMonth() + selectedMonth);
  //   return today.toLocaleDateString(); // Format date as needed
  // };

  // const calculateDailyDeficit = () => {
  //   const days = Math.ceil((new Date(new Date().setMonth(new Date().getMonth() + selectedMonth)) - new Date()) / (1000 * 60 * 60 * 24));
  //   return (7700 / days).toFixed(1);
  // };

  // Formatiranje datuma
  function formatDate() {
    const date = new Date();

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Meseci su 0-indeksirani
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  //Bmi kalkulator
  useEffect(() => {
    if (tezina && visina) {
      const heightInMeters = visina / 100;
      const calculatedBmi = (
        tezina /
        (heightInMeters * heightInMeters)
      ).toFixed(2);
      setBmi(calculatedBmi);
    } else {
      setBmi(0);
    }
  }, [tezina, visina]);

  //Da postavi fizicku aktivnost na prvi koji je u listi
  // useEffect(() => {
  //   if (isSuccessGetFizAkt && getFizAktData) {
  //     const firstAktivnost = Object.values(getFizAktData.entities)[0];
  //     if (firstAktivnost) {
  //       setVrstAkt(firstAktivnost.naziv);
  //     }
  //   }
  // }, [isSuccessGetFizAkt, getFizAktData]);

  //Da postavi dijagnozu aktivnost na prvi koji je u listi
  // useEffect(() => {
  //   if (isSuccessGetDijagnoza && getDijagnozaData) {
  //     const firstDijagnoza = Object.values(getDijagnozaData.entities)[0];
  //     if (firstDijagnoza) {
  //       setDijagnoza(firstDijagnoza.naziv);
  //     }
  //   }
  // }, [isSuccessGetDijagnoza, getDijagnozaData]);

  // Get spec ciljevi
  useEffect(() => {
    if (isSuccessGetSpecCiljevi) {
      // console.log("Učitani specifični ciljevi:", specCiljevi);
      setSpecCiljevi(Object.values(getSpecCiljeviData?.entities || {}));
      // console.log('Svi scep ciljevi', Object.values(getSpecCiljeviData?.entities || {}))

      const groupedData = Object.values(
        getSpecCiljeviData?.entities || {}
      ).reduce((acc, item) => {
        if (!acc[item.defTip]) acc[item.defTip] = [];
        acc[item.defTip].push(item);
        return acc;
      }, {});

      // console.log("groupedData => ", groupedData);

      setGroupedData(groupedData);
    }

    // console.log('SpecCiljeviii:', Object.values(getSpecCiljeviData?.entities || {}))

    if (isErrorGetSpecCiljevi) {
      const errorMessage = getSpecCiljeviError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetSpecCiljevi, isErrorGetSpecCiljevi, getSpecCiljeviError]);

  //
  useEffect(() => {
    if (selectedDefTip) {
      const filtered = specCiljevi?.filter(
        (item) => item.defTip === selectedDefTip
      );
      setFilteredSpecCiljevi(filtered);
    } else {
      setFilteredSpecCiljevi([]);
    }
  }, [selectedDefTip, specCiljevi]);

  //
  const onDefTipChanged = (e) => {
    setSelectedDefTip(e.target.value);
    setSpecilj(""); // Resetuj specifičan cilj - Zasto?
    //setSelectedSpecCiljevi([]);
  };

  //KADA SMO IMALI SAMO JEDAN SPECIFICAN CILJ DA IZABEREMO
  // const handleCheckboxChangeSpecCilj = (ciljId) => {
  //   setSelectedSpecCiljevi((prevSelected) => {
  //     if (prevSelected.includes(ciljId)) {
  //       return prevSelected.filter((id) => id !== ciljId);
  //     } else {
  //       return [...prevSelected, ciljId];
  //     }
  //   });
  // };

  //
  const handleCheckboxChangeSpecCilj = (id) => {
    setSelectedSpecCiljevi((prev) =>
      prev.includes(id) ? prev.filter((ciljId) => ciljId !== id) : [...prev, id]
    );
  };

  //work here
  useEffect(() => {
    posaljiSpecCiljeve();
  }, [selectedSpecCiljevi]);

  // const handleCheckboxChangeSpecCilj = (ciljId) => {
  //   setSelectedSpecCiljevi((prevSelected) => {
  //     const newSelected = prevSelected.includes(ciljId)
  //       ? prevSelected.filter(id => id !== ciljId) // Ukloni ako je već izabran
  //       : [...prevSelected, ciljId]; // Dodaj ako nije izabran

  //     if (selectedIshrana) {
  //       const odabranaIshrana = ishrane.find((ishrana) => ishrana._id === selectedIshrana);
  //       if (odabranaIshrana) {
  //         const namirniceSve = odabranaIshrana.namirnice || [];
  //         const namirniceZaUklanjanje = new Set(); // Skup za namirnice koje treba ukloniti

  //         // Kada se selektuje, dodajemo namirnice koje pripadaju tom cilju
  //         if (newSelected.includes(ciljId)) {
  //           const odabraniCilj = getSpecCiljeviData.entities[ciljId];
  //           if (odabraniCilj && odabraniCilj.namirnice) {
  //             odabraniCilj.namirnice.forEach(namirnicaId => {
  //               namirniceZaUklanjanje.add(namirnicaId);
  //             });
  //           }
  //         }

  //         // Uklanjamo sve namirnice povezane sa svim selektovanim ciljevima
  //         if (newSelected.length > 0) {
  //           // Uklanjamo namirnice
  //           setOdabraneNamirnice((prev) =>
  //             prev.filter(namirnicaId => !namirniceZaUklanjanje.has(namirnicaId))
  //           );
  //         } else {
  //           // Ako su svi ciljevi odselektovani, vraćamo sve namirnice
  //           setOdabraneNamirnice(namirniceSve);
  //         }
  //       }
  //     }

  //     // Logika za odselektovanje
  //     if (!newSelected.includes(ciljId)) {
  //       // Vraćamo samo namirnice koje su vezane za odabrani cilj
  //       const odabraniCilj = getSpecCiljeviData.entities[ciljId];
  //       if (odabraniCilj && odabraniCilj.namirnice) {
  //         const namirniceZaVracanje = odabraniCilj.namirnice.filter(namirnicaId => {
  //           return !newSelected.some(selectedCiljId => {
  //             const cilј = getSpecCiljeviData.entities[selectedCiljId];
  //             return cilј && cilј.namirnice.includes(namirnicaId);
  //           });
  //         });

  //         // Vraćamo namirnice koje nisu vezane za ostale ciljeve
  //         setOdabraneNamirnice((prev) => [
  //           ...prev,
  //           ...namirniceZaVracanje.filter(id => !prev.includes(id))
  //         ]);
  //       }
  //     }

  //     return newSelected;
  //   });
  // };

  useEffect(() => {
    if (isSuccessGetNamir) {
      const grupisaneNamirnice_ = Object.values(
        getNamirData.entities || {}
      ).reduce((acc, namirnica) => {
        acc[namirnica.grupa] = acc[namirnica.grupa] || {};
        acc[namirnica.grupa][namirnica.podtip] =
          acc[namirnica.grupa][namirnica.podtip] || [];
        acc[namirnica.grupa][namirnica.podtip].push(namirnica);
        return acc;
      }, {});

      setGrupisaneNamirnice(grupisaneNamirnice_);
      setAvailableNamirnice(Object.values(getNamirData.entities || {}));
    }
  }, [isSuccessGetNamir, getNamirData]);

  // Izvuci jedinstvene defTipove iz specifičnih ciljeva
  const uniqueDefTip = [...new Set(specCiljevi?.map((item) => item.defTip))];

  //Dodato isSuccessGetCiljevi
  useEffect(() => {
    if (isSuccessGetCiljevi && getCiljeviData.ids.length > 0) {
      // const firstOptionValue = getCiljeviData.entities[getCiljeviData.ids[0]]?.naziv;  //Ako hocu da mu bude postavljeno prvo na Mrsavljenje
      // setPrimcilj(firstOptionValue);
    }
  }, [getCiljeviData]);

  const handleChangeFizNivo = (event) => {
    setActivityLevel(event.target.value);
  };

  //const onActiveChanged = () => setActive(prev => !prev);

  //Modal change data IZMENI NAKNADNO!!!
  //Posalje chatu zahtev i postavi ispod generisan odgovor
  const handleConfirmIzmena = async (e) => {
    e.preventDefault();

    try {
      let request = await updateUser({
        id: user.id,
        mail,
        name_: name,
        lastname,
        datumRodjenja,
        telefon,
        pol,
        visina,
        tezina,
        struka,
        kukova,
        vrat,
        bloodType,
        activityLevel,
        tdee,
        primcilj,
        ukupnaKalVred,
        motiv: getMotivData?.entities[motiv]?.naziv,
        imunitet,
        komentarCilja,
        // dijagnoza,
        alergije,
      });
      console.log("ERROR: ", request);

      setHasIzmena(true);
    } catch (e) {
      console.log(e);
    }
  };

  const handleConfirm = async () => {
    await deleteUser({ id: user.id });
    closeModal();
  };

  //Za obime - uklopi posle
  const handleSubmitObim = (e) => {
    e.preventDefault();
    // Example validation
    if (!struka || !kukova || !vrat) {
      setErrorObim("Potrebno je upisati sve obime!");
    } else {
      setErrorObim("");
      // Handle form submission
      console.log({ struka, kukova, vrat });
    }
  };

  const handleChangeBloodType = (e) => {
    setBloodType(e.target.value);
  };

  const toggleButtonState1 = () => {
    setAreButtonsEnabled1((prevState) => !prevState);
  };

  const toggleButtonState2 = () => {
    setAreButtonsEnabled2((prevState) => !prevState);
  };

  const handleMailingListChange1 = (mailingList) => {
    setSelectedMailingLists1(mailingList);
    const newCalculatedValue = (mailingList.procenat / 100) * baseValue1;
    setCalculatedValue1(newCalculatedValue);
  };

  const handleMailingListChange2 = (mailingList) => {
    setSelectedMailingLists2(mailingList);
    const newCalculatedValue = (mailingList.procenat / 100) * baseValue2;
    setCalculatedValue2(newCalculatedValue);
  };

  //Za Moje izvestaje ishrane
  const [idIzvestaja, setIdIzvestaja] = useState("");
  {
    /* openModal(true)  setIdDnevnikaZaBris*/
  }

  const setIdIshraneIzvZaBris = (id) => {
    // setIdDnevnika(id);
    // openModal(true);
  };

  //   useEffect(()=>{
  //   console.log('checkedItemsNamirnice', Object.keys(checkedItemsNamirnice));

  // },[checkedItemsNamirnice])

  //ZeljenI cilj MRSAVLJENJE I GOJENJE
  // Definisanje state varijabli
  const [selectedPlan, setSelectedPlan] = useState("gojenje"); // Plan: mršavljenje ili gojenje
  const [selectedMonth, setSelectedMonth] = useState(1); // Početna vrednost za mesec
  const [brKilaDaSePromeni, setBrKilaDaSePromeni] = useState(0); // Početna vrednost za željeni gubitak ili dobitak kilograma
  const [kilazaIspisana, setKilazaIspisana] = useState(user?.tezina); // Početna vrednost trenutne težine

  // Funkcija za promenu izabrane vrednosti meseca
  const handleChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  // Funkcija za promenu plana (mršavljenje ili gojenje)
  const handlePlanChange = (event) => {
    setSelectedPlan(event.target.value);
    setBrKilaDaSePromeni(""); // Resetovanje unosa kilograma pri promeni plana
  };

  // Funkcija za izračunavanje krajnjeg datuma na osnovu broja meseci
  const calculateDate = () => {
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + parseInt(selectedMonth));
    return currentDate.toLocaleDateString("sr-RS");
  };

  // Funkcija za izračunavanje ciljne težine na kraju odabranog perioda
  const calculateTargetWeight = () => {
    const targetWeight =
      primcilj === "Mršavljenje"
        ? Number(kilazaIspisana) - (Number(brKilaDaSePromeni) || 0)
        : Number(kilazaIspisana) + (Number(brKilaDaSePromeni) || 0);
    return targetWeight > 0 ? targetWeight : 0; // Osiguravamo da težina ne bude negativna
  };

  // Funkcija za izračunavanje dnevnog kalorijskog deficita ili viška OK
  const calculateDailyChange = () => {
    const changePerKg = 7700; // Promena kalorija po kilogramu
    const daysInMonth = 30; // Broj dana u mesecu
    const change =
      (brKilaDaSePromeni * changePerKg) / (selectedMonth * daysInMonth);
    return Math.round(change);
  };

  // Sprečavanje unosa negativnih brojeva za željeni gubitak ili dobitak kilograma
  const handleWeightChange = (e) => {
    const value = e.target.value;
    if (value === "" || value === "-") {
      setBrKilaDaSePromeni(""); // Ako je prazno polje ili se unese "-", ostavi prazno
    } else {
      setBrKilaDaSePromeni(Math.max(0, value)); // Sprečava negativne vrednosti
    }
  };

  const posaljiSpecCiljeve = async () => {
    // const nazivi = selectedSpecCiljevi?.map(ciljId => {  //Radi ali samo saljemo nazive
    //   const cilj = specCiljevi?.find(c => c._id === ciljId);
    //     return cilj ? cilj.naziv : null;
    // }).filter(naziv => naziv !== null);

    const headers = new Headers();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    headers.set("Content-Type", "application/json"); // Postavljamo Content-Type na JSON

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/specCilj/${id}`, //HERE dodaj
        {
          method: "PATCH", // PATCH metod za ažuriranje resursa
          headers: headers,
          body: JSON.stringify(selectedSpecCiljevi), // Podaci koje šaljemo
          credentials: "include", // Uključujemo kolačiće sa zahtevom
        }
      );

      if (response.ok) {
        const data = await response.json();

        setOdabraneNamirnice(data.neodabraneNamirnice); //Obrnuo sam

        //Da ne mogu checkirati odcheckirani - PROVERI
        // setDisabledNamirnice((prevDisabled) => [
        //   ...new Set([...prevDisabled, ...data.neodabraneNamirnice]),
        // ]);

        // console.log("Uspešan odgovor:", data);
      } else {
        console.error("Greška u odgovoru:", response.status);
      }
    } catch (error) {
      console.error("Greška pri slanju zahteva:", error);
    }
  };

  const glutenListId = [
    "671f82735997900563cead4c",
    "671f829b5997900563cead5b",
    "671f82b35997900563cead6a",
    "671f82c75997900563cead79",
    "671f82e45997900563cead88",
    "671f83c65997900563ceade7",
    "671f83e85997900563ceadf6",
    "671f840a5997900563ceae05",
    "671f84315997900563ceae14",
    "671f84755997900563ceae32",
    "671f849a5997900563ceae41",
    "671f84b55997900563ceae50",
  ];

  const glutenList = [
    "Pšenica",
    "Ječam",
    "Ovas",
    "Raž",
    "Spelta",
    "Hleb od celovitog zrna",
    "Integralna testenina",
    "Ovsena kaša",
    "Beli hleb",
    "Obična testenina",
    "Keks",
    "Kolač",
  ];

  const laktozaListId = [
    "671f948cd1348708c15baba8",
    "671f957cd1348708c15babe4",
    "671f95c2d1348708c15babf3",
    "671f9634d1348708c15bac1c",
    "671f9605d1348708c15bac02",
    "671f9657d1348708c15bac2b",
    "671f966fd1348708c15bac3a",
    "671f9696d1348708c15bac49",
    "671f96b3d1348708c15bac58",
    "671f96ced1348708c15bac67",
    "671f9df0d1348708c15bb051",
    "671f9e0dd1348708c15bb060",
    "671f9707d1348708c15bac7a",
    "671f971bd1348708c15bac89",
  ];

  const laktozaList = [
    "Kravlje mleko",
    "Jogurt",
    "Grčki jogurt",
    "Voćni jogurt",
    "Gauda",
    "Edamer",
    "Feta",
    "Parmezan",
    "Mozzarela",
    "Rikota",
    "Kefir",
    "Kiselo mleko",
    "Kisela pavlaka",
    "Slatka pavlaka",
  ];

  // const handleCheckboxChangeAle = (type) => {
  //   setSelectedAllergies((prev) => {
  //     if (prev.includes(type)) {
  //       return prev.filter((allergy) => allergy !== type);
  //     } else {
  //       return [...prev, type];
  //     }
  //   });

  //   if(selectedIshrana.length != 0){
  //     if (!selectedAllergies.includes(type)) {
  //       if (type === 'gluten') {
  //         let glutenList = [
  //           'Pšenica',
  //           'Ječam',
  //           'Ovas',
  //           'Raž',
  //           'Spelta',
  //           'Hleb od celovitog zrna',
  //           'Integralna testenina',
  //           'Ovsena kaša',
  //           'Beli hleb',
  //           'Obična testenina',
  //           'Keks',
  //           'Kolač'
  //         ]
  //         setPopupContentAle(glutenList);
  //         //I ovde da skinem sa state-a odabranih naminica
  //         console.log('odabraneNamirnice1: ', odabraneNamirnice);
  //         let filteredIds = odabraneNamirnice.filter(id => !glutenListId.includes(id));
  //         setOdabraneNamirnice(filteredIds)

  //       } else if (type === 'laktoza') {
  //         let laktozaList = [
  //           'Kravlje mleko',
  //           'Jogurt',
  //           'Grčki jogurt',
  //           'Voćni jogurt',
  //           'Gauda',
  //           'Edamer',
  //           'Feta',
  //           'Parmezan',
  //           'Mozzarela',
  //           'Rikota',
  //           'Kefir',
  //           'Kiselo mleko',
  //           'Kisela pavlaka',
  //           'Slatka pavlaka'
  //         ]
  //         setPopupContentAle(laktozaList);
  //         //I ovde da skinem sa state-a odabranih naminica
  //         console.log('odabraneNamirnice1: ', odabraneNamirnice);
  //         let filteredIds = odabraneNamirnice.filter(id => !alktozaListId.includes(id));
  //         setOdabraneNamirnice(filteredIds)
  //       }
  //       setShowPopupAle(true);
  //     }

  //   }else{
  //     alert("Unesite ishranu");
  //   }
  //   // console.log('selectedAllergies', selectedAllergies)
  // };

  // const toggleAllergy = (type) => {

  //   setSelectedAllergies((prev) => {
  //     const updatedAllergies = prev.includes(type)
  //       ? prev.filter(a => a !== type)
  //       : [...prev, type];

  //     updateNamirnice(updatedAllergies);
  //     return updatedAllergies;
  //   });
  // };
  const toggleAllergy = (type) => {
    if (selectedIshrana.length === 0) {
      alert("Unesite ishranu");
      return; // Ne nastavljamo ako ishrana nije uneta
    }

    setSelectedAllergies((prev) => {
      const updatedAllergies = prev.includes(type)
        ? prev.filter((a) => a !== type)
        : [...prev, type];

      updateNamirnice(updatedAllergies);

      // Prikazujemo popup kada se alergija uključuje
      if (!prev.includes(type)) {
        setPopupContentAle(type === "gluten" ? glutenList : laktozaList);
        setShowPopupAle(true);
      }

      return updatedAllergies;
    });
  };

  const updateNamirnice = (allergies) => {
    let filteredIds = [...odabraneNamirnice];

    // Vraćamo namirnice koje su isključene
    if (allergies.includes("gluten")) {
      filteredIds = filteredIds.filter((id) => !glutenListId.includes(id));
      setPopupContentAle(glutenList);
    } else {
      // Ako gluten nije selektovan, vraćamo gluten namirnice
      filteredIds = [...filteredIds, ...glutenListId];
    }

    if (allergies.includes("laktoza")) {
      filteredIds = filteredIds.filter((id) => !laktozaListId.includes(id));
      setPopupContentAle(laktozaList);
    } else {
      // Ako laktoza nije selektovana, vraćamo laktoza namirnice
      filteredIds = [...filteredIds, ...laktozaListId];
    }

    setOdabraneNamirnice(filteredIds);
  };

  // const handleCheckboxChangeAle = (type) => {
  //   setSelectedAllergies((prev) => {
  //     if (prev.includes(type)) {
  //       // Alergija je isključena, ovde dodajemo radnju
  //       if (type === 'gluten') {
  //         // let filteredIds = odabraneNamirnice.filter(id => glutenListId.includes(id));
  //         // let filteredIds = glutenListId.forEach(item => odabraneNamirnice.push(item));
  //         let filteredIds = glutenListId.forEach(item => {
  //           if (!odabraneNamirnice.includes(item)) {
  //               odabraneNamirnice.push(item);
  //           }
  //       });
  //         setOdabraneNamirnice(filteredIds);
  //         console.log('iskljucenGluten')
  //       } else if (type === 'laktoza') {
  //         // let filteredIds = odabraneNamirnice.filter(id => alktozaListId.includes(id));
  //         // let filteredIds = alktozaListId.forEach(item => odabraneNamirnice.push(item));
  //         let filteredIds = laktozaListId.forEach(item => {
  //             if (!odabraneNamirnice.includes(item)) {
  //                 odabraneNamirnice.push(item);
  //             }
  //         });
  //         setOdabraneNamirnice(filteredIds);
  //         console.log('iskljucenaLaktoza')
  //       }
  //       return prev.filter((allergy) => allergy !== type);
  //     } else {
  //       // Alergija je uključena
  //       if (selectedIshrana.length !== 0) {
  //         if (type === 'gluten') {
  //           let filteredIds = odabraneNamirnice.filter(id => !glutenListId.includes(id));
  //           setOdabraneNamirnice(filteredIds);
  //           setPopupContentAle(glutenList);
  //           setShowPopupAle(true);
  //         } else if (type === 'laktoza') {
  //           let filteredIds = odabraneNamirnice.filter(id => !laktozaListId.includes(id));
  //           setOdabraneNamirnice(filteredIds);
  //           setPopupContentAle(laktozaList);
  //           setShowPopupAle(true);
  //         }
  //       } else {
  //         alert("Unesite ishranu");
  //       }
  //       return [...prev, type];
  //     }
  //   });
  // };

  //Provera
  // useEffect(()=>{
  //   console.log('odabraneNamirnice state: ', odabraneNamirnice);
  //   console.log('grupisaneNamirnice state: ', grupisaneNamirnice);
  // },[odabraneNamirnice])

  const closePopupAle = () => {
    setShowPopupAle(false);
    setPopupContentAle([]);
  };

  const handleOutsideClickAle = (event) => {
    if (event.target.className.includes("overlay")) {
      closePopupAle();
    }
  };

  // const renderSelectedItems = () => {
  //   const items = [];
  //   if (selectedAllergies.includes('gluten')) {
  //     items.push(
  //       'Pšenica',
  //       'Ječam',
  //       'Ovas',
  //       'Raž',
  //       'Spelta',
  //       'Hleb od celovitog zrna',
  //       'Integralna testenina',
  //       'Ovsena kaša',
  //       'Beli hleb',
  //       'Obična testenina',
  //       'Keks',
  //       'Kolač'
  //     );
  //   }
  //   if (selectedAllergies.includes('laktoza')) {
  //     items.push(
  //       'Kravlje mleko',
  //       'Jogurt',
  //       'Grčki jogurt',
  //       'Voćni jogurt',
  //       'Gauda',
  //       'Edamer',
  //       'Feta',
  //       'Parmezan',
  //       'Mozzarela',
  //       'Rikota',
  //       'Kefir',
  //       'Kiselo mleko',
  //       'Kisela pavlaka',
  //       'Slatka pavlaka'
  //     );
  //   }
  //   return items.length > 0 ? (
  //     <ul className="list-disc pl-5 mt-2">
  //       {items.map((item, index) => (
  //         <li key={index}>{item}</li>
  //       ))}
  //     </ul>
  //   ) : (
  //     <p className="text-gray-600 mt-2">Nema izabranih namirnica.</p>
  //   );
  // };
  const [errors, setErrors] = useState({});

  //Update intolerancije
  const posaljiIntolerancije = async () => {
    const headers = new Headers();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    headers.set("Content-Type", "application/json");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/updateIntolerancija/${id}`,
        {
          method: "PATCH",
          headers: headers,
          body: JSON.stringify(selectedAllergies),
          credentials: "include",
        }
      );

      if (response.ok) {
        const data = await response.json();

        // setOdabraneNamirnice(data.neodabraneNamirnice); //Obrnuo sam

        // console.log("Uspešan odgovor:", data);
      } else {
        console.error("Greška u odgovoru:", response.status);
      }
    } catch (error) {
      console.error("Greška pri slanju zahteva:", error);
    }
  };

  //Update intolernacije
  useEffect(() => {
    // console.log("selectedAllergies: ", selectedAllergies); //['gluten', i/ili 'laktoza']
    posaljiIntolerancije();
  }, [selectedAllergies]);

  const validate = () => {
    const newErrors = {};

    // Provera imena
    if (!name) newErrors.name = "Ime je obavezno";

    // Provera prezimena
    if (!lastname) newErrors.lastname = "Prezime je obavezno";

    // Provera datuma rođenja
    if (!datumRodjenja) newErrors.datumRodjenja = "Datum rođenja je obavezan";

    // Provera pola
    if (!pol) newErrors.pol = "Pol je obavezan";

    // Provera težine
    if (!tezina || isNaN(tezina)) newErrors.tezina = "Težina je obavezna";

    // Provera visine
    if (!visina || isNaN(visina)) newErrors.visina = "Visina je obavezna";

    setErrors(newErrors);

    // Ako nema grešaka, vrati true za slanje forme
    return Object.keys(newErrors).length === 0;
  };

  //Cuva podatke novog usera i postavlja navigation ekran
  const handleSubmit = async (e) => {
    // e.preventDefault();

    if (validate()) {
      const formData = {
        id,
        name,
        lastname,
        datumRodjenja,
        pol,
        tezina,
        visina,
        wellcome: "1",
        datumRegistracije: formatDate(),
      };

      const headers = new Headers();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/initalUpdate/${id}`,
          {
            method: "POST",
            headers: headers,
            body: JSON.stringify(formData),
          }
        );

        if (response.ok) {
          alert("Podaci sačuvani");
          // setHighlighted(true);
          // toggleHighlight(); //Nepotrebano za ovaj nacin
          setWellcome("1"); // Update state on success
          window.location.reload();
        } else {
          alert("Nije uspelo čuvanje");
        }
      } catch (error) {
        alert("Nije uspelo čuvanje!");
        console.error(error);
      }
    }
  };

  //Salje verifikaciju ponovo
  const sendPotvrduPonovo = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/reTokenizer`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ mail, id }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        console.log("Email uspešno poslat, proverite Vaš mail", data.message);
        alert("Email uspešno poslat, proverite Vaš mail", data.message);
        profile();
      } else {
        console.error("Greška:", data.message);
        alert("Greška:", data.message);
      }
    } catch (error) {
      console.error("Došlo je do greške pri slanju zahteva:", error);
    }
  };

  function getAllergenNamesString(allergenIds) {
    const allergenNames = Object.keys(allergenIds)
      .filter((id) => allergenIds[id])
      .map((id) => {
        const allergen = allergens.find((a) => a.id === id);
        return allergen ? allergen.name : null;
      })
      .filter((name) => name !== null);

    return allergenNames.join(", ");
  }

  const handleOkClick = () => {
    // console.log("Alergeni su odabrani:", selectedAllergens);
    // console.log("Name: ", getAllergenNames(selectedAllergens));

    // console.log("selectedAllergenNames: ", selectedAllergenNames);
    closeModalAlr();
  };

  const [klijentData, setKlijentData] = useState(null); // Stanje za klijentData
  const [showPreview, setShowPreview] = useState(false); // Stanje za prikazivanje modal-a ili preview-a

  // Prikaz klijentovih podataka iz pdf-a
  const preiewData = (data) => {
    setKlijentData(data.klijentData);
    setShowPreview(true);
  };

  const capitalizeFirstLetter = (text) => {
    return text
      .split(", ")
      .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
      .join(", ");
  };

  const gageCalc = () => {
    // console.log("bmi => ", bmi);
    let bmi_ = parseInt(bmi);
    if (bmi_ < 18.5) return 0.1; // Ispod težine
    if (bmi_ >= 18.5 && bmi_ <= 24.9) return 0.3; // Normalna težina
    if (bmi_ >= 25 && bmi_ <= 29.9) return 0.5; // Prekomerna težina
    if (bmi_ >= 30 && bmi_ <= 34.9) return 0.7; // Gojaznost Klasa I
    if (bmi_ >= 35 && bmi_ <= 39.9) return 0.85; // Gojaznost Klasa II
    return 1.0; // Gojaznost Klasa III
  };

  //Becka => tartar, kupus, kecap

  const nivoiFizickihAktivnosti = {
    sedentarni: {
      naziv: "Sedentaran",
      faktorAktivnosti: 1.2,
    },
    laganaAktivnost: {
      naziv: "Lagano aktivan",
      faktorAktivnosti: 1.375,
    },
    umerenaAktivnost: {
      naziv: "Umereno aktivan",
      faktorAktivnosti: 1.55,
    },
    intenzivnaAktivnost: {
      naziv: "Veoma aktivan",
      faktorAktivnosti: 1.725,
    },
    vrloIntenzivnaAktivnost: {
      naziv: "Ekstremno aktivan",
      faktorAktivnosti: 1.9,
    },
  };

  function getNivoFizickeAktivnosti(faktorAktivnosti) {
    if (typeof faktorAktivnosti === "string") {
      faktorAktivnosti = parseFloat(faktorAktivnosti);
    }
    for (let nivo in nivoiFizickihAktivnosti) {
      if (nivoiFizickihAktivnosti[nivo].faktorAktivnosti === faktorAktivnosti) {
        return nivoiFizickihAktivnosti[nivo].naziv;
      }
    }
    return "Nepoznat nivo aktivnosti"; // Ako faktor aktivnosti nije pronađen
  }

  //Provera bmi
  // useEffect(() => {
  //   console.log("bmi => ", typeof bmi);
  // }, [bmi]);

  //Verifikovanje
  // const verifikuj = async (e) => {
  //   e.preventDefault();

  //     const headers = new Headers();
  //     if (token) {
  //       headers.set("Authorization", `Bearer ${token}`);
  //     }
  //     headers.set("Content-Type", "application/json");

  //     const verificationToken = jwt.sign(
  //       { userId: user._id },
  //       process.env.REACT_APP_JWT_SECRET,
  //       { expiresIn: "1h" }
  //     );

  //     try {
  //       const response = await fetch(`https://nutritrans.rs:5000/verify-email?token=${verificationToken}`, {
  //         method: 'GET',
  //         headers: headers,
  //       });

  //       if (response.ok) {
  //         alert('Uspelo');
  //         // setIsVerified(true);
  //       } else {
  //         alert('Nije uspelo');
  //       }
  //     } catch (error) {
  //       alert('Nije uspelo!');
  //       console.error(error);
  //     }

  // };

  // <div className="flex">
  //   <div className="w-[70%] p-3 m-2 border-solid border rounded-md border-grey-100">

  //   </div>
  //   <div className="w-[30%] p-2 m-2 border-solid border rounded-md border-grey-100">

  //   </div>
  // </div>

  const kbitsToMbits = (value) => {
    if (value >= 1000) {
      value = value / 1000;
      if (Number.isInteger(value)) {
        return value.toFixed(0) + " mbit/s";
      } else {
        return value.toFixed(1) + " mbit/s";
      }
    } else {
      return value.toFixed(0) + " kbit/s";
    }
  };

  //Ovo je da bi se izbegao onaj error sa window.history - work shere
  let updateStuff = () => {
    setHighlighted(false); //Postavljamo state
    saveDataToDatabase(); //Saljemo podatke na cuvanje
    window.location.reload(); //Rrfresh starnice da bi izbegli error sa brisanjem podataka
  };

  let dashboard_ = (
    <>
      <div className="flex flex-col sm:flex-row">
        {/* Lični Podaci */}
        <div className="w-full sm:w-[33%] m-2 border-solid flex flex-col justify-between h-full">
          {/* Gornji div - Video */}
          <div className="border-solid border rounded-md border-black p-3">
            <div className="relative w-full pb-[56.25%] h-0 overflow-hidden rounded-md">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/s9pDhThgk74?si=asofXeDnSc00miWw"
                title="YouTube video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          {/* Donji div - Poslednji izveštaji */}
          <div className="border-solid border rounded-md border-black mt-2 p-3">
            <div className="flex justify-between items-center">
              <h4 className="text-base font-semibold text-gray-900">
                Primer izveštaja
              </h4>
              {/* <button
                className="ml-4 px-4 py-1 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none"
                // onClick={() => setSelectedDiv("PlanoviIshrane")}
              >
                Pogledaj
              </button> */}
            </div>

            <div className="pt-4">
              {defaultPDF.length === 0 ? (
                <div className="text-gray-500">Nema dostupnih fajlova.</div>
              ) : (
                <ul
                  role="list"
                  className="divide-y divide-gray-100 rounded-md border border-gray-200"
                >
                  {defaultPDF.map((file, index) => (
                    <div
                      className="bg-white shadow sm:rounded-lg"
                      key={new Date().getMilliseconds()}
                    >
                      <div className="px-3 py-3 sm:p-3">
                        <div className="sm:flex sm:items-start sm:justify-between">
                          <div>
                            <div className="max-w-xl text-sm text-dark">
                              <span className="font-medium">
                                {file?.datumKreir} -{" "}
                                {file?.vreme ? file?.vreme.slice(0, 5) : ""}{" "}
                              </span>
                              <span className="font-medium">
                                {file?.title}{" "}
                              </span>
                              <span className="font-medium">
                                - {file?.tip} dana
                              </span>
                            </div>
                          </div>
                          <div className="mt-5 sm:ml-6 sm:mt-0 sm:flex sm:shrink-0 sm:items-center">
                            <button
                              className="text-blue-600 hover:text-blue-800"
                              onClick={() => showPdfTwo(file.pdf)}
                            >
                              <EyeIcon className="h-5 w-5" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>

        <div className="w-full sm:w-[33%] p-3 m-2 border-solid border rounded-md border-black">
          <div className="flex justify-between items-center">
            <h4 className="text-base font-semibold text-gray-900">
              Lični Podaci
            </h4>
            <button
              className="ml-4 px-4 py-1 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none"
              onClick={() => setSelectedDiv("OsnovniPodaci")}
            >
              Svi podaci
            </button>
          </div>

          <div className="mt-4 border-t border-gray-100">
            <dl className="divide-y divide-gray-100">
              {[
                { label: "Ime", value: name ?? "Nema imena" },
                { label: "Prezime", value: lastname ?? "Nema prezimena" },
                { label: "Email", value: mail ?? "Nema emaila" },
                { label: "Telefon", value: telefon ?? "Nema broja telefona" },
                {
                  label: "Pol",
                  value:
                    pol === "muski"
                      ? "Muški"
                      : pol === "zenski"
                      ? "Ženski"
                      : "Nema pola",
                },
                {
                  label: "Datum rođenja",
                  value: datumRodjenja ?? "Nema datuma rođenja",
                },
                {
                  label: "Težina",
                  value: tezina ? `${tezina} kg` : "Nema težine",
                },
                {
                  label: "Visina",
                  value: visina ? `${visina} cm` : "Nema visine",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0"
                >
                  <dt className="text-sm font-medium text-gray-900">
                    {item.label}
                  </dt>
                  <dd className="mt-1 text-sm text-gray-700 sm:col-span-2 sm:mt-0">
                    {item.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>

        {/* BMI i Poslednji izveštaji */}
        <div className="w-full sm:w-[33%] m-2 border-solid flex flex-col justify-between h-full">
          {/* Gornji div - Poslednji izveštaji */}
          <div className="border-solid border rounded-md border-black mb-2 p-3">
            <div className="flex justify-between items-center">
              <h4 className="text-base font-semibold text-gray-900">
                Poslednji izveštaj
              </h4>
              <button
                className="ml-4 px-4 py-1 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none"
                onClick={() => setSelectedDiv("PlanoviIshrane")}
              >
                Svi planovi
              </button>
            </div>

            <div className="pt-4">
              {allImageTwo.length === 0 ? (
                <div className="text-gray-500">Nema dostupnih fajlova.</div>
              ) : (
                <ul
                  role="list"
                  className="divide-y divide-gray-100 rounded-md border border-gray-200"
                >
                  {allImageTwo.map((file, index) => (
                    // <li
                    //   key={index}
                    //   className="flex items-center justify-between py-4 pl-4 pr-5 text-sm"
                    // >
                    //   <div className="flex w-0 flex-1 items-center">
                    //     <PaperClipIcon
                    //       aria-hidden="true"
                    //       className="size-5 shrink-0 text-gray-400"
                    //     />
                    //     <div className="ml-4 flex min-w-0 flex-1 gap-2">
                    //       <span className="truncate font-medium">
                    //         {file?.datumKreir} -{" "}
                    //         {file?.datumKreir
                    //           ? file?.datumKreir.slice(0, 6)
                    //           : ""}
                    //         {file?.vreme ? file?.vreme.slice(0, 5) : ""}
                    //       </span>
                    //       <span className="truncate font-medium">
                    //         {file?.title}
                    //       </span>
                    //       <span className="truncate font-medium">
                    //         - Plan ishrane za: {file?.tip} dana
                    //       </span>
                    //       <span className="truncate font-medium">
                    //         - {file?.tip} D
                    //       </span>
                    //     </div>
                    //   </div>
                    //   <div className="ml-4 shrink-0">
                    //     <button
                    //       className="text-blue-600 hover:text-blue-800"
                    //       onClick={() => showPdfTwo(file.pdf)}
                    //     >
                    //       <EyeIcon className="h-5 w-5" aria-hidden="true" />
                    //     </button>
                    //   </div>
                    // </li>

                    // <li
                    //   key={index}
                    //   className="flex items-center justify-between py-4 pl-4 pr-5 text-sm"
                    // >
                    //   <div className="flex w-0 flex-1 items-center">
                    //     <PaperClipIcon
                    //       aria-hidden="true"
                    //       className="size-5 shrink-0 text-gray-400"
                    //     />
                    //     <div className="ml-4 flex min-w-0 flex-1 gap-2">
                    //       <span className="font-medium">
                    //         {file?.datumKreir} -{" "}
                    //         {file?.vreme ? file?.vreme.slice(0, 5) : ""}
                    //       </span>
                    //       <span className="font-medium">{file?.title}</span>
                    //       <span className="font-medium">
                    //         - {file?.tip} dana
                    //       </span>
                    //     </div>
                    //   </div>
                    //   <div className="ml-4 shrink-0">
                    // <button
                    //   className="text-blue-600 hover:text-blue-800"
                    //   onClick={() => showPdfTwo(file.pdf)}
                    // >
                    //   <EyeIcon className="h-5 w-5" aria-hidden="true" />
                    // </button>
                    //   </div>
                    // </li>

                    <div
                      className="bg-white shadow sm:rounded-lg"
                      key={new Date().getMilliseconds()}
                    >
                      <div className="px-3 py-3 sm:p-3">
                        <div className="sm:flex sm:items-start sm:justify-between">
                          <div>
                            <div className="max-w-xl text-sm text-dark">
                              <span className="font-medium">
                                {file?.datumKreir} -{" "}
                                {file?.vreme ? file?.vreme.slice(0, 5) : ""}{" "}
                              </span>
                              <span className="font-medium">
                                {file?.title}{" "}
                              </span>
                              <span className="font-medium">
                                - {file?.tip} dana
                              </span>
                            </div>
                          </div>
                          <div className="mt-5 sm:ml-6 sm:mt-0 sm:flex sm:shrink-0 sm:items-center">
                            <button
                              className="text-blue-600 hover:text-blue-800"
                              onClick={() => showPdfTwo(file.pdf)}
                            >
                              <EyeIcon className="h-5 w-5" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </ul>
              )}
            </div>
          </div>

          {/* Test dugme za highlight */}
          {/* <button
            onClick={toggleHighlight}
            style={{
              padding: "20px",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              zIndex: 2,
              position: "relative",
              backgroundColor: highlighted ? "#f1f1f1" : "white",
              boxShadow: highlighted
                ? "0px 8px 15px rgba(0, 0, 0, 0.1)"
                : "none",
              transition: "all 0.3s ease",
            }}
          >
            {highlighted ? "Remove Highlight" : "Highlight"}
          </button> */}

          <div className="border-solid border rounded-md border-black p-3">
            <h4 className="text-base font-semibold text-gray-900">BMI</h4>
            <div className="flex flex-col items-center mt-8">
              <h2 className="text-2xl font-semibold text-gray-800 text-center">
                Tvoj BMI: <span className="text-blue-600">{bmi} kg/m²</span>
              </h2>
              {/* <div className="relative w-64 h-64 mt-6 flex justify-center"> */}
              <BMIChartJS bmiValue={bmi} />

              {/* Bio je ovaj */}
              {/* <GaugeChart
                id="gauge-chart"
                percent={gageCalc()} // Procenat prema BMI vrednosti
                nrOfLevels={6} // 6 nivoa boja
                colors={[
                  "#1E90FF",
                  "#32CD32",
                  "#F8E152",
                  "#FFA500",
                  "#FF4500",
                  "#A659F5",
                ]} // 6 boja
                arcWidth={0.3}
                hideText={true}
                animate={true} 
              /> */}

              {/* <PieChart width={300} height={150}>
                <Pie
                  dataKey="value"
                  startAngle={180}
                  endAngle={0}
                  data={categories}
                  cx={cx}
                  cy={cy}
                  innerRadius={iR}
                  outerRadius={oR}
                  fill="#8884d8"
                  stroke="none"
                >
                  {categories.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                {needle(bmiValue, categories, cx, cy, iR, oR, "#d0d000")}
              </PieChart> */}

              {/* </div> */}
              {/* Tacke za gauge - BILO JE UKLJUCENO */}
              <div className="flex flex-wrap justify-center w-full mt-6 text-sm font-medium gap-x-4 gap-y-4">
                {[
                  {
                    textcolor: "text-blue-500",
                    color: "bg-blue-500",
                    label: "Ispod težine",
                  },
                  {
                    textcolor: "text-green-500",
                    color: "bg-green-500",
                    label: "Normalna težina",
                  },
                  {
                    textcolor: "text-yellow-500",
                    color: "bg-yellow-300",
                    label: "Prekomerna težina",
                  },
                  {
                    textcolor: "text-orange-500",
                    color: "bg-orange-500",
                    label: "Gojaznost, Klasa I",
                  },
                  {
                    textcolor: "text-red-500",
                    color: "bg-red-500",
                    label: "Gojaznost, Klasa II",
                  },
                  {
                    textcolor: "text-purple-500",
                    color: "bg-purple-500",
                    label: "Gojaznost, Klasa III",
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-center mx-2 w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/4 xl:w-1/4"
                  >
                    <div
                      className={`w-6 h-6 ${item.color} rounded-full mb-2`}
                    ></div>
                    <span className={`${item.textcolor} mt-1 text-center`}>
                      {item.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* <div className="border-solid border rounded-md border-black p-3">
            <h4 className="text-base font-semibold text-gray-900">BMI</h4>
            <div className="flex flex-col items-center mt-8">
              <h2 className="text-2xl font-semibold text-gray-800">
                Tvoj BMI: <span className="text-blue-600">{bmi} kg/m²</span>
              </h2>
              <div className="relative w-64 h-32">
                <PieChart width={400} height={500}>
                  <Pie
                    dataKey="value"
                    startAngle={180}
                    endAngle={0}
                    data={categories}
                    cx={cx}
                    cy={cy}
                    innerRadius={iR}
                    outerRadius={oR}
                    fill="#8884d8"
                    stroke="none"
                  >
                    {categories.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  {needle(bmiValue, categories, cx, cy, iR, oR, "#d0d000")}
                </PieChart>
              </div>

              <div className="flex flex-wrap justify-center w-full mt-4 text-sm font-medium gap-x-4 gap-y-4">
                {[
                  {
                    textcolor: "text-blue-500",
                    color: "bg-blue-500",
                    label: "Ispod težine",
                  },
                  {
                    textcolor: "text-green-500",
                    color: "bg-green-500",
                    label: "Normalna težina",
                  },
                  {
                    textcolor: "text-yellow-500",
                    color: "bg-yellow-300",
                    label: "Prekomerna težina",
                  },
                  {
                    textcolor: "text-orange-500",
                    color: "bg-orange-500",
                    label: "Gojaznost, Klasa I",
                  },
                  {
                    textcolor: "text-red-500",
                    color: "bg-red-500",
                    label: "Gojaznost, Klasa II",
                  },
                  {
                    textcolor: "text-purple-500",
                    color: "bg-purple-500",
                    label: "Gojaznost, Klasa III",
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-center mx-1 w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/4 xl:w-1/4"
                  >
                    <div
                      className={`w-6 h-6 ${item.color} rounded-full mb-2`}
                    ></div>
                    <span className={`${item.textcolor} mt-1 text-center`}>
                      {item.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );

  const tailwindContent = (
    <div className="grid grid-cols-1 gap-y-3 md:grid-cols-1">
      <form className="">
        <div className="px-3 py-3 sm:p-3">
          <div className="grid w-full grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
            <div className="sm:col-span-1">
              <label
                htmlFor="name"
                className="block text-lg font-medium leading-6 text-gray-900"
              >
                Ime
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="last-name"
                  id="last-name"
                  value={name}
                  onChange={onNameChanged}
                  autoComplete="family-name"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="last-name"
                className="block text-lg font-medium leading-6 text-gray-900"
              >
                Prezime
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="last-name"
                  id="last-name"
                  value={lastname}
                  onChange={onLastNameChanged}
                  autoComplete="family-name"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="mail"
                className="block text-lg font-medium leading-6 text-gray-900"
              >
                Mail
              </label>
              <div className="mt-1 flex items-center">
                <input
                  type="text"
                  name="mail"
                  id="mail"
                  value={mail}
                  onChange={onMailChanged}
                  autoComplete="mail"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
                <label className="flex items-center ml-3">
                  <input
                    type="checkbox"
                    onChange={handleCheckboxChange}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-gray-900">Pošta</span>
                </label>
              </div>

              {showPopup && (
                <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
                  <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
                    <div className="mt-3 text-center">
                      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                        <svg
                          className="h-6 w-6 text-yellow-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                          />
                        </svg>
                      </div>
                      <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                        Upoznorenje
                      </h3>
                      <div className="mt-2 px-7 py-3">
                        <p className="text-sm text-gray-500">{popupMessage}</p>
                      </div>
                      <div className="items-center px-4 py-3">
                        <button
                          onClick={closeModalPosta}
                          className="mt-3 px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                        >
                          Zatvori
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="telefon"
                className="block text-lg font-medium leading-6 text-gray-900"
              >
                Telefon
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="telefon"
                  id="telefon"
                  value={telefon}
                  onChange={onTelefonChanged}
                  autoComplete="telefon"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="datumRodjenja"
                className="block text-lg font-medium leading-6 text-gray-900"
              >
                Datum Rodjenja
              </label>
              <div className="mt-1">
                <input
                  type="date"
                  name="datumRodjenja"
                  id="datumRodjenja"
                  value={datumRodjenja}
                  onChange={onDatumRodjenjaChanged}
                  autoComplete="off"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="pol"
                className="block text-lg font-medium leading-6 text-gray-900"
              >
                Pol
              </label>
              <div className="mt-1">
                <select
                  name="pol"
                  id="pol"
                  value={pol}
                  onChange={onPolChanged}
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                >
                  <option value="" disabled>
                    Select an option
                  </option>
                  <option value="zenski">Ženski</option>
                  <option value="muski">Muški</option>
                </select>
              </div>
            </div>

            {/*<div className="grid w-full grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-1">
              <div className="flex items-center justify-between">
                <div className="flex-1 mr-4">
                  <label
                    htmlFor="tezina"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Tezina
                  </label>
                  <input
                    type="text"
                    name="tezina"
                    id="tezina"
                    value={tezina}
                    onChange={onTezinaChanged}
                    autoComplete="tezina"
                    className="mt-1 block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div>

                 <div className="w-20">
                  <label
                    htmlFor="bmi"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    BMI
                  </label>
                  <input
                    readOnly 
                    type="text"
                    name="bmi"
                    id="bmi"
                    value={bmi}
                    onChange={onBmiChanged}
                    autoComplete="bmi"
                    placeholder="BMI"
                    className="mt-1 block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div> 
              </div>
            </div>*/}

            <div className="sm:col-span-1">
              <label
                htmlFor="tezina"
                className="block text-lg font-medium leading-6 text-gray-900"
              >
                Tezina
              </label>
              <input
                type="text"
                name="tezina"
                id="tezina"
                value={tezina}
                onChange={onTezinaChanged}
                autoComplete="tezina"
                className="mt-1 block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              />
            </div>

            <div className="sm:col-span-1">
              <label
                htmlFor="pol"
                className="block text-lg font-medium leading-6 text-gray-900"
              >
                Visina
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="visina"
                  id="visina"
                  value={visina}
                  onChange={onVisinaChanged}
                  autoComplete="visina"
                  className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className="space-y-2">
              <label
                htmlFor="slika"
                className="block text-lg font-medium leading-6 text-gray-900"
              >
                Izaberite novu sliku profila:
              </label>
              {/* <input
                type="file"
                label="Image"
                name="myFile"
                id="file-upload"
                accept=".jpeg, .png, .jpg"
                onChange={handleFileUpload}
              /> */}
              <input
                type="file"
                onChange={handleUpload}
                className="border p-2 rounded"
              />
            </div>
          </div>
        </div>

        {/* <div className="flex items-center justify-end gap-x-2 border-t border-gray-900/10 px-2 py-2 sm:px-2">
          <button
            onClick={handleConfirmIzmena}
            className="rounded bg-blue-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
            Sačuvaj
          </button>
        </div> */}

        {/* <label>Tdee: {tdee}</label>
        <br/>
        <label>Bmr: {bmrValue}</label>
        <br/>
        <label>Nivo akt: {activityLevel}</label>
        <br/>
        <label>Ukupna: {ukupnaKalVred}</label>
        <br/>
        <label>Primcilj: {primcilj}</label> */}
      </form>

      {/* <div className="">
        <label
          htmlFor="about"
          className="block text-lg font-medium leading-6 text-gray-900 sm:pt-1.5"
        >
          Odgovor
        </label>
        <div className="">
          <textarea
            id="about"
            name="about"
            value={odg}
            rows={3}
            style={{ height: "350px", overflowY: "auto" }}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
            defaultValue={""}
          />
        </div>
      </div> */}
    </div>
  );

  let ishranaForm = (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {/* Kolona 1 */}
      <div className="">
        {/* <h3 className="text-sm font-medium leading-6 text-gray-900 whitespace-nowrap">Izaberite ishranu</h3> SELECT ZA TABELARNI PRIKAZ
        <select
            id="options"
            name="options"
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
            value={selectedIshrana}
            onChange={handleIshranaSelect}>
            {ishrane.map((ishrana) => (
                <option key={ishrana._id} value={ishrana._id}>
                    {ishrana.naziv}
                </option>
            ))}
        </select> */}

        {/* SELECT ZA TABELARNI PRIKAZ */}
        <div className="flex items-center space-x-1 mb-2">
          <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap mb-0">
            Vaš stil ishrane
          </h3>
          <Tooltip text="Vaš stil ishrane utiče na namirnice" />
        </div>

        <select
          id="options"
          name="options"
          value={selectedIshrana}
          onChange={handleIshranaChange}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
        >
          {/* <option value="">Izaberi ishranu</option> */}
          {ishrane.map((ishrana) => (
            <option key={ishrana._id} value={ishrana._id}>
              {ishrana.naziv}
            </option>
          ))}
        </select>

        {/* Opis */}
        <div className="bg-yellow-100 text-yellow-800 p-2 text-center mt-4">
          {pronadjiKomentar(selectedIshrana)}
        </div>

        <div className="flex items-center space-x-1 my-2">
          <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap mb-0">
            Broj obroka dnevno
          </h3>
          <Tooltip text="Odaberite koliko puta dnevno želite da jedete." />
        </div>

        <select
          id="ucestObr"
          name="ucestObr"
          value={ucestObr}
          onChange={onUcestObrChange}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
        >
          <option value="doručak, ručak">Doručak, Ručak</option>
          <option value="doručak, večera">Doručak, Večera</option>
          <option value="ručak, večera">Ručak, Večera</option>
          <option value="doručak, ručak, večera" defaultChecked>
            Doručak, Ručak, Večera
          </option>
          <option value="doručak, užina1, ručak, večera">
            Doručak, Užina, Ručak, Večera
          </option>
          <option value="doručak, užina1, ručak, užina2, večera">
            Doručak, Užina, Ručak, Užina, Večera
          </option>
          {/* <option value="doručak, ručak">Doručak, Ručak</option>
          <option value="doručak, večera">Doručak, Večera</option>
          <option value="ručak, večera">Ručak, Večera</option>
          <option value="doručak, ručak, večera" defaultChecked>Doručak, Ručak, Večera</option>
          <option value="doručak, užina, ručak, večera">Doručak, Užina, Ručak, Večera</option>
          <option value="doručak, užina, ručak, užina, večera">Doručak, Užina, Ručak, Užina, Večera</option> */}
        </select>

        {/* <option value="doručak, ručak">Doručak, Ručak</option>
        <option value="doručak, večera">Doručak, Večera</option>
        <option value="ručak, večera">Ručak, Večera</option>
        <option value="doručak, ručak, večera" defaultChecked>Doručak, Ručak, Večera</option>
        <option value="doručak, užina, ručak, večera">Doručak, Užina, Ručak, Večera</option>
        <option value="doručak, užina, ručak, užina, večera">Doručak, Užina, Ručak, Užina, Večera</option> */}

        {/* 
        ručak
        doručak, ručak
        doručak, večera
        ručak, večera
        doručak, ručak, večera
        doručak, užina, ručak, večera
        doručak, užina, ručak, užina, večera

        doc.font("OpenSans_Condensed-Regular").text(newData.ucestBr);
        
        */}

        <div className="flex items-center space-x-1 my-2">
          <label
            htmlFor="navike"
            className="block text-lg font-medium leading-6 text-gray-900 sm:pt-1.5"
          >
            Opis navika u ishrani
          </label>
          <Tooltip text="Unesite informacije o svojim svakodnevnim prehrambenim navikama." />
        </div>

        <div>
          <textarea
            id="navike"
            name="navike"
            value={navike}
            onChange={handleNavikeChange}
            rows={3}
            style={{ height: "150px", overflowY: "auto" }}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
          />
        </div>

        <div className="flex items-center space-x-1 my-2">
          <label
            htmlFor="iskSaDijetama"
            className="block text-lg font-medium leading-6 text-gray-900 sm:pt-1.5"
          >
            Vaša iskustva sa dijetama
          </label>
          <Tooltip text=" Podelite svoja iskustva sa prethodnim dijetama kako bismo bolje razumeli vaše potrebe." />
        </div>

        <div>
          <textarea
            id="iskSaDijetama"
            name="iskSaDijetama"
            value={iskSaDijetama}
            onChange={handleIskSaDijetamaChange}
            rows={3}
            style={{ height: "150px", overflowY: "auto" }}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>

      {/* Kolona 2 */}
      <div className="">
        <div className="flex items-center space-x-1">
          <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap mb-0">
            Konzumirate li alkohol?
          </h3>
          <Tooltip text="Označite da li konzumirate alkohol („Da“ ili „Ne“)." />
        </div>

        <div className="flex items-center space-x-4">
          <label>
            <input
              type="radio"
              name="alkohol"
              value="da"
              checked={alkohol === "da"}
              onChange={handleAlkoholChange}
              className="mr-2"
            />
            Da
          </label>
          <label>
            <input
              type="radio"
              name="alkohol"
              value="ne"
              checked={alkohol === "ne"}
              onChange={handleAlkoholChange}
              className="mr-2"
            />
            Ne
          </label>
        </div>

        {alkohol === "da" && (
          <div className="flex items-center space-x-4 my-4">
            <div>
              <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                Vrsta alkohola
              </h3>
              <select
                id="vrstAlk"
                name="vrstAlk"
                value={vrstaAlkohola}
                onChange={handleVrstaAlkoholaChange}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              >
                <option value="">Izabrite alkohol</option>
                <option value="pivo">Pivo</option>
                <option value="vino">Vino</option>
                <option value="žestina">Žestina</option>
              </select>
            </div>

            <div>
              <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
                Količina
              </h3>
              <select
                id="vrstAlkKol"
                name="vrstAlkKol"
                value={kolicina}
                onChange={handleKolicinaChange}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              >
                <option value="">Izabrite količinu</option>
                <option value="1">1 čaša</option>
                <option value="2 do 4">2 - 4 čaše</option>
                <option value="5 čaša nedeljno">5 čaša nedeljno</option>
              </select>
            </div>
          </div>
        )}

        <div className="flex items-center space-x-1">
          <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap mb-0">
            Pušite li?
          </h3>
          <Tooltip text="Označite da li pušite („Da“ ili „Ne“)." />
        </div>

        <div className="flex items-center space-x-4">
          <label>
            <input
              type="radio"
              name="smoking"
              value="da"
              checked={smoking === "da"}
              onChange={handleSmokingChange}
              className="mr-2"
            />
            Da
          </label>
          <label>
            <input
              type="radio"
              name="smoking"
              value="ne"
              checked={smoking === "ne"}
              onChange={handleSmokingChange}
              className="mr-2"
            />
            Ne
          </label>
        </div>

        {smoking === "da" && (
          <div className="mt-4">
            <label
              htmlFor="kolicinaCigara"
              className="block text-lg font-medium leading-6 text-gray-900"
            >
              Količina
            </label>
            <input
              id="kolicinaCigara"
              type="text"
              value={kolicinaCigara}
              onChange={handleKolicinaCigaraChange}
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
            />
          </div>
        )}

        {/* <div className="mt-4">
          <label
            htmlFor="voljeneNamirnice"
            className="block text-lg font-medium leading-6 text-gray-900"
          >
            Unesi namirnice koje volite (odvojite ih zarezom)
          </label>
          <input
            id="voljeneNamirnice"
            type="text"
            value={voljeneNamirnice}
            onChange={handleVoljeneNamirniceChange}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
          />
        </div>

        <div className="mt-4">
          <label
            htmlFor="neVoljeneNamirnice"
            className="block text-lg font-medium leading-6 text-gray-900"
          >
            Unesi namirnice koje ne volite (odvojite ih zarezom)
          </label>
          <input
            id="neVoljeneNamirnice"
            type="text"
            value={neVoljeneNamirnice}
            onChange={handleNeVoljeneNamirniceChange}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
          />
        </div> */}

        <div className="flex items-top space-x-4 mt-4">
          {/* <div>
            
            
          <div className="flex items-center space-x-1">
            <h3 className="text-sm font-medium leading-6 text-gray-900 whitespace-nowrap">Alergije na hranu</h3>
            <Tooltip text="Označite ako imate neku intoleranciju." />
          </div>


            <select
              value={}
              onChange={}
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
              <option value="" defaultChecked>Izaberite</option>
              <option value="Gluten">Gluten</option>
              <option value="Laktoza">Laktoza</option>
            </select>
          </div> */}

          {/* <div>
          <div className="flex items-center space-x-1">
            <h3 className="text-sm font-medium leading-6 text-gray-900 whitespace-nowrap">Alergije na hranu</h3>
            <Tooltip text="Označite ako imate neku intoleranciju." />
          </div>
        
        <div>
          <label>
            <input
              type="checkbox"
              checked={selectedAllergies.includes('gluten')}
              onChange={() => handleCheckboxChangeAle('gluten')}
              className="mr-2"
            />
            Gluten
          </label>
        </div>
        
        <div>
          <label>
            <input
              type="checkbox"
              checked={selectedAllergies.includes('laktoza')}
              onChange={() => handleCheckboxChangeAle('laktoza')}
              className="mr-2"
            />
            Laktoza
          </label>
        </div>

        {renderSelectedItems()}

        {showPopupAle && (
          <div 
            className="fixed inset-0 flex items-center justify-center z-50 overlay bg-black bg-opacity-50" 
            onClick={handleOutsideClickAle}
          >
            <div className="bg-white p-5 rounded shadow-md">
              <h4 className="font-semibold mb-2">Namirnice koje sadrže:</h4>
              <ul className="list-disc pl-5">
                {popupContentAle.map((namirnica, index) => (
                  <li key={index}>{namirnica}</li>
                ))}
              </ul>
              <button onClick={closePopupAle} className="w-full mt-3 px-4 py-2 bg-[#66BB6A] text-white text-base font-medium rounded-lg flex-1 shadow-sm hover:bg-[#5FAE5C] transition duration-300 mr-2">
                Zatvori
              </button>
            </div>
          </div>
        )}
      </div> */}
          <div>
            <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap">
              Da li imate alergije na hranu?
            </h3>

            <div className="flex items-center space-x-4 mb-2">
              <label>
                <input
                  type="radio"
                  value="da"
                  checked={allergiesEnabled === "da"}
                  onChange={() => setAllergiesEnabled("da")}
                  className="mr-2"
                />
                Da
              </label>
              <label>
                <input
                  type="radio"
                  value="ne"
                  checked={allergiesEnabled === "ne"}
                  onChange={() => setAllergiesEnabled("ne")}
                  className="mr-2"
                />
                Ne
              </label>
            </div>

            {allergiesEnabled === "da" && (
              <div>
                {["gluten", "laktoza"].map((allergy) => (
                  <div key={allergy}>
                    <label>
                      <input
                        type="checkbox"
                        checked={selectedAllergies.includes(allergy)}
                        onChange={() => toggleAllergy(allergy)}
                        className="mr-2"
                      />
                      {/* {allergy.charAt(0).toUpperCase() + allergy.slice(1)} */}
                      {allergy === "gluten"
                        ? "Alergija na gluten"
                        : allergy === "laktoza"
                        ? "Intolerancija na laktozu"
                        : allergy.charAt(0).toUpperCase() + allergy.slice(1)}
                    </label>
                  </div>
                ))}

                {/* <div>
            <label>
              <input
                type="checkbox"
                checked={selectedAllergies.includes('gluten')}
                onChange={() => handleCheckboxChangeAle('gluten')}
                className="mr-2"
              />
              Gluten
            </label>
          </div>
          
          <div>
            <label>
              <input
                type="checkbox"
                checked={selectedAllergies.includes('laktoza')}
                onChange={() => handleCheckboxChangeAle('laktoza')}
                className="mr-2"
              />
              Laktoza
            </label>
          </div> */}
              </div>
            )}

            {showPopupAle && (
              <div
                className="fixed inset-0 flex items-center justify-center z-50 overlay bg-black bg-opacity-50"
                onClick={handleOutsideClickAle}
              >
                <div className="bg-white p-5 rounded shadow-md">
                  <h4 className="font-semibold mb-2">
                    Iz ishrane biće uklonjene ove namirnice:
                  </h4>
                  <ul className="list-disc pl-5">
                    {popupContentAle.map((namirnica, index) => (
                      <li key={index}>{namirnica}</li>
                    ))}
                  </ul>
                  <button
                    onClick={closePopupAle}
                    className="w-full mt-3 px-4 py-2 bg-[#66BB6A] text-white text-base font-medium rounded-lg flex-1 shadow-sm hover:bg-[#5FAE5C] transition duration-300 mr-2"
                  >
                    Zatvori
                  </button>
                </div>
              </div>
            )}
            {/* {showPopupAle && (
        <div 
          className="fixed inset-0 flex items-center justify-center z-50 overlay bg-black bg-opacity-50" 
          onClick={handleOutsideClickAle}
        >
          <div className="bg-white p-5 rounded shadow-md">
            <h4 className="font-semibold mb-2">Iz ishrane biće uklonjene ove naminice:</h4>
            <ul className="list-disc pl-5">
              {popupContentAle.map((namirnica, index) => (
                <li key={index}>{namirnica}</li>
              ))}
            </ul>
            <button onClick={closePopupAle} className="w-full mt-3 px-4 py-2 bg-[#66BB6A] text-white text-base font-medium rounded-lg flex-1 shadow-sm hover:bg-[#5FAE5C] transition duration-300 mr-2">
              Zatvori
            </button>
          </div>
        </div>
      )} */}
          </div>

          {/* <div>
            <h3 className="text-sm font-medium leading-6 text-gray-900 whitespace-nowrap">Alergeni na hranu</h3>
            <div className="flex space-x-4 mt-1">
              <label>
                <input
                  type="radio"
                  value="Da"
                  checked={algiNaHran === 'Da'}
                  onChange={handleAlgiNaHranChange}
                  className="mr-2"
                />
                Da
              </label>
              <label>
                <input
                  type="radio"
                  value="Ne"
                  checked={algiNaHran === 'Ne'}
                  onChange={handleAlgiNaHranChange}
                  className="mr-2"
                />
                Ne
            </label>
          </div>
        </div> */}
        </div>

        {/* {algNaHran === 'Gluten' && (
        <div className="mt-2 text-gray-700">
          Namirnice koje sadrže gluten su: Pšenica, Ječam, Ovas, Raž, Spelta, Hleb od celovitog zrna, Integralna Testenina, Ovsena kaša, Beli hleb, Obična testenina, Keks, Kolač.
        </div>
      )}

      {algNaHran === 'Laktoza' && (
        <div className="mt-2 text-gray-700">
          Namirnice koje sadrže laktozu su: Kravlje mleko, Jogurt, Grčki jogurt, Voćni jogurt, Gauda, Edamer, Feta, Parmezan, Mozzarela, Rikota, Kefir, Kiselo mleko, Kisela pavlaka, Slatka pavlaka.
        </div>
      )} */}

        {/* Ovaj je validan */}
        {/* <h3 className="text-sm font-medium leading-6 text-gray-900 whitespace-nowrap">Alergeni na hranu</h3>
      <label className="flex items-center mt-1 mb-4">
        <input type="checkbox" checked={algiNaHran} onChange={handleAlgiNaHranChange} className="mr-2"/>Da
      </label>

      {algiNaHran && (
        <div className="mt-4">
          <h4 className="text-sm font-medium leading-6 text-gray-900">Odaberite alergene:</h4>
          <table className="min-w-full border-collapse border border-gray-300">
            <tbody>
              {allergens.map((allergen) => (
                <tr key={allergen}>
                  <td className="border border-gray-300 px-2 py-1">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        name={allergen}
                        checked={selectedAllergens[allergen] || false}
                        onChange={handleAllergenChange}
                        className="mr-2"
                      />
                      {allergen}
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )} */}

        <div>
          <div className="flex items-center space-x-1 mt-2">
            <h3 className="text-lg font-medium leading-6 text-gray-900 whitespace-nowrap mb-0">
              Da li ste alergični na neku namirnicu?
            </h3>
            <Tooltip text="Dodajte listu namirnica koje izazivaju alergiju." />
          </div>

          {/* <div className="flex items-center space-x-4">
        <label>
          <input
            type="radio"
            name="allergy"
            value="yes"
            className="mr-2"
            onChange={() => handleRadioChange("yes")}
          />
          Da
        </label>
        <label>
          <input
            type="radio"
            name="allergy"
            value="no"
            className="mr-2"
            defaultChecked
            onChange={() => handleRadioChange("no")}
          />
          Ne
        </label>
      </div> */}
          <div className="flex items-center space-x-4">
            <label>
              <input
                type="radio"
                name="allergy"
                value="yes"
                className="mr-2"
                checked={allergyChoice === "yes"} // Da bi se označio radio dugme kada je odabrano "yes"
                onChange={() => handleRadioChange("yes")}
              />
              Da
            </label>
            <label>
              <input
                type="radio"
                name="allergy"
                value="no"
                className="mr-2"
                checked={allergyChoice === "no"} // Da bi se označio radio dugme kada je odabrano "no"
                onChange={() => handleRadioChange("no")}
              />
              Ne
            </label>
          </div>

          <p className="text-lg">
            Alergični ste na: {getAllergenNamesString(selectedAllergens)}
          </p>

          {modalOpenAlr && (
            <div
              className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75"
              onClick={closeModalAlr}
            >
              <div
                className="bg-white p-4 rounded shadow-lg max-h-96 overflow-y-auto w-96"
                onClick={(e) => e.stopPropagation()}
              >
                <h4 className="text-sm font-medium leading-6 text-gray-900">
                  Uklonite naminice koje sadrže alergen:
                </h4>
                <table className="min-w-full border-collapse border border-gray-300">
                  <tbody>
                    {allergens.map((allergen) => (
                      <tr key={allergen.id}>
                        <td className="border border-gray-300 px-2 py-1">
                          <label className="flex items-center">
                            <input
                              type="checkbox"
                              name={allergen.id}
                              checked={selectedAllergens[allergen.id] || false}
                              onChange={handleAllergenChange}
                              className="mr-2"
                            />
                            {allergen.name}
                          </label>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="mt-4 flex">
                  <button
                    onClick={handleOkClick}
                    className="mt-3 px-4 py-2 bg-[#66BB6A] text-white text-base font-medium rounded-lg flex-1 shadow-sm hover:bg-[#5FAE5C] transition duration-300 mr-2"
                  >
                    U redu
                  </button>
                  {/* <button
                onClick={closeModalAlr}
                className="mt-3 px-4 py-2 bg-blue-500 text-white text-base font-medium rounded-lg flex-1 shadow-sm hover:bg-blue-600 transition duration-300"
              >
                Zatvori
              </button> */}
                </div>
              </div>
            </div>
          )}

          {/* dugme za dodaju namirnice */}
          {isAllergic && (
            <div className="mt-4">
              <button
                onClick={() => setModalOpenAlr(true)}
                className="mt-3 px-4 py-2 bg-yellow-500 text-white font-medium rounded-lg shadow-sm hover:bg-yellow-600 transition duration-300"
              >
                Dodaj namirnicu
              </button>
            </div>
          )}

          {/* <div className="mt-4">
        <h4 className="text-sm font-medium leading-6 text-gray-900">Odabrane namirnice:</h4>
        <p>Ukupno odabranih: {odabraneNamirnice.length}</p>
        <ul>
          {odabraneNamirnice.length > 0 ? (
            odabraneNamirnice.map((id) => (
              <li key={id} className="mt-1">{id}</li>
            ))
          ) : (
            <li>Nema odabranih namirnica.</li>
          )}
        </ul>
      </div> */}
        </div>

        {/* <div>
        <h3 className="text-sm font-medium leading-6 text-gray-900 whitespace-nowrap">Alergeni na hranu</h3>
        <label className="flex items-center mt-1 mb-4">
          <input type="checkbox" checked={algiNaHran} onChange={handleAlgiNaHranChange} className="mr-2" />Da
        </label>

        {modalOpenAlr && (
          <div 
            className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 modal-backdrop"
            onClick={handleBackdropClickAlr}
          >
            <div className="bg-white p-4 rounded shadow-lg max-h-96 overflow-y-auto w-96">
              <h4 className="text-sm font-medium leading-6 text-gray-900">Odaberite alergene:</h4>
              <table className="min-w-full border-collapse border border-gray-300">
                <tbody>
                  {allergens.map((allergen) => (
                    <tr key={allergen}>
                      <td className="border border-gray-300 px-2 py-1">
                        <label className="flex items-center">
                          <input
                            type="checkbox"
                            name={allergen}
                            checked={selectedAllergens[allergen] || false}
                            onChange={handleAllergenChange}
                            className="mr-2"
                          />
                          {allergen}
                        </label>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="mt-4 flex">
                <button onClick={handleOkClick} className="mt-3 px-4 py-2 bg-[#66BB6A] text-white text-base font-medium rounded-lg flex-1 shadow-sm hover:bg-[#5FAE5C] transition duration-300 mr-2">
                  U redu
                </button>
                <button onClick={closeModalAlr} className="mt-3 px-4 py-2 bg-blue-500 text-white text-base font-medium rounded-lg flex-1 shadow-sm hover:bg-blue-600 transition duration-300">
                  Zatvori
                </button>
              </div>
            </div>
          </div>
        )}
    </div> */}

        {/* {algiNaHran && (
        <div className="mt-4">
          <h4 className="text-sm font-medium leading-6 text-gray-900">Odaberite alergene:</h4>
          <div className="flex flex-col space-y-2">
            {allergens.map((allergen) => (
              <label key={allergen} className="flex items-center">
                <input
                  type="checkbox"
                  name={allergen}
                  checked={selectedAllergens[allergen] || false}
                  onChange={handleAllergenChange}
                  className="mr-2"
                />
                {allergen}
              </label>
            ))}
          </div>
        </div>
      )} */}

        {/* <h3 className="text-sm font-medium leading-6 text-gray-900 whitespace-nowrap mt-4">Prehrambene intolerancije</h3>
        <label className="flex items-center mt-1">
          <input
            type="checkbox"
            checked={prehranIntol}
            onChange={handlePrehranIntolChange}
            className="mr-2"
          />
          Da
      </label> */}

        {isModalOpenIntol && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto">
            <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-5xl mx-4 max-h-[90vh] overflow-y-auto">
              {/* <button
              onClick={closeModalIntol}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 focus:outline-none text-2xl"
              style={{ width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              &times;
            </button> */}
              <h2 className="text-lg font-semibold mb-4 text-center">
                Intolerancija na hranu
              </h2>
              <p className="mb-2">
                Intolerancija je stanje u kojem organizam ne može adekvatno da
                svari određene namirnice. Za razliku od alergije, koja je
                imunološka reakcija, intolerancija je uzrokovana nedostatkom
                enzima ili drugim metaboličkim problemima.
              </p>
              <h4 className="font-medium mt-4">
                Šta se dešava prilikom intolerancije?
              </h4>
              <p className="mb-2">
                Kada osoba sa intolerancijom unese namirnicu na koju je
                intolerantna, organizam nema dovoljno enzima da je razgradi. To
                dovodi do različitih simptoma, koji mogu varirati od osobe do
                osobe i od namirnice do namirnice.
              </p>
              <h4 className="font-medium mt-4">Najčešći simptomi:</h4>
              <ul className="list-disc list-inside mb-4">
                <li>
                  Probavni problemi: nadimanje, gasovi, grčevi u stomaku,
                  dijareja, zatvor
                </li>
                <li>Kožni problemi: osip, ekcem</li>
                <li>Glavobolja, migrena</li>
                <li>Umor, malaksalost</li>
                <li>Problemi sa koncentracijom</li>
              </ul>
              <h4 className="font-medium mt-4">Najčešće intolerancije:</h4>
              <ul className="list-disc list-inside mb-4">
                <li>
                  Laktozna intolerancija: Nedostatak enzima laktaze koji
                  razgrađuje laktozu (mlečni šećer).
                </li>
                <li>
                  Gluten intolerancija (Celijakija): Autoimuna bolest u kojoj
                  organizam reaguje na gluten, protein koji se nalazi u pšenici,
                  ječmu i raži.
                </li>
                <li>
                  Fruktozna intolerancija: Poteškoće u varenju fruktoze,
                  jednostavnog šećera koji se nalazi u voću.
                </li>
                <li>
                  Histaminska intolerancija: Preosetljivost na histamin,
                  supstancu koja se nalazi u mnogim namirnicama.
                </li>
              </ul>
              {/* Button positioned below the text */}
              <div className="items-center px-4 py-3">
                <button
                  onClick={closeModalIntol}
                  className="px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                >
                  Zatvori
                </button>
              </div>
            </div>
          </div>
        )}

        {/* <div className="mt-4">
        <label
          htmlFor="neVoljeneNamirnice"
          className="block text-lg font-medium leading-6 text-gray-900">
          Prehrambene intolerancije (odvojite ih zarezom)
        </label>
        <input
          id="prehranIntol"
          type="text"
          // value={prehranIntol}
          // onChange={handlePrehranIntolChange}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
        />
      </div> */}
      </div>

      {/* </div> */}
    </div>
  );

  let ciljevi = (
    <div>
      <div className="flex items-center space-x-1">
        <label
          htmlFor="role"
          className="block text-lg font-medium leading-6 text-gray-900"
        >
          Osnovni ciljevi
        </label>
        <Tooltip text="Odaberite glavni cilj" />
      </div>

      <div className="mt-1">
        {isSuccessGetCiljevi ? (
          <select
            id="primcilj"
            name="primcilj"
            autoComplete="primcilj"
            value={primcilj}
            onChange={onPrimCiljChanged}
            className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600"
          >
            {getCiljeviData.ids.map((id) => (
              // Promeni naziv da updejtuje ceo objekat zbog linkovanja u bazi
              <option key={id} value={getCiljeviData.entities[id]?.naziv}>
                {getCiljeviData.entities[id]?.naziv}
              </option>
            ))}
          </select>
        ) : (
          <div>Učitavanje...</div>
        )}
      </div>

      {primcilj == "Mršavljenje" ? (
        <>
          {/* First Radio Group - Weight Loss Plans */}
          <div className="mb-6">
            {/* <button
              onClick={toggleButtonState1}
              className="mb-4 px-4 py-2 bg-blue-600 text-white rounded"
            >
              {areButtonsEnabled1 ? "Onemoguci" : "Omoguci"}
            </button> */}

            {/* <fieldset>
              <RadioGroup
                value={selectedMailingLists1}
                onChange={handleMailingListChange1}
                className="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-4 sm:gap-x-4"
              >
                {mailingLists1.map((mailingList) => (
                  <Radio
                    key={mailingList.id}
                    value={mailingList}
                    className={`group relative flex cursor-pointer rounded-lg p-3 shadow-sm transition-all duration-200
                          ${
                            areButtonsEnabled1 ||
                            mailingList.id === 1 ||
                            mailingList.id === 2 ||
                            mailingList.id === 3
                              ? "border border-gray-300 bg-white"
                              : "border border-gray-200 bg-gray-100 cursor-not-allowed"
                          }
                          focus:outline-none`}
                    disabled={
                      !areButtonsEnabled1 &&
                      mailingList.id !== 1 &&
                      mailingList.id !== 2 &&
                      mailingList.id !== 3
                    }
                  >
                    <span className="flex flex-1">
                      <span className="flex flex-col">
                        <span className="block text-sm font-medium text-gray-900">
                          {mailingList.title}
                        </span>
                        <span className="mt-1 flex items-center text-sm text-gray-500">
                          {mailingList.description}
                        </span>
                        <span className="mt-1 flex items-center text-sm text-gray-500">
                          {mailingList.ideal}
                        </span>
                        <span className="mt-6 text-sm font-medium text-gray-900">
                          {mailingList.users}
                        </span>
                      </span>
                    </span>
                    <CheckCircleIcon
                      aria-hidden="true"
                      className={`h-5 w-5 text-blue-600 ${
                        areButtonsEnabled1 || mailingList.id === 1
                          ? ""
                          : "invisible"
                      }`}
                    />
                    <span
                      aria-hidden="true"
                      className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent 
                            group-data-[focus]:border group-data-[checked]:border-blue-600"
                    />
                  </Radio>
                ))}
              </RadioGroup>
            </fieldset> work here  */}
            <fieldset>
              <RadioGroup
                value={selectedMailingLists1}
                onChange={handleMailingListChange1}
                className="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-4 sm:gap-x-4"
              >
                {mailingLists1.map((mailingList) => (
                  <Radio
                    key={mailingList.id}
                    value={mailingList}
                    className={`group relative flex cursor-pointer rounded-lg p-3 shadow-sm transition-all duration-200 ${
                      mailingList.id <= enabledButtonsCount1
                        ? "border border-gray-300 bg-white"
                        : "border border-gray-200 bg-gray-100 cursor-not-allowed"
                    } focus:outline-none`}
                    disabled={mailingList.id > enabledButtonsCount1}
                  >
                    <span className="flex flex-1">
                      <span className="flex flex-col">
                        <span className="block text-sm font-medium text-gray-900">
                          {mailingList.title}
                        </span>
                        <span className="mt-1 flex items-center text-sm text-gray-500">
                          {mailingList.description}
                        </span>
                        <span className="mt-1 flex items-center text-sm text-gray-500">
                          {mailingList.ideal}
                        </span>
                        <span className="mt-6 text-sm font-medium text-gray-900">
                          {mailingList.users}
                        </span>
                      </span>
                    </span>
                    <CheckCircleIcon
                      aria-hidden="true"
                      className={`h-5 w-5 text-blue-600 ${
                        mailingList.id <= enabledButtonsCount1
                          ? ""
                          : "invisible"
                      }`}
                    />
                    <span
                      aria-hidden="true"
                      className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent group-data-[focus]:border group-data-[checked]:border-blue-600"
                    />
                  </Radio>
                ))}
              </RadioGroup>
            </fieldset>

            {/* <div className="mt-4 text-gray-900">
              <span className="font-semibold">
                Calculated Percentage of {baseValue1}:{" "}
              </span>
              {calculatedValue1}
            </div> */}
          </div>
        </>
      ) : primcilj == "Povećanje kilaže" ? (
        <>
          {/* Second Radio Group - Exercise Intensity Levels */}
          <div>
            {/* <button
              onClick={toggleButtonState2}
              className="mb-4 px-4 py-2 bg-blue-600 text-white rounded"
            >
              {areButtonsEnabled2 ? "Onemoguci" : "Omoguci"}
            </button> */}

            {/* <fieldset>
              <RadioGroup
                value={selectedMailingLists2}
                onChange={handleMailingListChange2}
                className="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-4 sm:gap-x-4"
              >
                {mailingLists2.map((mailingList) => (
                  <Radio
                    key={mailingList.id}
                    value={mailingList}
                    className={`group relative flex cursor-pointer rounded-lg p-3 shadow-sm transition-all duration-200
                          ${
                            areButtonsEnabled2 ||
                            mailingList.id === 1 ||
                            mailingList.id === 2 ||
                            mailingList.id === 3
                              ? "border border-gray-300 bg-white"
                              : "border border-gray-200 bg-gray-100 cursor-not-allowed"
                          }
                          focus:outline-none`}
                    disabled={
                      !areButtonsEnabled2 &&
                      mailingList.id !== 1 &&
                      mailingList.id !== 2 &&
                      mailingList.id !== 3
                    }
                  >
                    <span className="flex flex-1">
                      <span className="flex flex-col">
                        <span className="block text-sm font-medium text-gray-900">
                          {mailingList.title}
                        </span>
                        <span className="mt-1 flex items-center text-sm text-gray-500">
                          {mailingList.description}
                        </span>
                        <span className="mt-1 flex items-center text-sm text-gray-500">
                          {mailingList.ideal}
                        </span>
                        <span className="mt-6 text-sm font-medium text-gray-900">
                          {mailingList.users}
                        </span>
                      </span>
                    </span>
                    <CheckCircleIcon
                      aria-hidden="true"
                      className={`h-5 w-5 text-blue-600 ${
                        areButtonsEnabled2 || mailingList.id === 1
                          ? ""
                          : "invisible"
                      }`}
                    />
                    <span
                      aria-hidden="true"
                      className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent 
                            group-data-[focus]:border group-data-[checked]:border-blue-600"
                    />
                  </Radio>
                ))}
              </RadioGroup>
            </fieldset> */}

            <fieldset>
              <RadioGroup
                value={selectedMailingLists2}
                onChange={handleMailingListChange2}
                className="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-4 sm:gap-x-4"
              >
                {mailingLists2.map((mailingList) => (
                  <Radio
                    key={mailingList.id}
                    value={mailingList}
                    className={`group relative flex cursor-pointer rounded-lg p-3 shadow-sm transition-all duration-200 ${
                      mailingList.id <= enabledButtonsCount2
                        ? "border border-gray-300 bg-white"
                        : "border border-gray-200 bg-gray-100 cursor-not-allowed"
                    } focus:outline-none`}
                    disabled={mailingList.id > enabledButtonsCount2}
                  >
                    <span className="flex flex-1">
                      <span className="flex flex-col">
                        <span className="block text-sm font-medium text-gray-900">
                          {mailingList.title}
                        </span>
                        <span className="mt-1 flex items-center text-sm text-gray-500">
                          {mailingList.description}
                        </span>
                        <span className="mt-1 flex items-center text-sm text-gray-500">
                          {mailingList.ideal}
                        </span>
                        <span className="mt-6 text-sm font-medium text-gray-900">
                          {mailingList.users}
                        </span>
                      </span>
                    </span>
                    <CheckCircleIcon
                      aria-hidden="true"
                      className={`h-5 w-5 text-blue-600 ${
                        mailingList.id <= enabledButtonsCount2
                          ? ""
                          : "invisible"
                      }`}
                    />
                    <span
                      aria-hidden="true"
                      className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent group-data-[focus]:border group-data-[checked]:border-blue-600"
                    />
                  </Radio>
                ))}
              </RadioGroup>
            </fieldset>

            {/* <div className="mt-4 text-gray-900">
                  <span className="font-semibold">Calculated Percentage of {baseValue2}: </span>
                  {calculatedValue2}
                </div> */}
          </div>
        </>
      ) : (
        ""
      )}

      {/* Render za cetvrti radio button - RENDER JE OK ALI KALKULACIJE SU LOSE */}

      {primcilj === "Mršavljenje" ? (
        <>
          {selectedMailingLists1.title ===
          "Idealno za: Osobe sa jasno definisanim ciljem" ? (
            <>
              {/* Mrsavljenje - popravi kalkulacije */}
              <fieldset className="mt-6 p-6 border border-gray-300 rounded-lg shadow-lg bg-gray-50 max-w-3xl mx-auto">
                <div className="flex items-center space-x-1 mb-4">
                  <legend className="text-2xl font-bold text-gray-900">
                    Koliko dugo želite da traje vaš plan?
                  </legend>
                  <Tooltip text="Unesite trajanje u mesecima: 1 mesec" />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="flex flex-col">
                    <div className="flex items-center space-x-1">
                      <label className="text-md font-medium text-gray-700">
                        Trajanje perioda (u mesecima):
                      </label>
                      <Tooltip text="Unesite trajanje u mesecima: 1 mesec" />
                    </div>

                    <select
                      value={selectedMonth}
                      onChange={handleChange}
                      className="mt-2 block w-full rounded-md border-gray-300 py-2 px-3 bg-white text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    >
                      {[1, 2, 3, 4, 5, 6].map((month) => (
                        <option key={month} value={month}>
                          {month}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="flex flex-col">
                    <div className="flex items-center space-x-1">
                      <label className="text-md font-medium text-gray-700">
                        Kada želite da postignete svoj cilj?
                      </label>
                      <Tooltip text="(Automatski izračunato na osnovu trajanja): 9. februar 2025." />
                    </div>
                    <span className="mt-2 text-lg font-semibold text-blue-600">
                      {calculateDate()}
                    </span>
                  </div>
                </div>

                <div className="mt-6">
                  <div className="flex items-center space-x-1">
                    <label className="text-md font-medium text-gray-700">
                      Koliko kilograma želite da izgubite?
                    </label>
                    <Tooltip text="Unesite željeni broj kilograma: __ kg" />
                  </div>

                  <div className="flex items-center space-x-4 mt-2">
                    <input
                      type="number"
                      name="brKilaDaSePromeni"
                      id="brKilaDaSePromeni"
                      value={brKilaDaSePromeni}
                      onChange={handleWeightChange}
                      className="w-full sm:w-24 rounded-md border-gray-300 py-2 px-3 bg-white text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      placeholder="Unesite kg"
                      min="0"
                    />
                    <span className="text-md font-medium text-gray-700">
                      kg
                    </span>
                  </div>
                </div>

                <div className="mt-6">
                  <label className="text-md font-medium text-gray-700">
                    Vaša trenutna kilaža:{" "}
                    <span className="font-semibold text-blue-600">
                      {kilazaIspisana} kg
                    </span>
                  </label>
                </div>

                <div className="mt-6 bg-white p-4 rounded-lg shadow-inner border border-gray-200">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4">
                    Rezultati vašeg plana:
                  </h3>
                  <p className="text-md font-medium text-gray-700">
                    Nakon{" "}
                    <span className="font-semibold text-blue-600">
                      {selectedMonth}
                    </span>{" "}
                    meseca, vaša ciljana težina biće
                    <span className="font-semibold text-blue-600">
                      {" "}
                      {calculateTargetWeight()} kg
                    </span>
                    .
                  </p>
                  <p className="text-md font-medium text-gray-700">
                    Dnevni deficit kalorija:{" "}
                    <span className="font-semibold text-blue-600">
                      {brKilaDaSePromeni ? calculateDailyChange() : "Nema"}
                    </span>{" "}
                    kalorija po danu.
                  </p>
                </div>
              </fieldset>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      {primcilj === "Povećanje kilaže" ? (
        <>
          {selectedMailingLists2.title === "Tvoje povećanje" ? (
            <>
              {/* Gojenje - popravi kalkulacije */}
              <fieldset className="mt-6 p-6 border border-gray-300 rounded-lg shadow-lg bg-gray-50 max-w-3xl mx-auto">
                <legend className="text-2xl font-bold text-gray-900 mb-4">
                  Plan za gojenje:
                </legend>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="flex flex-col">
                    <label className="text-md font-medium text-gray-700">
                      Trajanje perioda (u mesecima):
                    </label>
                    <select
                      value={selectedMonth}
                      onChange={handleChange}
                      className="mt-2 block w-full rounded-md border-gray-300 py-2 px-3 bg-white text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    >
                      {[1, 2, 3, 4, 5, 6].map((month) => (
                        <option key={month} value={month}>
                          {month}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="flex flex-col">
                    <label className="text-md font-medium text-gray-700">
                      Predviđeni datum postizanja cilja:
                    </label>
                    <span className="mt-2 text-lg font-semibold text-blue-600">
                      {calculateDate()}
                    </span>
                  </div>
                </div>

                <div className="mt-6">
                  <div className="flex items-center space-x-1">
                    <label className="text-md font-medium text-gray-700">
                      Koliko kilograma želite da dobijete?
                    </label>
                    <Tooltip text="Unesite željeni broj kilograma: __ kg" />
                  </div>

                  <div className="flex items-center space-x-4 mt-2">
                    <input
                      type="number"
                      name="brKilaDaSePromeni"
                      id="brKilaDaSePromeni"
                      value={brKilaDaSePromeni}
                      onChange={handleWeightChange}
                      className="w-full sm:w-24 rounded-md border-gray-300 py-2 px-3 bg-white text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      placeholder="Unesite kg"
                      min="0"
                    />
                    <span className="text-md font-medium text-gray-700">
                      kg
                    </span>
                  </div>
                </div>

                <div className="mt-6">
                  <label className="text-md font-medium text-gray-700">
                    Vaša trenutna kilaža:{" "}
                    <span className="font-semibold text-blue-600">
                      {kilazaIspisana} kg
                    </span>
                  </label>
                </div>

                <div className="mt-6 bg-white p-4 rounded-lg shadow-inner border border-gray-200">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4">
                    Rezultati vašeg plana:
                  </h3>
                  <p className="text-md font-medium text-gray-700">
                    Nakon{" "}
                    <span className="font-semibold text-blue-600">
                      {selectedMonth}
                    </span>{" "}
                    meseca, vaša ciljana težina biće
                    <span className="font-semibold text-blue-600">
                      {" "}
                      {calculateTargetWeight()} kg
                    </span>
                    .
                  </p>
                  <p className="text-md font-medium text-gray-700">
                    Dnevni kalorijski višak:{" "}
                    <span className="font-semibold text-blue-600">
                      {brKilaDaSePromeni ? calculateDailyChange() : "Nema"}
                    </span>{" "}
                    kalorija po danu.
                  </p>
                </div>
              </fieldset>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      {/* Odabirom iz ovog selecta menjamo naminice HERE */}
      {/* <label
        htmlFor="role"
        className="block text-lg font-medium leading-6 text-gray-900 mt-4"
      >
        Specificni cilj
      </label>

      <div className="mt-1">
        {isSuccessGetSpecCiljevi ? (
          <select
            id="specilj"
            name="specilj"
            autoComplete="specilj"
            value={specilj}
            onChange={onSpecCiljChanged}
            className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600"
          >
            <option value="">Izaberite specifičan cilj</option>
            {getSpecCiljeviData.ids.map((id) => (
              <option key={id} value={id}>
                {getSpecCiljeviData.entities[id]?.naziv}
              </option>
            ))}
          </select>
        ) : (
          <div>Učitavanje...</div>
        )}
      </div> */}

      {/* Spec ciljevi */}
      {/* <div>
        <label
          htmlFor="defTip"
          className="block text-lg font-medium leading-6 text-gray-900 mt-4"
        >
          Kategorija specificnih ciljeva
        </label>
        <div className="mt-1">
          <select
            id="defTip"
            name="defTip"
            value={selectedDefTip}
            onChange={onDefTipChanged}
            className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600"
          >
            <option value="">Izaberite tip</option>
            {uniqueDefTip.map((tip, index) => (
              <option key={index} value={tip}>
                {tip}
              </option>
            ))}
          </select>
        </div>

        <label
          htmlFor="specilj"
          className="block text-lg font-medium leading-6 text-gray-900 mt-4"
        >
          Specifičan cilj
        </label>
        <div className="mt-1">
          {filteredSpecCiljevi?.length > 0 ? ( //Pogledaj da li ovaj treba filteredSpecCiljevi
            filteredSpecCiljevi?.map((cilj) => (
              <div key={cilj._id} className="flex items-center">
                <input
                  type="checkbox"
                  id={cilj._id}
                  checked={selectedSpecCiljevi.includes(cilj._id)}
                  onChange={() => handleCheckboxChangeSpecCilj(cilj._id)}
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label
                  htmlFor={cilj._id}
                  className="ml-2 block text-sm text-gray-900"
                >
                  {cilj.naziv}
                </label>
              </div>
            ))
          ) : (
            <div>Izaberite tip specifičnog cilja</div>
          )}
        </div>
        <button onClick={posaljiSpecCiljeve}>Potvrdi ciljeve</button>
      </div> */}

      {/* Ovako treba da izgledaju specificni ciljevi */}
      {/* Postavljeno sve vertikalno */}
      {groupedData && (
        <div className="mt-5">
          <div className="flex items-center space-x-1">
            <label
              htmlFor="defTip"
              className="block text-lg font-medium leading-6 text-gray-900"
            >
              Dodatni ciljevi
            </label>
            <Tooltip text="Izaberite dodatne ciljeve u skladu sa svojim potrebama, poput zdravlja, kondicije ili navika." />
          </div>

          <div className="mt-2">
            {Object.entries(groupedData).map(([defTip, ciljevi]) => (
              <div key={defTip} className="mb-6">
                <h3 className="text-sm font-medium text-gray-900">{defTip}</h3>
                <div className="mt-2">
                  {ciljevi.map((cilj) => (
                    <div key={cilj._id} className="flex items-center">
                      <input
                        type="checkbox"
                        id={cilj._id}
                        checked={selectedSpecCiljevi?.includes(cilj._id)}
                        onChange={() => handleCheckboxChangeSpecCilj(cilj._id)}
                        className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                      />
                      <label
                        htmlFor={cilj._id}
                        className="ml-2 block text-sm text-gray-900"
                      >
                        {cilj.naziv}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            ))}
            {/* <button
              onClick={posaljiSpecCiljeve}
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded shadow"
            >
              Potvrdi ciljeve
            </button> */}
          </div>
        </div>
      )}

      {/* Test specificnih ciljeva */}
      {/* Postavljeno sve vertikalno */}
      {/* {groupedData && (
        <div>
          <div className="flex flex-wrap gap-6">
            {Object.entries(groupedData).map(([defTip, ciljevi]) => (
              <div key={defTip} className="flex flex-col w-1/4">
                <h3 className="text-lg font-medium text-gray-900 text-center">
                  {defTip}
                </h3>
                <div className="mt-2 flex flex-col items-start">
                  {ciljevi.map((cilj) => (
                    <div key={cilj._id} className="flex items-center">
                      <input
                        type="checkbox"
                        id={cilj._id}
                        checked={selectedSpecCiljevi.includes(cilj._id)}
                        onChange={() => handleCheckboxChangeSpecCilj(cilj._id)}
                        className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                      />
                      <label
                        htmlFor={cilj._id}
                        className="ml-2 block text-sm text-gray-900"
                      >
                        {cilj.naziv}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <button
            onClick={posaljiSpecCiljeve}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded shadow"
          >
            Potvrdi ciljeve
          </button>
        </div>
      )} */}

      {/* Prikaz spec ciljeva */}
      <div className="mt-4">
        <h3 className="text-lg font-medium">Izabrani specifični ciljevi:</h3>

        <ul className="mt-2 list-disc list-inside">
          {selectedSpecCiljevi?.map((ciljId) => {
            const cilj = specCiljevi?.find((c) => c._id === ciljId);
            return cilj ? <li key={ciljId}>{cilj.naziv}</li> : null;
          })}
        </ul>
      </div>

      <div className="flex items-center space-x-1">
        <label
          htmlFor="role"
          className="block text-lg font-medium leading-6 text-gray-900"
        >
          Vaša motivacija
        </label>
        <Tooltip text="Unesite kratki tekst o tome šta vas motiviše da postignete ciljeve." />
      </div>

      <div className="mt-1">
        {isSuccessGetMotiv ? (
          <select
            id="motiv"
            name="motiv"
            autoComplete="motivacija"
            value={motiv || ""}
            onChange={onMotivChanged}
            className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600"
          >
            <option value="Nema motivacije">Izaberite motivaciju</option>
            {getMotivData.ids.map((id) => (
              <option key={id} value={id}>
                {getMotivData.entities[id]?.naziv}
              </option>
            ))}
          </select>
        ) : (
          <div>Učitavanje...</div>
        )}
      </div>

      {/* Ovo polje za komentar je za skuplji paket */}
      <div className="mt-2">
        <div className="flex items-center space-x-1">
          <label
            htmlFor="komentarCilj"
            className="block text-lg font-medium leading-6 text-gray-900 sm:pt-1.5"
          >
            Dodatni komentar cilja
          </label>
          <Tooltip text="Detaljnije opišete svoj cilj, motivaciju ili specifične izazove sa kojima se suočavate - U polje da se upise." />
        </div>
        <div className="">
          <textarea
            id="komentarCilj"
            name="komentarCilj"
            value={komentarCilja} //Napravi promenljivu i data flow
            onChange={onKomentarCiljaChange}
            rows={3}
            style={{ height: "150px", overflowY: "auto" }}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>

      {/* Zeljeni cilj */}
      {/* <label className="block text-lg font-medium leading-6 text-gray-900 sm:pt-1.5 mt-2">
          Željeni cilj
        </label>

        <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4">
          <label className="text-md">
            Trajanje meseca:
          </label>
          <select 
            value={selectedMonth} 
            onChange={handleChange} 
            className="block w-full sm:w-24 rounded border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:max-w-xs sm:text-sm sm:leading-6"
          >
            {[1, 2, 3, 4, 5, 6].map(month => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </select>

          <label className="text-md">
            Postizanje cilja do datuma: {calculateDate()}
          </label>
        </div>

        <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-2 mt-2">
          <label className="text-md">Željena kilaža za mršavljenje</label>
          <input
            type="number"
            name="brKilaDaSmrsa"
            id="brKilaDaSmrsa"
            value={brKilaDaSmrsa}
            onChange={(e) => setBrKilaDaSmrsa(e.target.value)}
            className="w-24 rounded border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
          />
          <label className="text-md">kg</label>
        </div>

        <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-2 mt-2">
          <label className="text-md">Ispisana kilaža {kilazaIspisana} kg</label> 
        </div>

        <div className="flex flex-col items-center mt-4 sm:items-start">
          <label className="text-md text-center sm:text-left mb-2">
            Posle {selectedMonth} meseci imaćete {kilazaIspisana} kila
          </label>
          <label className="text-md text-center sm:text-left mb-2">
            Dnevni deficit {calculateDailyDeficit()} kalorija po danu
          </label>
        </div> */}

      {/* {primcilj === "Mršavljenje" || primcilj === "Povećanje kilaže" ? 

            <fieldset className="mt-6 p-6 border border-gray-300 rounded-lg shadow-lg bg-gray-50 max-w-3xl mx-auto">
              <legend className="text-2xl font-bold text-gray-900 mb-4">{primcilj === "Mršavljenje" ? "Plan za mršavljenje:" : primcilj === "Povećanje kilaže" ? "Plan za gojenje" : ""}</legend>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="flex flex-col">
                  <label className="text-md font-medium text-gray-700">Trajanje perioda (u mesecima):</label>
                  <select
                    value={selectedMonth}
                    onChange={handleChange}
                    className="mt-2 block w-full rounded-md border-gray-300 py-2 px-3 bg-white text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  >
                    {[1, 2, 3, 4, 5, 6].map((month) => (
                      <option key={month} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex flex-col">
                  <label className="text-md font-medium text-gray-700">
                    Predviđeni datum postizanja cilja:
                  </label>
                  <span className="mt-2 text-lg font-semibold text-blue-600">
                    {calculateDate()}
                  </span>
                </div>
              </div>

          
              <div className="mt-6">
                <label className="text-md font-medium text-gray-700">
         
                  {primcilj === "Mršavljenje" ? "Željeni broj kilograma za mršavljenje:" : primcilj === "Povećanje kilaže" ? "Željeni broj kilograma za gojenje:" : ""}
                </label>
                <div className="flex items-center space-x-4 mt-2">
                  <input
                    type="number"
                    name="brKilaDaSePromeni"
                    id="brKilaDaSePromeni"
                    value={brKilaDaSePromeni}
                    onChange={handleWeightChange}
                    className="w-full sm:w-24 rounded-md border-gray-300 py-2 px-3 bg-white text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    placeholder="Unesite kg"
                    min="0"
                  />
                  <span className="text-md font-medium text-gray-700">kg</span>
                </div>
              </div>

              <div className="mt-6">
                <label className="text-md font-medium text-gray-700">
                  Vaša trenutna kilaža:{" "}
                  <span className="font-semibold text-blue-600">{kilazaIspisana} kg</span>
                </label>
              </div>

              <div className="mt-6 bg-white p-4 rounded-lg shadow-inner border border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Rezultati vašeg plana:</h3>
                <div className="">
                <div className="container">
                  <p className="text-md font-medium text-gray-700">
                    Nakon <span className="font-semibold text-blue-600">{selectedMonth}</span> meseca, vaša ciljana težina biće 
                    <span className="font-semibold text-blue-600"> {calculateTargetWeight()} kg</span>.
                  </p>
                  <p className="text-md font-medium text-gray-700">
                    {primcilj === "mrsavljenje" ? "dnevni deficit" : "dnevni kalorijski višak"} kalorija: 
                    <span className="font-semibold text-blue-600">
                      {brKilaDaSePromeni ? calculateDailyChange() : " Nema"}
                    </span> kalorija po danu.
                  </p>
                </div>
                  
                </div>
              </div>
            </fieldset>

          : <></>} */}

      <br />
    </div>
  );

  let fizParam = (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Kolona 1 */}
        <div className="">
          <div className="flex items-center space-x-1">
            <label
              htmlFor="activity-level"
              className="block text-lg font-medium text-gray-700"
            >
              Izaberite nivo aktivnosti:
            </label>
            <Tooltip text="Procena vaše dnevne aktivnosti pomaže u prilagođavanju kalorijskih preporuka." />
          </div>

          <select
            id="activity-level"
            value={activityLevel} //Ne cuva ga!
            onChange={handleChangeFizNivo}
            className="mt-2 block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600"
          >
            <option value="1.2">Sedentaran (malo ili nimalo vežbanja)</option>
            <option value="1.375">
              Lagano aktivan (lakše vežbanje/sport 1-3 dana u nedelji)
            </option>
            <option value="1.55">
              Umereno aktivan (umereno vežbanje/sport 3-5 dana u nedelji)
            </option>
            <option value="1.725">
              Veoma aktivan (intenzivno vežbanje/sport 6-7 dana u nedelji)
            </option>
            <option value="1.9">
              Ekstremno aktivan (veoma intenzivno vežbanje, fizički posao)
            </option>
          </select>
          {/* <p className="mt-2 text-sm text-gray-600">
            Izabrani nivo aktivnosti: {activityLevel}
          </p> */}

          <div>
            <div className="flex items-center space-x-1">
              <label
                htmlFor="vrstAkt"
                className="block text-lg font-medium text-gray-700 mt-4 mb-2"
              >
                Omiljene aktivnosti (jednostavnije)
              </label>
              <Tooltip text="Izaberite fizičke aktivnosti u kojima uživate da biste dobili bolje prilagođene planove." />
            </div>

            {/* <select
            id="vrstAkt"
            value={vrstAkt || ""}
            onChange={handleChangeVrstAkt}
            className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600"
          >
            <option value="" selected>Izaberite fizičku aktivnost</option>

            {isSuccessGetFizAkt && getFizAktData ? (
              Object.values(getFizAktData.entities).map((aktivnost) => (
                <option key={aktivnost.id} value={aktivnost.naziv}>
                  {aktivnost.naziv}
                </option>
              ))
            ) : isErrorGetFizAkt ? (
              <option disabled>{getFizAktError.message}</option>
            ) : (
              <option disabled>Učitavanje...</option>
            )}
          </select> */}
            <div className="relative" ref={dropdownRef}>
              {/* Button to toggle dropdown */}
              <button
                onClick={handleToggleFizAkt}
                className="inline-flex justify-between w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                {selectedActivities?.length > 0
                  ? selectedActivities?.join(", ")
                  : "Koja je tvoja idealna fizička aktivnost?"}
                <svg
                  className="w-5 h-5 ml-2 -mr-1 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.707a1 1 0 011.414 0L10 11.586l3.293-3.879a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>

              {/* Dropdown menu with checkboxes */}
              {dropdownOpenFizAkt && (
                <div className="absolute z-10 mt-2 w-full rounded-md bg-white shadow-lg">
                  <ul className="py-1 text-sm text-gray-700 max-h-60 overflow-auto">
                    {isSuccessGetFizAkt && getFizAktData ? (
                      Object.values(getFizAktData.entities).map((aktivnost) => (
                        <li
                          key={aktivnost.id}
                          className="px-4 py-2 hover:bg-gray-100"
                        >
                          <label className="flex items-center">
                            <input
                              type="checkbox"
                              value={aktivnost.naziv}
                              checked={selectedActivities.includes(
                                aktivnost.naziv
                              )}
                              onChange={() =>
                                handleCheckboxChangeFizAktDrop(aktivnost)
                              }
                              className="mr-2"
                            />
                            {aktivnost.naziv}
                          </label>
                        </li>
                      ))
                    ) : isErrorGetFizAkt ? (
                      <li className="px-4 py-2 text-red-500">
                        {getFizAktError.message}
                      </li>
                    ) : (
                      <li className="px-4 py-2">Učitavanje...</li>
                    )}
                  </ul>
                </div>
              )}
            </div>

            <div className="max-w-md mt-3">
              <div className="flex items-center space-x-1">
                <label
                  htmlFor="obim"
                  className="text-lg font-medium text-gray-700 my-2"
                >
                  Mere tela:
                </label>
                <Tooltip text="Unesite mere (struk, kukovi, grudi itd.) radi praćenja napretka." />
              </div>
              {/* <form onSubmit={handleSubmitObim}>*/}
              <div className="grid grid-cols-7 gap-1 mt-2">
                <label
                  htmlFor="struka"
                  className="text-sm font-medium text-gray-700 col-span-1 mr-1 flex items-center justify-start"
                >
                  Struka:
                </label>
                <input
                  type="number"
                  id="struka"
                  value={struka}
                  onChange={(e) => setStruka(e.target.value)}
                  className={`col-span-6 block w-full border rounded-md shadow-sm py-0.5 ${
                    struka ? "" : "border-gray-300"
                  } focus:border-blue-500 focus:ring focus:ring-blue-200`}
                  placeholder="Unesi"
                />

                <label
                  htmlFor="kukova"
                  className="text-sm font-medium text-gray-700 col-span-1 mr-1 flex items-center justify-start"
                >
                  Kukova:
                </label>
                <input
                  type="number"
                  id="kukova"
                  value={kukova}
                  onChange={(e) => setKukova(e.target.value)}
                  className={`col-span-6 block w-full border rounded-md shadow-sm py-0.5 ${
                    kukova ? "" : "border-gray-300"
                  } focus:border-blue-500 focus:ring focus:ring-blue-200`}
                  placeholder="Unesi"
                />

                <label
                  htmlFor="vrat"
                  className="text-sm font-medium text-gray-700 col-span-1 mr-1 flex items-center justify-start"
                >
                  Vrat:
                </label>
                <input
                  type="number"
                  id="vrat"
                  value={vrat}
                  onChange={(e) => setvrat(e.target.value)}
                  className={`col-span-6 block w-full border rounded-md shadow-sm py-0.5 ${
                    vrat ? "" : "border-gray-300"
                  } focus:border-blue-500 focus:ring focus:ring-blue-200`}
                  placeholder="Unesi"
                />
              </div>
              {/* {errorObim && <p className="text-red-500 text-sm mt-2">{errorObim}</p>}
                <button type="submit" className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md">Submit</button> */}
              {/* </form> */}
            </div>
          </div>
        </div>
        {/* Kolona 2 */}
        <div className="">
          {/* <div className="max-w-md">
            <div className="flex items-center space-x-1">
              <label className="text-sm font-medium text-gray-700 mb-2">
                Krvna grupa:
              </label>
              <Tooltip text="Informacija o krvnoj grupi koristi se za dodatne preporuke u ishrani (opciono)." />
            </div>

            <table className="w-full my-2">
              <tbody>
                <tr>
                  {["A+", "B+", "AB+", "0+"].map((type) => (
                    <td key={type} className="text-center">
                      <label className="flex items-center">
                        <input
                          type="radio"
                          value={type}
                          checked={bloodType === type}
                          onChange={handleChangeBloodType}
                          className="mr-2 form-radio h-4 w-4 text-blue-600 border-gray-300"
                        />
                        {type}
                      </label>
                    </td>
                  ))}
                </tr>
                <tr>
                  {["A-", "B-", "AB-", "0-"].map((type) => (
                    <td key={type} className="text-center">
                      <label className="flex items-center">
                        <input
                          type="radio"
                          value={type}
                          checked={bloodType === type}
                          onChange={handleChangeBloodType}
                          className="mr-2 form-radio h-4 w-4 text-blue-600 border-gray-300"
                        />
                        {type}
                      </label>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
            {bloodType && (
                  <p className="mt-4 text-sm text-gray-600">Vaša krvna grupa je: {bloodType}</p>
              )}
          </div> */}

          {/* Rekao je da izbacimo dijagnoze */}
          {/* <label htmlFor="dijagnoza" className="block text-sm font-medium text-gray-700 mb-2">Postojeće zdravstvene dijagnoze:</label>
          <select
            id="dijagnoza"
            value={dijagnoza || ""}
            onChange={handleChangeDijagnoza}
            className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600">
            <option value="">Izaberite postojeću dijagnozu</option>
            {isSuccessGetDijagnoza && getDijagnozaData ? (
              Object.values(getDijagnozaData.entities).map((dijagnozaItem) => (
                <option key={dijagnozaItem.id} value={dijagnozaItem.naziv}>
                  {dijagnozaItem.naziv}
                </option>
              ))
            ) : isErrorGetDijagnoza ? (
              <option disabled>{getDijagnozaError.message}</option>
            ) : (
              <option disabled>Učitavanje...</option>
            )}
          </select> */}

          {/* <label htmlFor="dijagnozaInput" className="block text-sm font-medium text-gray-700 mt-4">Dijagnoza:</label>
          <input
            id="dijagnozaInput"
            type="text"
            placeholder="Unesite dijagnozu"
            value={dijagnoza}
            onChange={(e) => setDijagnoza(e.target.value)}
            className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600"
          /> */}

          {/* <div className="flex items-center space-x-1">
            <label
              htmlFor="alergije"
              className="block text-sm font-medium text-gray-700 mt-4 mb-2"
            >
              Alergije:
            </label>
            <Tooltip text="Navedite alergije na hranu ili druge supstance radi sigurnosti." />
          </div>

          <input
            id="alergije"
            type="text"
            placeholder="Unesite alergije"
            value={alergije}
            onChange={(e) => setAlergije(e.target.value)}
            className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600"
          /> */}
          {/* <p className="mt-2 text-sm text-gray-600">Postojeća dijagnoza: {imunitet}</p> */}

          <fieldset className="mt-4">
            <div className="flex items-center space-x-1">
              <legend className="block text-lg font-medium text-gray-700">
                DA – ako ti je imunitet dobar. NE – ako ti je oslabljen:
              </legend>
              <Tooltip text="Odaberite „Da“ ili „Ne“ u skladu sa svojim zdravstvenim stanjem." />
            </div>

            <div className="flex items-center mt-2">
              <input
                type="radio"
                id="imunitetDa"
                name="imunitet"
                value="Da"
                checked={imunitet === "Da"}
                onChange={() => setImunitet("Da")}
                className="mr-2"
              />
              <label htmlFor="imunitetDa" className="mr-4">
                Da
              </label>

              <input
                type="radio"
                id="imunitetNe"
                name="imunitet"
                value="Ne"
                checked={imunitet === "Ne"}
                onChange={() => setImunitet("Ne")}
                className="mr-2"
              />
              <label htmlFor="imunitetNe">Ne</label>
            </div>
          </fieldset>
        </div>{" "}
        {/* col2 */}
      </div>
    </>
  );

  let mojeIshrane = (
    <>
      <table className="min-w-full border-collapse border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
              Datum
            </th>
            <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
              Title
            </th>
            <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"></th>
          </tr>
        </thead>
        <tbody className="bg-white">
          <tr key="12">
            <td className="border-b border-r px-4 py-2 text-sm text-gray-900 whitespace-nowrap"></td>
            <td className="border-b border-r px-4 py-2 text-sm text-gray-900"></td>
            <td className="flex justify-begin relative whitespace-nowrap px-3 py-2 text-sm font-medium sm:pr-6">
              <button className="text-red-600 hover:text-red-800 mr-2">
                <EyeIcon className="h-5 w-5" aria-hidden="true" />
              </button>
              <button className="text-blue-600 hover:text-blue-800">
                <ArrowDownTrayIcon className="h-5 w-5" aria-hidden="true" />
              </button>
              <button className="text-red-600 hover:text-red-800 mr-2">
                <TrashIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </td>
          </tr>
        </tbody>
        {/*<tbody className="bg-white"> EyeIcon
           {isSuccessGetDnevnikKorisnik && mojDnevnikData != null && mojDnevnikData.map((item) => ( 
            <tr key={item._id}>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900 whitespace-nowrap">{item.datum}</td>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.god}</td>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.tezina}</td>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.visina}</td>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.struk}</td>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.vrat}</td>
              {gender === "female" && (
                <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.kuk}</td>
              )}
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.bmi}</td>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.procenatTelesneMase}</td>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.telesnaMasa}</td>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.cistaTelesnaMast}</td>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.idealneTelesneMasti}</td>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900 text-center">
                <span className="inline-block">{item.povecanje}</span>
                <span className="mx-2">|</span>
                <span className="inline-block">{item.smanjenje}</span>
              </td>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.telesnaMasaBmi}</td>
              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">{item.kategorija}</td>
              <td className="border-b border-r px-2 py-2 text-sm text-gray-900" onClick={() => setIdIshraneIzvZaBris(item._id)}>
                <TrashIcon className="h-5 w-5 shrink-0 cursor-pointer stroke-red-600" aria-hidden="true"/>
              </td>
            </tr>
        </tbody>
        */}
      </table>
    </>
  );

  let tabovi = (
    <div className="bg-white shadow-sm ring-2 ring-gray-900/5 sm:rounded mt-3">
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded border-gray-300 focus:border-blue-500 focus:ring-blue-500"
          value={currentTab}
          onChange={handleSelectChange}
        >
          {tabs.map((tab) => (
            <option key={tab.name} value={tab.name}>
              {tab.name}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <nav
          className="isolate flex divide-x divide-gray-200 rounded shadow"
          aria-label="Tabs"
        >
          {tabs.map((tab, tabIdx) => (
            <a
              key={tab.name}
              href={tab.href}
              onClick={(e) => {
                e.preventDefault();
                handleTabClick(tab.name);
              }}
              className={classNames(
                tab.name === currentTab
                  ? "text-gray-900"
                  : "text-gray-500 hover:text-gray-700",
                tabIdx === 0 ? "rounded-tl rounded-bl" : "",
                tabIdx === tabs.length - 1 ? "rounded-tr rounded-br" : "",
                "group relative w-1/2 overflow-hidden bg-white px-4 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
              )}
              aria-current={tab.name === currentTab ? "page" : undefined}
            >
              <span>{tab.name}</span>
              <span
                aria-hidden="true"
                className={classNames(
                  tab.name === currentTab ? "bg-blue-500" : "bg-transparent",
                  "absolute inset-x-0 bottom-0 h-0.5"
                )}
              />
            </a>
          ))}
        </nav>
      </div>
      <div className="">
        {currentTab === "Osnovni podaci" && (
          <div className="block w-full h-100 rounded bg-white border-gray-300">
            {tailwindContent}
          </div>
        )}
        {currentTab === "Ciljevi" && (
          <div className="block w-full h-max rounded bg-white p-4 border-gray-300">
            {ciljevi}
          </div>
        )}
        {currentTab === "Fizički parametri" && (
          <div className="block w-full h-max rounded bg-white p-4 border-gray-300">
            {fizParam}
          </div>
        )}
        {currentTab === "Ishrana i zivotne navike" && (
          <div className="block w-full rounded bg-white p-4 border-gray-300">
            {ishranaForm}
          </div>
        )}
        {currentTab === "Namirnice" && (
          <div className="block w-full rounded bg-white p-4 border-gray-300">
            {/* <h1>
              Izabrali ste ishranu i onda ide text bla bla bla koji Jovana treba
              da izdizajnira...
            </h1> */}
            <div className="mt-4">
              <label
                htmlFor="voljeneNamirnice"
                className="block text-lg font-medium leading-6 text-gray-900"
              >
                Unesi namirnice koje volite (odvojite ih zarezom)
              </label>
              <input
                id="voljeneNamirnice"
                type="text"
                value={voljeneNamirnice}
                onChange={handleVoljeneNamirniceChange}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              />
            </div>

            <div className="mt-4">
              <label
                htmlFor="neVoljeneNamirnice"
                className="block text-lg font-medium leading-6 text-gray-900"
              >
                Unesi namirnice koje ne volite (odvojite ih zarezom)
              </label>
              <input
                id="neVoljeneNamirnice"
                type="text"
                value={neVoljeneNamirnice}
                onChange={handleNeVoljeneNamirniceChange}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
              />
            </div>

            {/* Prikaz namirnica po kategorijama i podkategorijama SA CHECKBOXOVIMA */}
            {/* {selectedIshrana ? ( */}
            {/* Klasican tree naminica */}
            {/* <div className="mb-4">
              <h3 className="text-xl font-semibold mb-2">Odabir Namirnica</h3>

              
              <div className="overflow-y-scroll" style={{ maxHeight: "400px" }}>
                {Object.keys(grupisaneNamirnice).map((grupa) => (
                  <div key={grupa} className="mb-4">
                    <h3 className="text-lg font-semibold">{grupa}</h3>
                    {Object.keys(grupisaneNamirnice[grupa]).map((podtip) => (
                      <div key={podtip} className="ml-4 mb-2">
                        <h4 className="text-md font-medium">{podtip}</h4>
                        <div className="ml-6">
                          {grupisaneNamirnice[grupa][podtip].map(
                            (namirnica) => (
                              <div
                                key={namirnica._id}
                                className="flex items-center mb-1"
                              >
                                <input
                                  type="checkbox"
                                  value={namirnica._id}
                                  checked={odabraneNamirnice?.includes(
                                    namirnica._id
                                  )}
                                  onChange={handleNamirnicaChange}
                                  className="mr-2"
                                  disabled={
                                    disabledNamirnice.includes(namirnica._id) ||
                                    !ishrane
                                      .find(
                                        (ishrana) =>
                                          ishrana._id === selectedIshrana
                                      )
                                      ?.namirnice.includes(namirnica._id)
                                  }
                                />
                                <label>
                                  {namirnica.naziv}{" "}
                                  {namirnica.alergen
                                    ? "(Alergen)"
                                    : namirnica.gluten
                                    ? "(Sadrži Gluten)"
                                    : namirnica.laktoza
                                    ? "(Sadrži Laktozu)"
                                    : ""}
                                </label>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>

            </div> */}
            {/* ) : (
              <p>Izaberite ishranu</p>
            )} */}

            {/* Tree i prikaz svih naminica i onih kojih ne pripadaju su DISABLED a koje pripadaju su ENABLED i iz skupa izbacuje sve specificne ciljeve */}
            {/* {selectedIshrana ? ( */}
            <div className="mb-4">
              <h3 className="text-xl font-semibold mb-2">Odabir Namirnica</h3>

              <div className="overflow-y-scroll" style={{ maxHeight: "400px" }}>
                {Object.keys(grupisaneNamirnice).map((grupa) => (
                  <div key={grupa} className="mb-4">
                    <h3 className="text-lg font-semibold">{grupa}</h3>
                    {Object.keys(grupisaneNamirnice[grupa]).map((podtip) => (
                      <div key={podtip} className="ml-4 mb-2">
                        <h4 className="text-md font-medium">{podtip}</h4>
                        <div className="ml-6">
                          {grupisaneNamirnice[grupa][podtip].map(
                            (namirnica) => (
                              <div
                                key={namirnica._id}
                                className="flex items-center mb-1"
                              >
                                <input
                                  type="checkbox"
                                  value={namirnica._id}
                                  checked={odabraneNamirnice.includes(
                                    namirnica._id
                                  )}
                                  onChange={handleNamirnicaChange}
                                  className="mr-2"
                                  disabled={
                                    disabledNamirnice.includes(namirnica._id) ||
                                    !ishrane
                                      .find(
                                        (ishrana) =>
                                          ishrana._id === selectedIshrana
                                      )
                                      ?.namirnice.includes(namirnica._id)
                                  } // Disable checkbox ako namirnica nije deo izabrane ishrane ili cilja
                                />
                                <label>
                                  {namirnica.naziv}{" "}
                                  {namirnica.alergen
                                    ? "(Alergen)"
                                    : namirnica.gluten
                                    ? "(Sadrži Gluten)"
                                    : namirnica.laktoza
                                    ? "(Sadrži Laktozu)"
                                    : ""}
                                </label>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
            {/* ) : (
              <p>Izaberite ishranu</p>
            )} */}

            {/* Tree i prikaz svih naminica i onih kojih ne pripadaju su DISABLED a koje pripadaju su ENABLED */}
            {/* {selectedIshrana ? (
              <div className="mb-4">
                <h3 className="text-xl font-semibold mb-2">Odabir Namirnica</h3>
                <div className="overflow-y-scroll" style={{ maxHeight: '400px' }}>
                  {Object.keys(grupisaneNamirnice).map((grupa) => (
                    <div key={grupa} className="mb-4">
                      <h3 className="text-lg font-semibold">{grupa}</h3>
                      {Object.keys(grupisaneNamirnice[grupa]).map((podtip) => (
                        <div key={podtip} className="ml-4 mb-2">
                          <h4 className="text-md font-medium">{podtip}</h4>
                          <div className="ml-6">
                            {grupisaneNamirnice[grupa][podtip].map((namirnica) => (
                              <div key={namirnica._id} className="flex items-center mb-1">
                                <input
                                  type="checkbox"
                                  value={namirnica._id}
                                  checked={odabraneNamirnice.includes(namirnica._id)}
                                  onChange={handleNamirnicaChange}
                                  className="mr-2"
                                  disabled={
                                    !ishrane
                                      .find((ishrana) => ishrana._id === selectedIshrana)?.namirnice.includes(namirnica._id)
                                  }
                                />
                                <label>
                                  {namirnica.naziv}{' '}
                                  {namirnica.alergen
                                    ? '(Alergen)'
                                    : namirnica.gluten
                                    ? '(Sadrži Gluten)'
                                    : namirnica.laktoza
                                    ? '(Sadrži Laktozu)'
                                    : ''}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <p>Izaberite ishranu</p>
            )} */}

            {/* Tabela i prikaz samo onih naminica koje pripadaju ishrani  DODAJ DA SE VIDE OSTALI CHECKBOXOVI I DA SU ONI DIABLED */}
            {/* {grupisaneNamirnice && Object.keys(grupisaneNamirnice).length > 0 ? (
                <div className="mb-4">
                    <h3 className="text-xl font-semibold mb-2">Odabir Namirnica</h3>
                    <div className="overflow-y-scroll" style={{ maxHeight: "450px" }}>
                        <table className="table-auto bg-white border-collapse border border-gray-400 w-full">
                            <thead className="bg-gray-100 sticky top-0">
                                <tr>
                                    <th className="border border-gray-300 p-2 text-left">Kategorija</th>
                                    <th className="border border-gray-300 p-2 text-left">Potkategorija</th>
                                    <th className="border border-gray-300 p-2 text-left">Namirnice</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(grupisaneNamirnice).map((grupa) => (
                                    <React.Fragment key={grupa}>
                                        {Object.keys(grupisaneNamirnice[grupa]).map((podtip, index) => (
                                            <tr key={podtip}>
                                                {index === 0 && (
                                                    <td className="border border-gray-300 p-2" rowSpan={Object.keys(grupisaneNamirnice[grupa]).length}>
                                                        {grupa}
                                                    </td>
                                                )}
                                                <td className="border border-gray-300 p-2">{podtip}</td>
                                                <td className="border border-gray-300 p-2">
                                                    <div className="flex flex-col">
                                                        {grupisaneNamirnice[grupa][podtip].map((namirnica) => (
                                                            <div key={namirnica._id} className="flex items-center mb-1">
                                                                <input
                                                                    type="checkbox"
                                                                    value={namirnica.naziv} // Koristimo ime namirnice umesto ID-ja
                                                                    checked={odabraneNamirnice.includes(namirnica.naziv)} // Provera da li je ime u odabranim namirnicama
                                                                    onChange={handleNamirnicaChange}
                                                                    className="mr-2"
                                                                />
                                                                <label>
                                                                    {namirnica.naziv}{" "}
                                                                    {namirnica.alergen ? "(Alergen)" : namirnica.gluten ? "(Sadrži Gluten)" : namirnica.laktoza ? "(Sadrži Laktozu)" : ""}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : (
                <p>Izaberite ishranu</p>
            )} */}

            <br />
            {/* <br/> */}
          </div>
        )}
        {currentTab === "Moje ishrane" && (
          <div className="block w-full rounded bg-white p-4 border-gray-300">
            {/* {mojeIshrane} */}

            <div className="App">
              {/* <form className="formStyle" onSubmit={submitImage}>
                <h4>Otpremi PDF</h4>
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Naslov"
                  required
                  onChange={(e) => setTitle(e.target.value)}
                />
                <br />
                <input
                  type="file"
                  className="form-control"
                  accept="application/pdf"
                  required
                  onChange={(e) => setFile(e.target.files[0])}
                />
                <br />
                <button className="btn btn-primary" type="submit">
                  Otpremi
                </button>
              </form> */}

              <div className="uploaded">
                <h4 className="text-lg">Otpremljeni izveštaji:</h4>
                {allImage && allImage.length > 0 ? (
                  <div className="overflow-x-auto">
                    <table className="min-w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                            Datum kreiranja izveštaja
                          </th>
                          <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                            Primarni cilj
                          </th>
                          <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                            Datum početka ishrane
                          </th>
                          <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                            Datum završetka ishrane
                          </th>
                          <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                            Broj dana ishrane
                          </th>
                          <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                            Status
                          </th>
                          <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                            Akcije
                          </th>
                        </tr>
                      </thead>
                      {/*  */}
                      <tbody className="bg-white">
                        {allImage.map((data) => (
                          <tr key={data._id}>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                              {data?.datumKreir} -{" "}
                              {data?.vreme ? data?.vreme.slice(0, 5) : ""}
                              {/*datumKreir - vreme  {data?.vreme ? data?.vreme.slice(0, 5) : ''}*/}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {data?.title} {/* primarni cilj */}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {data?.datumPoc} {/* dat poc */}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {data?.datumKraj} {/* dat kraja */}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {data?.tip} {/* tip */}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {data?.status} {/* status */}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              <div className="flex items-center space-x-4">
                                <button
                                  className="text-blue-600 hover:text-blue-800"
                                  onClick={() => showPdf(data.pdf)} // Open PDF in popup
                                >
                                  <EyeIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                  />
                                </button>
                                <div className="border-l h-5" />{" "}
                                {/* Horizontal line */}
                                <button
                                  className="text-blue-600 hover:text-blue-800"
                                  onClick={() => downloadPdf(data.pdf)}
                                >
                                  <ArrowDownTrayIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                  />
                                </button>
                                <div className="border-l h-5" />{" "}
                                {/* Horizontal line */}
                                <button
                                  onClick={() => preiewData(data)}
                                  className="text-blue-600 hover:text-blue-800"
                                >
                                  <UserIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                  />
                                </button>
                                <div className="border-l h-5" />{" "}
                                {/* Horizontal line */}
                                <button
                                  className="text-red-600 hover:text-red-800"
                                  onClick={() => deletePdf(data._id, data.pdf)}
                                >
                                  <TrashIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                  />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <br />
                    {/* <br/> */}
                  </div>
                ) : (
                  <p>Nema otpremljenih izveštaja.</p>
                )}
              </div>

              {/* Modal for PDF Preview u listi svih pdf-ova */}
              {isModalOpenPdf && (
                <div
                  className="fixed inset-0 flex items-center justify-center z-50 bg-gray-800 bg-opacity-75"
                  onClick={closeModalPdf} // Close modal when clicking on the background
                >
                  <div
                    className="bg-white p-6 rounded-lg shadow-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto"
                    onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking inside the modal
                  >
                    <div className="flex justify-between items-center">
                      {/* Show PDF Title instead of "Preview PDF" */}
                      <h2 className="text-lg font-semibold">{title}</h2>
                      <div className="flex space-x-2">
                        {/* Download button similar to close button */}
                        <button
                          className="text-blue-600 hover:text-blue-800 border border-blue-600 px-3 py-1 rounded-md"
                          onClick={() => downloadPdf(pdfFile.split("/").pop())}
                        >
                          Preuzmi PDF
                        </button>
                        <button
                          className="text-red-600 hover:text-red-800 border border-red-600 px-3 py-1 rounded-md"
                          onClick={closeModalPdf}
                        >
                          Zatvori
                        </button>
                      </div>
                    </div>
                    <div className="mt-4 flex flex-col items-center space-y-4">
                      <Document
                        file={pdfFile}
                        onLoadSuccess={onDocumentLoadSuccess}
                      >
                        {Array.from(new Array(numPages), (el, index) => (
                          <div
                            key={`page_${index + 1}`}
                            className="flex justify-center p-4 bg-white shadow-md border border-gray-300 rounded-lg"
                            style={{ marginBottom: "1px" }} // Minimal margin to avoid visual gaps
                          >
                            <Page
                              pageNumber={index + 1}
                              width={window.innerWidth < 640 ? 300 : 600}
                              className="p-0 m-0"
                              renderAnnotationLayer={false}
                              renderTextLayer={false}
                              style={{ overflow: "hidden" }} // Ensure no overflow
                            />
                          </div>
                        ))}
                      </Document>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* end */}

            {showPreview && klijentData && (
              <div
                className="fixed inset-0 flex items-center justify-center z-50 bg-gray-800 bg-opacity-50 transition-opacity duration-300 ease-in-out"
                onClick={() => setShowPreview(false)} // Close the modal when clicking outside
              >
                <div
                  className="bg-white p-6 rounded-lg shadow-lg w-full sm:max-w-md md:max-w-lg max-h-[80vh] overflow-y-auto transform transition-all duration-500 ease-in-out"
                  onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
                >
                  <div className="flex justify-between items-center mb-6 border-b pb-4">
                    <h4 className="text-xl font-semibold text-gray-800">
                      Podaci o klijentu
                    </h4>
                    <button
                      onClick={() => setShowPreview(false)} // Close modal
                      className="text-red-600 hover:text-red-800 border border-red-600 px-4 py-2 rounded-lg font-semibold transition-all duration-300"
                    >
                      Zatvori
                    </button>
                  </div>
                  <div className="space-y-4">
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Težina:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.tez ? `${klijentData?.tez} Kg` : "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Visina:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.visina
                          ? `${klijentData?.visina} Cm`
                          : "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Primarni cilj:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.primCilj || "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Motivacija:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.motiv || "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Nivo aktivnosti:
                      </p>
                      <p className="text-sm text-gray-800">
                        {getNivoFizickeAktivnosti(klijentData?.nivoAkt) ||
                          "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Datum rođenja:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.datumRodj || "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        TDEE:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.tdee
                          ? `${klijentData?.tdee} kcal`
                          : "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        BMI:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.bmi || "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        BMR:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.bmrValue
                          ? `${klijentData?.bmrValue} kcal`
                          : "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Vrsta fizičke aktivnosti:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.vrstaFiz?.join(", ") || "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Struk:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.struk
                          ? `${klijentData?.struk} Cm`
                          : "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Kuk:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.kuk ? `${klijentData?.kuk} Cm` : "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Krvna grupa:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.krv || "Nema"}
                      </p>
                    </div>
                    {/* <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">Dijagnoza:</p>
                      <p className="text-sm text-gray-800">{klijentData?.dijag || "Nema"}</p>
                    </div> */}
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Alergije:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.alerg || "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Ishrana:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.ish || "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Broj obroka:
                      </p>
                      <p className="text-sm text-gray-800">
                        {capitalizeFirstLetter(klijentData?.obr) || "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Pusenje:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.pus || "Nema"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-sm font-semibold text-gray-600">
                        Alkohol:
                      </p>
                      <p className="text-sm text-gray-800">
                        {klijentData?.alk || "Nema"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      {/* template za svaku komponentu backgroundColor: "rgba(2, 1, 1, 0.43)",*/}
      {highlighted && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(2, 1, 1, 0.43)",
            zIndex: 1,
          }}
        />
      )}

      <div className="">
        {/* <header className="mb-3">
                    <div className="">
                        <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">Korisnik</h1>
                    </div>
                </header>
                <hr className="border-t border-slate-950" /> */}
        <main className="">
          <div className="">
            {/* <br/> */}

            {/* Navbar */}
            <div className="p-5">
              <div className="flex flex-col items-center md:flex-row md:justify-between md:items-center space-y-4 md:space-y-0 md:space-x-5">
                <div className="flex items-center space-x-4">
                  <div className="shrink-0">
                    {/* <img
                      src={postImage.myFile || pol == "muski" ? `${process.env.PUBLIC_URL}/img/profileMale.png` : `${process.env.PUBLIC_URL}/img/profileFemale.png`}
                      alt="Uploaded" className="w-20 h-20 rounded-full border border-gray-300 object-cover"
                    /> */}
                    {/* {isLoadingImg ? (
                      <div>Loading...</div>
                    ) : (
                      <img
                        src={
                          postImage.myFile ||
                          (pol === "muski"
                            ? `${process.env.PUBLIC_URL}/img/profileMale.png`
                            : `${process.env.PUBLIC_URL}/img/profileFemale.png`)
                        }
                        alt="Profile"
                        className="w-20 h-20 rounded-full border border-gray-300 object-cover"
                      />
                    )} */}

                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt="Profilna"
                        className="w-20 h-20 rounded-full object-cover border border-gray-300"
                      />
                    ) : (
                      <img
                        src={
                          pol === "muski"
                            ? `${process.env.PUBLIC_URL}/img/profileMale.png`
                            : `${process.env.PUBLIC_URL}/img/profileFemale.png`
                        }
                        alt="Profile"
                        className="w-20 h-20 rounded-full object-cover border border-gray-300"
                      />
                    )}
                  </div>
                  <div className="text-center md:text-left">
                    <h1 className="text-xl md:text-2xl font-bold text-gray-900">
                      {name} {lastname}
                    </h1>
                    <p className="text-sm font-medium text-gray-500">
                      TDEE: {Math.round(tdee)} kcal, BMI {bmi} m²
                    </p>
                  </div>
                </div>

                {/* <div className="relative flex items-center justify-center">
                  <div className="bg-gray-700 text-white p-1 rounded-md shadow-lg w-64">
                    <div className="text-center mb-1 text-sm">
                      U ovom meniju se nalaze sve opcije koje možete koristiti.
                    </div>

                    <div className="text-center">
                      <button className="bg-blue-500 text-white py-1 px-2 rounded-md text-sm">
                        Button
                      </button>
                    </div>
                  </div>
                  <div className="absolute top-1/2 right-[-10px] transform -translate-y-1/2 w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-gray-700" />
                </div>

                <div
                  className="flex flex-wrap justify-center gap-2 md:justify-end"
                  style={{
                    padding: "20px",

                    borderRadius: "8px",
                    zIndex: 2,
                    position: "relative",
                    backgroundColor: highlighted ? "#f1f1f1" : "white",
                    boxShadow: highlighted
                      ? "0px 8px 15px rgba(0, 0, 0, 0.1)"
                      : "none",
                    transition: "all 0.3s ease",
                  }}
                >
                  {[
                    { name: "Dashboard", label: "Dashboard" },
                    { name: "OsnovniPodaci", label: "Osnovni podaci" },
                    { name: "Ciljevi", label: "Ciljevi" },
                    { name: "FizickiParametri", label: "Fizički parametri" },
                    { name: "Ishrana", label: "Ishrana" },
                    { name: "Namirnice", label: "Namirnice" },
                    { name: "PlanoviIshrane", label: "Planovi ishrane" },
                  ].map((item) => (
                    <button
                      key={item.name}
                      type="button"
                      aria-pressed={selectedDiv === item.name}
                      onClick={() => handleButtonClick(item.name)}
                      className={`inline-flex items-center justify-center rounded-lg px-4 py-2 text-xs md:text-sm font-semibold shadow-sm ring-1 ring-inset ${
                        selectedDiv === item.name
                          ? "bg-white-500 text-black ring-green-600"
                          : "bg-gray-200 text-gray-900 ring-gray-300 hover:bg-gray-300"
                      }`}
                    >
                      {item.label}
                    </button>
                  ))}
                </div> */}
                <div className="flex flex-col-reverse md:flex-row items-start justify-start space-y-4 md:space-y-0 md:space-x-4">
                  {/* First div with the tooltip */}
                  {highlighted && (
                    <div
                      className="relative flex flex-col items-center justify-center mt-4 md:mt-0"
                      style={{
                        zIndex: 2,
                        backgroundColor: highlighted ? "#f1f1f1" : "white",
                        borderRadius: "8px",
                        boxShadow: highlighted
                          ? "0px 8px 15px rgba(0, 0, 0, 0.1)"
                          : "none",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {/* Strelica za mobile (gore) */}
                      <div className="absolute top-[-5px] left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-8 border-b-gray-700 block md:hidden" />

                      <div className="bg-gray-700 text-white p-1 rounded-md shadow-lg w-64 relative">
                        <div className="text-center mb-1 text-sm">
                          Popuni svih 7 polja, zatim klikni na dugme 'NT' da
                          kreiraš svoj izveštaj. Bez popunjenih podataka,
                          izveštaj neće biti kompletan.
                        </div>

                        <div className="text-center">
                          <button
                            className="bg-blue-500 text-white py-1 px-2 rounded-md text-sm"
                            onClick={updateStuff}
                          >
                            Zatvori
                          </button>
                        </div>

                        {/* Strelica za desktop (desno) */}
                        <div className="absolute top-1/2 right-[-10px] transform -translate-y-1/2 w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-gray-700 hidden md:block" />
                      </div>
                    </div>
                  )}

                  {/* Second div with buttons */}
                  <div
                    className="flex flex-wrap justify-center gap-2 md:justify-end"
                    style={{
                      padding: "20px",
                      borderRadius: "8px",
                      zIndex: 2,
                      backgroundColor: highlighted ? "#f1f1f1" : "white",
                      boxShadow: highlighted
                        ? "0px 8px 15px rgba(0, 0, 0, 0.1)"
                        : "none",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {[
                      { name: "Dashboard", label: "Korisnik" },
                      { name: "OsnovniPodaci", label: "Osnovni podaci" },
                      { name: "Ciljevi", label: "Ciljevi" },
                      { name: "FizickiParametri", label: "Fizički parametri" },
                      { name: "Ishrana", label: "Ishrana" },
                      { name: "Namirnice", label: "Namirnice" },
                      { name: "PlanoviIshrane", label: "Planovi ishrane" },
                    ].map((item) => (
                      <button
                        key={item.name}
                        type="button"
                        aria-pressed={selectedDiv === item.name}
                        onClick={() => handleButtonClick(item.name)}
                        className={`inline-flex items-center justify-center rounded-lg px-4 py-2 text-xs md:text-sm font-semibold shadow-sm ring-1 ring-inset ${
                          selectedDiv === item.name
                            ? "bg-white-500 text-black ring-green-600"
                            : "bg-gray-200 text-gray-900 ring-gray-300 hover:bg-gray-300"
                        }`}
                      >
                        {item.label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div className="mt-4">
                {selectedDiv === "Dashboard" && (
                  <>
                    {dashboard_}

                    {isModalOpenPdfTwo && (
                      <div
                        className="fixed inset-0 flex items-center justify-center z-50 bg-gray-800 bg-opacity-75"
                        onClick={closeModalPdfTwo}
                      >
                        <div
                          className="bg-white p-6 rounded-lg shadow-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="flex justify-between items-center">
                            {/* Show PDF Title instead of "Preview PDF" */}
                            <h2 className="text-lg font-semibold">{title}</h2>
                            <div className="flex space-x-2">
                              {/* Download button similar to close button */}
                              <button
                                className="text-blue-600 hover:text-blue-800 border border-blue-600 px-3 py-1 rounded-md"
                                onClick={() =>
                                  downloadPdf(pdfFile.split("/").pop())
                                }
                              >
                                Preuzmi PDF
                              </button>
                              <button
                                className="text-red-600 hover:text-red-800 border border-red-600 px-3 py-1 rounded-md"
                                onClick={closeModalPdfTwo}
                              >
                                Zatvori
                              </button>
                            </div>
                          </div>
                          <div className="mt-4 flex flex-col items-center space-y-4">
                            <Document
                              file={pdfFile}
                              onLoadSuccess={onDocumentLoadSuccess}
                            >
                              {Array.from(new Array(numPages), (el, index) => (
                                <div
                                  key={`page_${index + 1}`}
                                  className="flex justify-center p-4 bg-white shadow-md border border-gray-300 rounded-lg"
                                  style={{ marginBottom: "1px" }}
                                >
                                  <Page
                                    pageNumber={index + 1}
                                    width={window.innerWidth < 640 ? 300 : 600}
                                    className="p-0 m-0"
                                    renderAnnotationLayer={false}
                                    renderTextLayer={false}
                                    style={{ overflow: "hidden" }}
                                  />
                                </div>
                              ))}
                            </Document>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {selectedDiv === "OsnovniPodaci" && <>{tailwindContent}</>}
                {selectedDiv === "Ciljevi" && <>{ciljevi}</>}
                {selectedDiv === "FizickiParametri" && <>{fizParam}</>}
                {selectedDiv === "Ishrana" && <>{ishranaForm}</>}
                {selectedDiv === "Namirnice" && (
                  <>
                    <div className="block w-full rounded bg-white p-4 border-gray-300">
                      {/* <h1>
                        Izabrali ste ishranu i onda ide text bla bla bla koji
                        Jovana treba da izdizajnira...
                      </h1> */}
                      <div className="mt-4">
                        <label
                          htmlFor="voljeneNamirnice"
                          className="block text-lg font-medium leading-6 text-gray-900"
                        >
                          Omiljene namirnice (odvojite ih zarezom)
                        </label>
                        <input
                          id="voljeneNamirnice"
                          type="text"
                          value={voljeneNamirnice}
                          onChange={handleVoljeneNamirniceChange}
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                        />
                      </div>

                      <div className="mt-4">
                        <label
                          htmlFor="neVoljeneNamirnice"
                          className="block text-lg font-medium leading-6 text-gray-900"
                        >
                          Namirnice koje izbegavate (odvojite ih zarezom)
                        </label>
                        <input
                          id="neVoljeneNamirnice"
                          type="text"
                          value={neVoljeneNamirnice}
                          onChange={handleNeVoljeneNamirniceChange}
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                        />
                      </div>

                      {/* Prikaz namirnica po kategorijama i podkategorijama SA CHECKBOXOVIMA ovaj je!*/}
                      {/* {selectedIshrana ? ( */}
                      {/* <div className="my-4">
                        <div className="flex items-center space-x-1 mb-2">
                          <h3 className="text-xl font-semibold mb-0">
                            Spisak dostupnih namirnica
                          </h3>
                          <Tooltip text="Pregledajte dostupne namirnice i prilagodite svoj izbor." />
                        </div>

                        <div
                          className="bg-green-100 overflow-y-scroll"
                          style={{ maxHeight: "400px" }}
                        >
                          {Object.keys(grupisaneNamirnice).map((grupa) => (
                            <div key={grupa} className="mb-4">
                              <h3 className="text-lg font-semibold">{grupa}</h3>
                              {Object.keys(grupisaneNamirnice[grupa]).map(
                                (podtip) => (
                                  <div key={podtip} className="ml-4 mb-2">
                                    <h4 className="text-md font-medium">
                                      {podtip}
                                    </h4>
                                    <div className="ml-6">
                                      {grupisaneNamirnice[grupa][podtip].map(
                                        (namirnica) => (
                                          <div
                                            key={namirnica._id}
                                            className="flex items-center mb-1"
                                          >
                                            <input
                                              type="checkbox"
                                              value={namirnica._id}
                                              checked={odabraneNamirnice?.includes(
                                                namirnica._id
                                              )}
                                              onChange={handleNamirnicaChange}
                                              className="mr-2"
                                              disabled={
                                                disabledNamirnice.includes(
                                                  namirnica._id
                                                ) ||
                                                !ishrane
                                                  .find(
                                                    (ishrana) =>
                                                      ishrana._id ===
                                                      selectedIshrana
                                                  )
                                                  ?.namirnice.includes(
                                                    namirnica._id
                                                  )
                                              } // Disable checkbox ako namirnica nije deo izabrane ishrane ili cilja
                                            />
                                            <label>
                                              {namirnica.naziv}{" "}
                                              {namirnica.alergen
                                                ? "(Alergen)"
                                                : namirnica.gluten
                                                ? "(Sadrži Gluten)"
                                                : namirnica.laktoza
                                                ? "(Sadrži Laktozu)"
                                                : ""}
                                            </label>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          ))}
                        </div>
                      </div> */}

                      {/* TEST - OK 1 */}
                      {/* <div className="my-4">
                        <div className="flex items-center space-x-1 mb-2">
                          <h3 className="text-xl font-semibold mb-0">
                            Spisak dostupnih namirnica
                          </h3>
                          <Tooltip text="Pregledajte dostupne namirnice i prilagodite svoj izbor." />
                        </div>

                        <div
                          className="overflow-y-scroll"
                          style={{ maxHeight: "400px" }}
                        >
                          <div className="grid grid-cols-8 gap-2">
                            {Object.keys(grupisaneNamirnice).map((grupa) => (
                              <div key={grupa} className="mb-4">
                                <h3 className="text-lg font-semibold">
                                  {grupa}
                                </h3>
                                {Object.keys(grupisaneNamirnice[grupa]).map(
                                  (podtip) => (
                                    <div key={podtip} className="ml-4 mb-2">
                                      <h4 className="text-md font-medium">
                                        {podtip}
                                      </h4>
                                      <div className="ml-6">
                                        {grupisaneNamirnice[grupa][podtip].map(
                                          (namirnica) => (
                                            <div
                                              key={namirnica._id}
                                              className="flex items-center mb-1"
                                            >
                                              <input
                                                type="checkbox"
                                                value={namirnica._id}
                                                checked={odabraneNamirnice?.includes(
                                                  namirnica._id
                                                )}
                                                onChange={handleNamirnicaChange}
                                                className="mr-2"
                                                disabled={
                                                  disabledNamirnice.includes(
                                                    namirnica._id
                                                  ) ||
                                                  !ishrane
                                                    .find(
                                                      (ishrana) =>
                                                        ishrana._id ===
                                                        selectedIshrana
                                                    )
                                                    ?.namirnice.includes(
                                                      namirnica._id
                                                    )
                                                }
                                              />
                                              <label>
                                                {namirnica.naziv}{" "}
                                                {namirnica.alergen
                                                  ? "(Alergen)"
                                                  : namirnica.gluten
                                                  ? "(Sadrži Gluten)"
                                                  : namirnica.laktoza
                                                  ? "(Sadrži Laktozu)"
                                                  : ""}
                                              </label>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div> */}

                      {/* TEST - 2 OK */}
                      {/* <div className="my-4">
                        <div className="flex items-center space-x-1 mb-2">
                          <h3 className="text-xl font-semibold mb-0">
                            Spisak dostupnih namirnica
                          </h3>
                          <Tooltip text="Pregledajte dostupne namirnice i prilagodite svoj izbor." />
                        </div>

                        <div
                          className="bg-green-100 overflow-y-scroll"
                          style={{ maxHeight: "450px" }}
                        >
                          <div className="grid grid-cols-8 gap-2">
                            {Object.keys(grupisaneNamirnice).map(
                              (grupa, index) => (
                                <div
                                  key={grupa}
                                  className={`mb-4 p-2 rounded-lg bg-color-${
                                    index % 8
                                  }`}
                                  style={{
                                    backgroundColor: `hsl(${
                                      index * 45
                                    }, 70%, 80%)`,
                                  }}
                                >
                                  <img
                                    src={`/images/${grupa.toLowerCase()}.png`}
                                    alt={grupa}
                                    className="w-full h-20 object-cover rounded-md mb-2"
                                  />
                                  <h3 className="text-lg font-semibold text-center">
                                    {grupa}
                                  </h3>
                                  {Object.keys(grupisaneNamirnice[grupa]).map(
                                    (podtip) => (
                                      <div key={podtip} className="ml-4 mb-2">
                                        <h4 className="text-md font-medium">
                                          {podtip}
                                        </h4>
                                        <div className="ml-6">
                                          {grupisaneNamirnice[grupa][
                                            podtip
                                          ].map((namirnica) => (
                                            <div
                                              key={namirnica._id}
                                              className="flex items-center mb-1"
                                            >
                                              <input
                                                type="checkbox"
                                                value={namirnica._id}
                                                checked={odabraneNamirnice?.includes(
                                                  namirnica._id
                                                )}
                                                onChange={handleNamirnicaChange}
                                                className="mr-2"
                                                disabled={
                                                  disabledNamirnice.includes(
                                                    namirnica._id
                                                  ) ||
                                                  !ishrane
                                                    .find(
                                                      (ishrana) =>
                                                        ishrana._id ===
                                                        selectedIshrana
                                                    )
                                                    ?.namirnice.includes(
                                                      namirnica._id
                                                    )
                                                }
                                              />
                                              <label>
                                                {namirnica.naziv}{" "}
                                                {namirnica.alergen
                                                  ? "(Alergen)"
                                                  : namirnica.gluten
                                                  ? "(Sadrži Gluten)"
                                                  : namirnica.laktoza
                                                  ? "(Sadrži Laktozu)"
                                                  : ""}
                                              </label>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div> */}

                      {/* TEST - 3 OK */}
                      <div className="my-4">
                        <div className="flex items-center space-x-1 mb-2">
                          <h3 className="text-xl font-semibold mb-0">
                            Spisak dostupnih namirnica
                          </h3>
                          <Tooltip text="Pregledajte dostupne namirnice i prilagodite svoj izbor." />
                        </div>

                        <div
                          className="overflow-y-scroll"
                          style={{ maxHeight: "450px" }}
                        >
                          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-2">
                            {Object.keys(grupisaneNamirnice).map(
                              (grupa, index) => (
                                // <></>
                                <div
                                  key={grupa}
                                  className={`mb-4 p-2 rounded-lg bg-color-${
                                    index % 8
                                  }`}
                                  style={{
                                    backgroundColor: `hsl(${index * 45}, 70%, ${
                                      index % 2 === 0 ? 80 : 90
                                    }%)`,
                                  }}
                                >
                                  <img
                                    // src={`/images/${grupa.toLowerCase()}.png`}
                                    src={`${
                                      process.env.PUBLIC_URL
                                    }/img/namirnice/${grupa.toLowerCase()}.jpg`}
                                    alt={grupa}
                                    className="w-full h-40 object-cover rounded-md mb-2"
                                  />
                                  <h3 className="text-lg font-semibold text-center">
                                    {grupa}
                                  </h3>
                                  {Object.keys(grupisaneNamirnice[grupa]).map(
                                    (podtip, podtipIndex) => (
                                      <div
                                        key={podtip}
                                        className={`mb-2 p-2 rounded-lg`}
                                        style={{
                                          backgroundColor: `hsl(${
                                            index * 45
                                          }, 70%, ${
                                            podtipIndex % 2 === 0 ? 90 : 80
                                          }%)`,
                                        }}
                                      >
                                        <h4 className="text-md font-medium underline">
                                          {podtip}
                                        </h4>
                                        <div className="ml-6">
                                          {grupisaneNamirnice[grupa][
                                            podtip
                                          ].map((namirnica) => (
                                            <div
                                              key={namirnica._id}
                                              className="flex items-center mb-1"
                                            >
                                              <input
                                                type="checkbox"
                                                value={namirnica._id}
                                                checked={odabraneNamirnice?.includes(
                                                  namirnica._id
                                                )}
                                                onChange={handleNamirnicaChange}
                                                className="mr-2"
                                                disabled={
                                                  disabledNamirnice.includes(
                                                    namirnica._id
                                                  ) ||
                                                  !ishrane
                                                    .find(
                                                      (ishrana) =>
                                                        ishrana._id ===
                                                        selectedIshrana
                                                    )
                                                    ?.namirnice.includes(
                                                      namirnica._id
                                                    )
                                                }
                                              />
                                              <label>
                                                {namirnica.naziv}{" "}
                                                {namirnica.alergen
                                                  ? "(Alergen)"
                                                  : namirnica.gluten
                                                  ? "(Sadrži Gluten)"
                                                  : namirnica.laktoza
                                                  ? "(Sadrži Laktozu)"
                                                  : ""}
                                              </label>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ) : (
                        <p>Izaberite ishranu</p>
                      )} */}

                      {/* Tree i prikaz svih naminica i onih kojih ne pripadaju su DISABLED a koje pripadaju su ENABLED i iz skupa izbacuje sve specificne ciljeve */}
                      {/* {selectedIshrana ? (
                        <div className="mb-4">
                          <h3 className="text-xl font-semibold mb-2">Odabir Namirnica</h3>
                          <div className="overflow-y-scroll" style={{ maxHeight: '400px' }}>
                            {Object.keys(grupisaneNamirnice).map((grupa) => (
                              <div key={grupa} className="mb-4">
                                <h3 className="text-lg font-semibold">{grupa}</h3>
                                {Object.keys(grupisaneNamirnice[grupa]).map((podtip) => (
                                  <div key={podtip} className="ml-4 mb-2">
                                    <h4 className="text-md font-medium">{podtip}</h4>
                                    <div className="ml-6">
                                      {grupisaneNamirnice[grupa][podtip].map((namirnica) => (
                                        <div key={namirnica._id} className="flex items-center mb-1">
                                          <input
                                            type="checkbox"
                                            value={namirnica._id}
                                            checked={odabraneNamirnice.includes(namirnica._id)}
                                            onChange={handleNamirnicaChange}
                                            className="mr-2"
                                            disabled={
                                              disabledNamirnice.includes(namirnica._id) ||
                                              !ishrane
                                                .find((ishrana) => ishrana._id === selectedIshrana)?.namirnice.includes(namirnica._id)
                                            } // Disable checkbox ako namirnica nije deo izabrane ishrane ili cilja
                                          />
                                          <label>
                                            {namirnica.naziv}{' '}
                                            {namirnica.alergen
                                              ? '(Alergen)'
                                              : namirnica.gluten
                                              ? '(Sadrži Gluten)'
                                              : namirnica.laktoza
                                              ? '(Sadrži Laktozu)'
                                              : ''}
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <p>Izaberite ishranu</p>
                      )} */}

                      {/* Tree i prikaz svih naminica i onih kojih ne pripadaju su DISABLED a koje pripadaju su ENABLED */}
                      {/* {selectedIshrana ? (
                        <div className="mb-4">
                          <h3 className="text-xl font-semibold mb-2">Odabir Namirnica</h3>
                          <div className="overflow-y-scroll" style={{ maxHeight: '400px' }}>
                            {Object.keys(grupisaneNamirnice).map((grupa) => (
                              <div key={grupa} className="mb-4">
                                <h3 className="text-lg font-semibold">{grupa}</h3>
                                {Object.keys(grupisaneNamirnice[grupa]).map((podtip) => (
                                  <div key={podtip} className="ml-4 mb-2">
                                    <h4 className="text-md font-medium">{podtip}</h4>
                                    <div className="ml-6">
                                      {grupisaneNamirnice[grupa][podtip].map((namirnica) => (
                                        <div key={namirnica._id} className="flex items-center mb-1">
                                          <input
                                            type="checkbox"
                                            value={namirnica._id}
                                            checked={odabraneNamirnice.includes(namirnica._id)}
                                            onChange={handleNamirnicaChange}
                                            className="mr-2"
                                            disabled={
                                              !ishrane
                                                .find((ishrana) => ishrana._id === selectedIshrana)?.namirnice.includes(namirnica._id)
                                            }
                                          />
                                          <label>
                                            {namirnica.naziv}{' '}
                                            {namirnica.alergen
                                              ? '(Alergen)'
                                              : namirnica.gluten
                                              ? '(Sadrži Gluten)'
                                              : namirnica.laktoza
                                              ? '(Sadrži Laktozu)'
                                              : ''}
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <p>Izaberite ishranu</p>
                      )} */}

                      {/* Tabela i prikaz samo onih naminica koje pripadaju ishrani  DODAJ DA SE VIDE OSTALI CHECKBOXOVI I DA SU ONI DIABLED */}
                      {/* {grupisaneNamirnice && Object.keys(grupisaneNamirnice).length > 0 ? (
                          <div className="mb-4">
                              <h3 className="text-xl font-semibold mb-2">Odabir Namirnica</h3>
                              <div className="overflow-y-scroll" style={{ maxHeight: "450px" }}>
                                  <table className="table-auto bg-white border-collapse border border-gray-400 w-full">
                                      <thead className="bg-gray-100 sticky top-0">
                                          <tr>
                                              <th className="border border-gray-300 p-2 text-left">Kategorija</th>
                                              <th className="border border-gray-300 p-2 text-left">Potkategorija</th>
                                              <th className="border border-gray-300 p-2 text-left">Namirnice</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {Object.keys(grupisaneNamirnice).map((grupa) => (
                                              <React.Fragment key={grupa}>
                                                  {Object.keys(grupisaneNamirnice[grupa]).map((podtip, index) => (
                                                      <tr key={podtip}>
                                                          {index === 0 && (
                                                              <td className="border border-gray-300 p-2" rowSpan={Object.keys(grupisaneNamirnice[grupa]).length}>
                                                                  {grupa}
                                                              </td>
                                                          )}
                                                          <td className="border border-gray-300 p-2">{podtip}</td>
                                                          <td className="border border-gray-300 p-2">
                                                              <div className="flex flex-col">
                                                                  {grupisaneNamirnice[grupa][podtip].map((namirnica) => (
                                                                      <div key={namirnica._id} className="flex items-center mb-1">
                                                                          <input
                                                                              type="checkbox"
                                                                              value={namirnica.naziv} // Koristimo ime namirnice umesto ID-ja
                                                                              checked={odabraneNamirnice.includes(namirnica.naziv)} // Provera da li je ime u odabranim namirnicama
                                                                              onChange={handleNamirnicaChange}
                                                                              className="mr-2"
                                                                          />
                                                                          <label>
                                                                              {namirnica.naziv}{" "}
                                                                              {namirnica.alergen ? "(Alergen)" : namirnica.gluten ? "(Sadrži Gluten)" : namirnica.laktoza ? "(Sadrži Laktozu)" : ""}
                                                                          </label>
                                                                      </div>
                                                                  ))}
                                                              </div>
                                                          </td>
                                                      </tr>
                                                  ))}
                                              </React.Fragment>
                                          ))}
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      ) : (
                          <p>Izaberite ishranu</p>
                      )} */}

                      <br />
                      {/* <br/> */}
                    </div>
                  </>
                )}
                {selectedDiv === "PlanoviIshrane" && (
                  <>
                    <div className="block w-full rounded bg-white p-4 border-gray-300">
                      {/* {mojeIshrane} */}
                      <div className="App">
                        {/* <form className="formStyle" onSubmit={submitImage}>
                          <h4>Otpremi PDF</h4>
                          <br />
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Naslov"
                            required
                            onChange={(e) => setTitle(e.target.value)}
                          />
                          <br />
                          <input
                            type="file"
                            className="form-control"
                            accept="application/pdf"
                            required
                            onChange={(e) => setFile(e.target.files[0])}
                          />
                          <br />
                          <button className="btn btn-primary" type="submit">
                            Otpremi
                          </button>
                        </form> */}

                        <div className="uploaded">
                          <h4 className="block text-lg font-medium leading-6 text-gray-900">
                            Otpremljeni izveštaji:
                          </h4>
                          {allImage && allImage.length > 0 ? (
                            <div className="overflow-x-auto">
                              <table className="min-w-full border-collapse border border-gray-300">
                                <thead className="bg-gray-100">
                                  <tr>
                                    <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                                      Datum kreiranja izveštaja
                                    </th>
                                    <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                                      Primarni cilj
                                    </th>
                                    <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                                      Datum početka ishrane
                                    </th>
                                    <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                                      Datum završetka ishrane
                                    </th>
                                    <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                                      Broj dana ishrane
                                    </th>
                                    <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                                      Status
                                    </th>
                                    <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                                      Akcije
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="bg-white">
                                  {allImage
                                    .slice()
                                    .reverse()
                                    .map((data) => (
                                      <tr key={data._id}>
                                        <td className="border-b border-r px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                                          {data?.datumKreir} -{" "}
                                          {data?.vreme
                                            ? data?.vreme.slice(0, 5)
                                            : ""}
                                        </td>
                                        <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                                          {data?.title} {/* primarni cilj */}
                                        </td>
                                        <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                                          {data?.datumPoc} {/* dat poc */}
                                        </td>
                                        <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                                          {data?.datumKraj} {/* dat kraja */}
                                        </td>
                                        <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                                          {data?.tip} {/* tip */}
                                        </td>
                                        <td
                                          className={`border-b border-r px-4 py-2 text-sm text-gray-900 ${
                                            data?.status === "Aktivan"
                                              ? "bg-green-500"
                                              : "bg-red-500"
                                          }`}
                                        >
                                          {data?.status} {/* status */}
                                        </td>

                                        <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                                          <div className="flex items-center space-x-4">
                                            <button
                                              className="text-blue-600 hover:text-blue-800"
                                              onClick={() => showPdf(data.pdf)} // Open PDF in popup
                                            >
                                              <EyeIcon
                                                className="h-5 w-5"
                                                aria-hidden="true"
                                              />
                                            </button>
                                            <div className="border-l h-5" />{" "}
                                            {/* Horizontal line */}
                                            <button
                                              className="text-blue-600 hover:text-blue-800"
                                              onClick={() =>
                                                downloadPdf(data.pdf)
                                              }
                                            >
                                              <ArrowDownTrayIcon
                                                className="h-5 w-5"
                                                aria-hidden="true"
                                              />
                                            </button>
                                            <div className="border-l h-5" />{" "}
                                            {/* Horizontal line */}
                                            <button
                                              onClick={() => preiewData(data)}
                                              className="text-blue-600 hover:text-blue-800"
                                            >
                                              <UserIcon
                                                className="h-5 w-5"
                                                aria-hidden="true"
                                              />
                                            </button>
                                            <div className="border-l h-5" />{" "}
                                            {/* Horizontal line */}
                                            <button
                                              className="text-red-600 hover:text-red-800"
                                              onClick={() =>
                                                deletePdf(data._id, data.pdf)
                                              }
                                            >
                                              <TrashIcon
                                                className="h-5 w-5"
                                                aria-hidden="true"
                                              />
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                              <br />
                              {/* <br/> */}
                            </div>
                          ) : (
                            <p>Nema otpremljenih izveštaja.</p>
                          )}
                        </div>

                        {/* Modal for PDF Preview */}
                        {isModalOpenPdf && (
                          <div
                            className="fixed inset-0 flex items-center justify-center z-50 bg-gray-800 bg-opacity-75"
                            onClick={closeModalPdf} // Close modal when clicking on the background
                          >
                            <div
                              className="bg-white p-6 rounded-lg shadow-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto"
                              onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking inside the modal
                            >
                              <div className="flex justify-between items-center">
                                {/* Show PDF Title instead of "Preview PDF" */}
                                <h2 className="text-lg font-semibold">
                                  {title}
                                </h2>
                                <div className="flex space-x-2">
                                  {/* Download button similar to close button */}
                                  <button
                                    className="text-blue-600 hover:text-blue-800 border border-blue-600 px-3 py-1 rounded-md"
                                    onClick={() =>
                                      downloadPdf(pdfFile.split("/").pop())
                                    }
                                  >
                                    Preuzmi PDF
                                  </button>
                                  <button
                                    className="text-red-600 hover:text-red-800 border border-red-600 px-3 py-1 rounded-md"
                                    onClick={closeModalPdf}
                                  >
                                    Zatvori
                                  </button>
                                </div>
                              </div>
                              <div className="mt-4 flex flex-col items-center space-y-4">
                                <Document
                                  file={pdfFile}
                                  onLoadSuccess={onDocumentLoadSuccess}
                                >
                                  {Array.from(
                                    new Array(numPages),
                                    (el, index) => (
                                      <div
                                        key={`page_${index + 1}`}
                                        className="flex justify-center p-4 bg-white shadow-md border border-gray-300 rounded-lg"
                                        style={{ marginBottom: "1px" }} // Minimal margin to avoid visual gaps
                                      >
                                        <Page
                                          pageNumber={index + 1}
                                          width={
                                            window.innerWidth < 640 ? 300 : 600
                                          }
                                          className="p-0 m-0"
                                          renderAnnotationLayer={false}
                                          renderTextLayer={false}
                                          style={{ overflow: "hidden" }} // Ensure no overflow
                                        />
                                      </div>
                                    )
                                  )}
                                </Document>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* end */}

                      {showPreview && klijentData && (
                        <div
                          className="fixed inset-0 flex items-center justify-center z-50 bg-gray-800 bg-opacity-50 transition-opacity duration-300 ease-in-out"
                          onClick={() => setShowPreview(false)} // Close the modal when clicking outside
                        >
                          <div
                            className="bg-white p-6 rounded-lg shadow-lg w-full sm:max-w-md md:max-w-lg max-h-[80vh] overflow-y-auto transform transition-all duration-500 ease-in-out"
                            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
                          >
                            <div className="flex justify-between items-center mb-6 border-b pb-4">
                              <h4 className="text-xl font-semibold text-gray-800">
                                Podaci o klijentu
                              </h4>
                              <button
                                onClick={() => setShowPreview(false)} // Close modal
                                className="text-red-600 hover:text-red-800 border border-red-600 px-4 py-2 rounded-lg font-semibold transition-all duration-300"
                              >
                                Zatvori
                              </button>
                            </div>
                            <div className="space-y-4">
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Težina:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.tez
                                    ? `${klijentData?.tez} Kg`
                                    : "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Visina:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.visina
                                    ? `${klijentData?.visina} Cm`
                                    : "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Primarni cilj:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.primCilj || "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Motivacija:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.motiv || "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Nivo aktivnosti:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {getNivoFizickeAktivnosti(
                                    klijentData?.nivoAkt
                                  ) || "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Datum rođenja:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.datumRodj || "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  TDEE:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.tdee
                                    ? `${klijentData?.tdee} kcal`
                                    : "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  BMI:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.bmi || "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  BMR:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.bmrValue
                                    ? `${klijentData?.bmrValue} kcal`
                                    : "Nema"}
                                </p>
                              </div>
                              {/* <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Vrsta fizičke aktivnosti:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.vrstaFiz?.join(", ") || "Nema"}
                                </p>
                              </div> */}
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Vrsta fizičke aktivnosti:
                                </p>
                                <p
                                  className="text-sm text-gray-800"
                                  title={
                                    klijentData?.vrstaFiz?.join(", ").length >
                                    25
                                      ? klijentData?.vrstaFiz?.join(", ")
                                      : ""
                                  }
                                >
                                  {klijentData?.vrstaFiz?.join(", ") || "Nema"}
                                </p>
                              </div>

                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Struk:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.struk
                                    ? `${klijentData?.struk} Cm`
                                    : "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Kuk:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.kuk
                                    ? `${klijentData?.kuk} Cm`
                                    : "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Vrat:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.vrat
                                    ? `${klijentData?.vrat} Cm`
                                    : "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Krvna grupa:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.krv || "Nema"}
                                </p>
                              </div>
                              {/* <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">Dijagnoza:</p>
                                <p className="text-sm text-gray-800">{klijentData?.dijag || "Nema"}</p>
                              </div> */}
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Alergije:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.alerg || "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Ishrana:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.ish || "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Broj obroka:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {capitalizeFirstLetter(klijentData?.obr) ||
                                    "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Pusenje:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.pus || "Nema"}
                                </p>
                              </div>
                              <div className="flex justify-between">
                                <p className="text-sm font-semibold text-gray-600">
                                  Alkohol:
                                </p>
                                <p className="text-sm text-gray-800">
                                  {klijentData?.alk || "Nema"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Tabovi */}
            {/* {tabovi} */}

            <br />

            {isModalOpen && (
              <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
                <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
                  <div className="mt-3 text-center">
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                      <svg
                        className="h-6 w-6 text-yellow-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                      Upoznorenje
                    </h3>
                    <div className="mt-2 px-7 py-3">
                      <p className="text-sm text-gray-500">
                        Da li ste sigurni da želite izbrisati odbaranog
                        korisnika
                      </p>
                    </div>
                    <div className="items-center px-4 py-3">
                      <button
                        onClick={handleConfirm}
                        className="px-4 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                      >
                        Da
                      </button>
                      <button
                        onClick={closeModal}
                        className="mt-3 px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                      >
                        Ne
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isModalOpenIzmena && (
              <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
                <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
                  <div className="mt-3 text-center">
                    {!hasIzmena ? (
                      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                        <svg
                          className="h-6 w-6 text-yellow-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                          />
                        </svg>
                      </div>
                    ) : (
                      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100">
                        <svg
                          className="h-6 w-6 text-blue-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </div>
                    )}

                    <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                      Obaveštenje
                    </h3>

                    <div className="mt-2 px-7 py-3">
                      <p className="text-sm text-gray-500">
                        {!hasIzmena
                          ? "Da li ste sigurni da želite izgenerisati ishranu?"
                          : "Uspešno ste izmenili  korisničke podatke"}
                      </p>
                    </div>

                    <div className="items-center px-4 py-3">
                      {!hasIzmena ? (
                        <>
                          <button
                            onClick={handleConfirmIzmena}
                            className="px-4 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                          >
                            Da
                          </button>
                          <button
                            onClick={closeModalIzmena}
                            className="mt-3 px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                          >
                            Ne
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={closeModalIzmena}
                          className="px-4 py-2 bg-blue-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
                        >
                          Uredu
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </main>

        {/* Modal za verifikaciju ODKOMENTARISI OBAVEZNO*/}
        {isVerified === false ? (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
            <div className="relative p-3 border w-96 shadow-lg rounded bg-white z-60">
              <div className="mt-3 text-center">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                  <svg
                    className="h-6 w-6 text-yellow-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    />
                  </svg>
                </div>
                <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                  Upozorenje
                </h3>
                <div className="mt-2 px-7 py-3">
                  <p className="text-sm text-gray-500">
                    Poštovani, morate verifikovati vaš profil da biste mogli
                    koristiti aplikaciju. Na vaš mail vam je poslato uputstvo za
                    verifikaciju. Ako je verifikacija istekla ili je ne možete
                    pronaći u email-u možete je poslati ponovo.
                  </p>
                  <button
                    type="button"
                    onClick={sendPotvrduPonovo}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 mt-2"
                    disabled={loading} // Onemogućava dugme dok traje zahtev
                  >
                    {loading ? "Šalje se..." : "Pošalji ponovo"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {/* Neophodne informacije modal */}
        {/* {wellcome == "0" ? (
          <div className="fixed inset-0 flex items-center justify-center z-70 bg-gray-500 bg-opacity-50">
            <div className="bg-white rounded-lg p-6 w-1/3">
              <h2 className="text-xl font-semibold mb-4">
                Neophodne informacije
              </h2>

              <div className="space-y-4">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Ime
                  </label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    value={name}
                    onChange={onNameChanged}
                    className="mt-1 block w-full rounded border py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div>

                <div>
                  <label
                    htmlFor="lastname"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Prezime
                  </label>
                  <input
                    type="text"
                    name="lastname"
                    id="lastname"
                    value={lastname}
                    onChange={onLastNameChanged}
                    className="mt-1 block w-full rounded border py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div>

                <div>
                  <label
                    htmlFor="datumRodjenja"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Datum rođenja korisnika
                  </label>
                  <input
                    type="date"
                    name="datumRodjenja"
                    id="datumRodjenja"
                    value={datumRodjenja}
                    onChange={onDatumRodjenjaChanged}
                    className="mt-1 block w-full rounded border py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div>

                <div>
                  <label
                    htmlFor="pol"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Pol
                  </label>
                  <select
                    name="pol"
                    id="pol"
                    value={pol}
                    onChange={onPolChanged}
                    className="block w-full rounded border py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  >
                    <option value="" disabled>
                      Izaberite opciju
                    </option>
                    <option value="zenski">Ženski</option>
                    <option value="muski">Muški</option>
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="tezina"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Trenutna težina
                  </label>
                  <input
                    type="text"
                    name="tezina"
                    id="tezina"
                    value={tezina}
                    onChange={onTezinaChanged}
                    className="mt-1 block w-full rounded border py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div>

                <div>
                  <label
                    htmlFor="visina"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Visina
                  </label>
                  <input
                    type="text"
                    name="visina"
                    id="visina"
                    value={visina}
                    onChange={onVisinaChanged}
                    className="mt-1 block w-full rounded border py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div className="mt-6 flex justify-end space-x-4">
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )} */}

        {wellcome == "0" ? (
          <div className="fixed inset-0 flex items-center justify-center z-20 bg-gray-500 bg-opacity-50">
            <div className="bg-white rounded-lg p-4 w-full sm:w-1/3 md:w-1/3 lg:w-1/3">
              <h2 className="text-xl font-semibold mb-4">
                Neophodne informacije za profil
              </h2>

              <div className="space-y-2">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Ime
                  </label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    value={name}
                    onChange={onNameChanged}
                    className="mt-1 block w-full rounded border py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div>
                {errors.name && (
                  <span className="text-red-500 text-sm">{errors.name}</span>
                )}

                <div>
                  <label
                    htmlFor="lastname"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Prezime
                  </label>
                  <input
                    type="text"
                    name="lastname"
                    id="lastname"
                    value={lastname}
                    onChange={onLastNameChanged}
                    className="mt-1 block w-full rounded border py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div>
                {errors.lastname && (
                  <span className="text-red-500 text-sm">
                    {errors.lastname}
                  </span>
                )}

                <div>
                  <label
                    htmlFor="datumRodjenja"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Datum rođenja korisnika
                  </label>
                  <input
                    type="date"
                    name="datumRodjenja"
                    id="datumRodjenja"
                    value={datumRodjenja}
                    onChange={onDatumRodjenjaChanged}
                    className="mt-1 block w-full rounded border py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div>
                {errors.datumRodjenja && (
                  <span className="text-red-500 text-sm">
                    {errors.datumRodjenja}
                  </span>
                )}

                <div>
                  <label
                    htmlFor="pol"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Pol
                  </label>
                  <select
                    name="pol"
                    id="pol"
                    value={pol}
                    onChange={onPolChanged}
                    className="block w-full rounded border py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  >
                    <option value="" disabled>
                      Izaberite opciju
                    </option>
                    <option value="zenski">Ženski</option>
                    <option value="muski">Muški</option>
                  </select>
                </div>
                {errors.pol && (
                  <span className="text-red-500 text-sm">{errors.pol}</span>
                )}

                <div>
                  <label
                    htmlFor="tezina"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Trenutna težina
                  </label>
                  <input
                    type="text"
                    name="tezina"
                    id="tezina"
                    value={tezina}
                    onChange={onTezinaChanged}
                    className="mt-1 block w-full rounded border py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div>
                {errors.tezina && (
                  <span className="text-red-500 text-sm">{errors.tezina}</span>
                )}

                <div>
                  <label
                    htmlFor="visina"
                    className="block text-lg font-medium leading-6 text-gray-900"
                  >
                    Visina
                  </label>
                  <input
                    type="text"
                    name="visina"
                    id="visina"
                    value={visina}
                    onChange={onVisinaChanged}
                    className="mt-1 block w-full rounded border py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                  />
                </div>
                {errors.visina && (
                  <span className="text-red-500 text-sm">{errors.visina}</span>
                )}
              </div>

              <div className="mt-4 flex justify-end space-x-4">
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Sačuvaj
                </button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {/* <div
          style={{
            border: "1px solid #e0e0e0",
            borderRadius: "50%",
            zIndex: 2,
            position: "fixed",
            bottom: "-5px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "100px",
            height: "100px",
            backgroundColor: highlighted ? "#f1f1f1" : "white",
            boxShadow: highlighted ? "0px 8px 15px rgba(0, 0, 0, 0.1)" : "none",
            transition: "all 0.3s ease",
          }}
        ></div> */}
      </div>
      <br />
      <br />
      <br />
    </>
  );
};
export default EditUserForm;

function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.onerror = (error) => reject(error);
  });
}

// let canSave
// if (password) {
//     canSave = [roles.length, validUsername, validPassword].every(Boolean) && !isLoading
// } else {
//     canSave = [roles.length, validUsername].every(Boolean) && !isLoading
// }

//TailwindConetent
// const tailwindContent = (
//     <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
//         <form className="bg-white shadow-sm ring-2 ring-gray-900/5 sm:rounded md:col-span-3">
//             <div className="px-3 py-3 sm:p-3">
//                 <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">

//                     <div className="sm:col-span-3">
//                         <label htmlFor="last-name" className="block text-lg font-medium leading-6 text-gray-900">Ime</label>
//                         <div className="mt-1">
//                             <input readOnly type="text" name="last-name" id="last-name" value={name} onChange={onNameChanged} autoComplete="family-name" className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6" />
//                         </div>
//                     </div>

//                     <div className="sm:col-span-3">
//                         <label htmlFor="last-name" className="block text-lg font-medium leading-6 text-gray-900">Prezime</label>
//                         <div className="mt-1">
//                             <input readOnly type="text" name="last-name" id="last-name" value={lastName} onChange={onLastNameChanged} autoComplete="family-name" className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6" />
//                         </div>
//                     </div>

//                     <div className="sm:col-span-4">
//                         <label htmlFor="username" className="block text-lg font-medium leading-6 text-gray-900">Korisničko ime</label>
//                         <div className="mt-1">
//                             <input type="text" name="username" id="username" value={username} onChange={onUsernameChanged} autoComplete="username" className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6" />
//                         </div>
//                     </div>

//                     <div className="sm:col-span-3">
//                         <label htmlFor="password" className="block text-lg font-medium leading-6 text-gray-900">Lozinka</label>
//                         <div className="mt-1">
//                             <input type="password" name="password" id="password" value={password} onChange={onPasswordChanged} autoComplete="password" className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6" />
//                         </div>
//                     </div>

//                     <div className="col-span-full">
//                         <label htmlFor="street-address" className="block text-lg font-medium leading-6 text-gray-900"> Adresa</label>
//                         <div className="mt-1">
//                             <input type="text" name="street-address" id="street-address" value={address} onChange={onAddressChanged} autoComplete="street-address" className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6" />
//                         </div>
//                     </div>

//                     <div className="col-span-full">
//                         <label htmlFor="phone" className="block text-lg font-medium leading-6 text-gray-900"> Telefon</label>
//                         <div className="mt-1">
//                             <input type="number" name="phone" id="phone" value={phone} onChange={onPhoneChanged} autoComplete="phone" className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6" />
//                         </div>
//                     </div>

//                     <div className="sm:col-span-4">
//                         <label htmlFor="role" className="block text-lg font-medium leading-6 text-gray-900">Uloga</label>
//                         <div className="mt-1">
//                             {/* Throws error because value is not scalar... */}
//                             <select id="role" name="role" autoComplete="role" value={roles} onChange={onRolesChanged} className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:max-w-xs sm:text-sm sm:leading-6" >
//                                 {options}
//                             </select>
//                         </div>
//                     </div>

//                 </div>
//             </div>

//             <div className="flex items-center justify-end gap-x-2 border-t border-gray-900/10 px-2 py-2 sm:px-2">
//                 <button type="submit" onClick={openModal} className="rounded bg-red-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">Izbriši</button>
//                 <button type="submit" onClick={openModalIzmena} className="rounded bg-blue-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">Izmeni</button>
//             </div>
//         </form>
//     </div>
// )

{
  /* <div>
          <h3 className="text-sm font-medium leading-6 text-gray-900 whitespace-nowrap">Alergeni na hranu</h3>
          <select
            id="algiNaHran"
            name="algiNaHran"
            value={algiNaHran}
            onChange={handlAalgiNaHranChange}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
          >
            <option value="" defaultChecked>Izaberite</option>
            <option value="2 do 4">2 - 4 čaše</option>
            <option value="5 čaša nedeljno">5 čaša nedeljno</option>
          </select>
        </div> */
}
